// Auto-generated by vibesites deploy pipeline. Do not edit manually.
// Generated: 2026-08-26T18:20:34.774Z
// Property: Fitzroy Grove (ID: 6767906449167553)
// Collections: 37 amenities, 7 floorplans (live), 50 photos, 75 POIs, 2 reviews, 6 office hours, 1 special offers (live)
// Live collections (fetched at runtime): floorplans, special_offers

export const property = {
  "multihub_agency_id": "5680529164730368",
  "multihub_company_id": "5726763346821120",
  "multihub_property_id": "6767906449167553",
  "property_external_id": "2wwgghc",
  "property_zillow_url": "https://www.zillow.com/b/2951-s-fitzroy-pl-rogers-ar-CkBB3V/",
  "property_apartments_url": "https://www.apartments.com/fitzroy-grove-rogers-ar/2wwgghc/",
  "property_google_business_url": "https://www.google.com/maps/place/Fitzroy+Grove/@36.2882519,-94.1551354,955m/data=!3m2!1e3!4b1!4m6!3m5!1s0x87c911fc924f108f:0x55947be2c08fd150!8m2!3d36.2882519!4d-94.1551354!16s%2Fg%2F11rsh5cqq4!5m1!1e2?entry=ttu&g_ep=EgoyMDI2MDcxNS4wIKXMDSoASAFQAw%3D%3D",
  "property_linkedin_url": null,
  "property_hubspot_id": "56463087370",
  "property_crm_software": null,
  "property_pm_software": null,
  "property_pm_info": null,
  "property_status": null,
  "property_slug": "fitzroy-grove",
  "property_name": "Fitzroy Grove",
  "property_website_url": "https://www.livefitzroygrove.com/",
  "property_domain": "https://www.fitzroygroveapartments.com",
  "property_address": "2950 S Fitzroy Pl",
  "property_full_address": "2950 S Fitzroy Pl, Rogers, AR 72758",
  "property_address_1": "2950 S Fitzroy Pl",
  "property_address_2": null,
  "property_address_city": "Rogers",
  "property_address_state": "AR",
  "property_address_zip_full": null,
  "property_address_zip": "72758",
  "property_address_country": "US",
  "property_address_county": "Benton County",
  "property_neighborhood_address": "Outer Central Benton County",
  "property_address_latitude": "36.28830640122377",
  "property_address_longitude": "-94.1550053147615",
  "property_email": null,
  "property_phone": "(855) 491-3365",
  "property_call_tracking_phone": null,
  "property_company_name": "Weidner Apartment Homes",
  "property_company_url": "https://www.weidner.com/",
  "agency_contacts": null,
  "property_type": null,
  "property_short_description": "<p><strong>Resort-inspired living in Rogers’ Pinnacle Hills corridor.</strong> Explore polished studio to three-bedroom apartments with airy ceilings, granite finishes, in-home laundry, and everyday perks designed to make coming home feel effortless.</p>",
  "property_long_description": "<p><strong>Resort-inspired living in Rogers’ Pinnacle Hills corridor.</strong> At Fitzroy Grove, you’re close to the energy of Northwest Arkansas while coming home to polished spaces designed for everyday ease. Choose from studio, one-, two-, and three-bedroom <a href=\"/floor-plans\">apartment layouts</a> with granite countertops, designer cabinetry, stainless steel appliances, kitchen islands, oversized closets, in-home washer/dryer, keyless entry, and ceilings that add an open, airy feel.</p><p>Outside your door, the community gives you room to recharge, focus, and gather—from the <a href=\"/amenities\">resort-style pool</a> with poolside cabanas to a 24-hour health club, java bar, business center, putting green, bocce court, grilling stations, package center, private garages, and a pet-friendly setting with a dog park and grooming area.</p><p>Set just off I-49, Fitzroy Grove puts Pinnacle Hills Promenade, Walmart AMP, Topgolf, the Razorback Greenway, and the dining and shopping of Uptown Rogers within easy reach, with Bentonville, downtown Rogers, and major Northwest Arkansas employment hubs all a short drive away.</p>",
  "property_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167553/019f38c4-ba60-729c-8e19-39f9c9b96412.webp",
  "property_featured_image_media": {
    "alt_text": "Apartment community pool and lounge area with modern buildings in the background.",
    "public_id": "019f38c4-ba60-729c-8e19-39f9c9b96412",
    "storage_key": "property/6767906449167553/019f38c4-ba60-729c-8e19-39f9c9b96412.webp",
    "width": 3072,
    "height": 2048
  },
  "property_featured_video": null,
  "property_featured_video_media": null,
  "property_total_units": "250",
  "property_year_built": "2021",
  "property_year_renovated": null,
  "property_walk_score": "9",
  "property_transit_score": null,
  "property_business_hours_list": null,
  "property_current_occupancy": "100",
  "property_admin_fee": null,
  "property_application_fee": null,
  "property_fees_deposit_info": null,
  "property_ispetfriendly": true,
  "property_allows_cats": true,
  "property_allows_dogs": true,
  "property_upfront_pet_fee": "300",
  "property_pet_deposit": null,
  "property_monthly_pet_rent": "25",
  "property_max_pets": "2",
  "property_max_pet_weight_limit": null,
  "property_pet_restrictions": "<ul>\n<li>Pit Bull &amp; Pit Bull Mixes</li>\n<li>American Pit Bull Terrier</li>\n<li>American Staffordshire Terrier</li>\n<li>Wolf Hybrids</li>\n<li>Doberman Pinscher</li>\n<li>Saint Bernard</li>\n<li>American Bulldog</li>\n<li>Staffordshire Bull Terrier</li>\n<li>Rottweiler</li>\n<li>German Shepherd</li>\n<li>Chow Chow</li>\n<li>Great Dane</li>\n<li>Akita</li>\n</ul>",
  "property_pet_policy_description": "We allow cats and dogs. Maximum of 2 pets per household. Monthly pet rent is $25 per pet. One-time non-refundable pet fee is $300 per pet. No weight limit. Breed restrictions apply; certain breeds are prohibited.",
  "property_petpolicy_info": null,
  "property_online_leasing_url": null,
  "property_resident_portal_url": null,
  "property_apply_now_url": null,
  "property_community_amenities_list": null,
  "property_apartment_features_list": null,
  "property_primary_logo": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167553/019f38c4-c72c-7560-99ed-a28d1ae1c1bb.webp",
  "property_primary_logo_media": {
    "alt_text": "The Fitzroy Grove logo",
    "public_id": "019f38c4-c72c-7560-99ed-a28d1ae1c1bb",
    "storage_key": "property/6767906449167553/019f38c4-c72c-7560-99ed-a28d1ae1c1bb.webp",
    "width": 1080,
    "height": 1080
  },
  "property_secondary_logo": null,
  "property_secondary_logo_media": null,
  "property_icon": null,
  "property_icon_media": null,
  "property_fav_icon": null,
  "property_fav_icon_media": null,
  "property_mono_white_logo": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167553/019f38c5-53d0-754c-a22c-d0c0c0ff270e.webp",
  "property_mono_white_logo_media": {
    "alt_text": null,
    "public_id": "019f38c5-53d0-754c-a22c-d0c0c0ff270e",
    "storage_key": "property/6767906449167553/019f38c5-53d0-754c-a22c-d0c0c0ff270e.webp",
    "width": 1080,
    "height": 1080
  },
  "property_mono_black_logo": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167553/019ff651-9139-7228-8d32-e11b6d710c04.webp",
  "property_mono_black_logo_media": {
    "alt_text": "The Fitzroy Grove logo",
    "public_id": "019ff651-9139-7228-8d32-e11b6d710c04",
    "storage_key": "property/6767906449167553/019ff651-9139-7228-8d32-e11b6d710c04.webp",
    "width": 500,
    "height": 221
  },
  "property_company_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/company/5726763346821120/019d0198-4291-7593-82c0-efd4c864db24.webp",
  "property_company_icon_media": null,
  "property_company_logo": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/company/5726763346821120/019d0198-5322-7081-947b-e809ba802b6c.webp",
  "property_company_logo_media": {
    "alt_text": "Weidner Apartment Homes logo",
    "public_id": "019d0198-5322-7081-947b-e809ba802b6c",
    "storage_key": "company/5726763346821120/019d0198-5322-7081-947b-e809ba802b6c.webp",
    "width": 1342,
    "height": 402
  },
  "property_company_mono_black_logo": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/company/5726763346821120/019d270e-bdc5-779e-a400-a391326cc801.webp",
  "property_company_mono_black_logo_media": {
    "alt_text": "Weidner Apartment Homes logo",
    "public_id": "019d270e-bdc5-779e-a400-a391326cc801",
    "storage_key": "company/5726763346821120/019d270e-bdc5-779e-a400-a391326cc801.webp",
    "width": 640,
    "height": 192
  },
  "property_company_mono_white_logo": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/company/5726763346821120/019d270e-c548-748f-97de-b042810ed358.webp",
  "property_company_mono_white_logo_media": {
    "alt_text": "Weidner Apartment Homes logo",
    "public_id": "019d270e-c548-748f-97de-b042810ed358",
    "storage_key": "company/5726763346821120/019d270e-c548-748f-97de-b042810ed358.webp",
    "width": 640,
    "height": 192
  },
  "property_primary_color": null,
  "property_secondary_color": null,
  "property_font_color": null,
  "property_color_4": null,
  "property_color_3": null,
  "property_color_5": null,
  "property_color_6": null,
  "property_color_7": null,
  "property_color_8": null,
  "property_bedrooms_range": "Studio - 3",
  "property_bedrooms_min": "Studio",
  "property_bedrooms_max": "3",
  "property_bathrooms_range": "1 - 2",
  "property_bathrooms_min": "1",
  "property_bathrooms_max": "2",
  "property_sqft_range": "503 - 1,399 sq ft",
  "property_sqft_min": "503",
  "property_sqft_max": "1,399",
  "property_price_range": null,
  "property_price_min": null,
  "property_price_max": null,
  "property_available_units": null,
  "property_facebook_url": null,
  "property_instagram_url": null,
  "property_twitter_url": null,
  "property_google_place_url": "https://www.google.com/maps/place/?q=place_id:ChIJjxBPkvwRyYcRUNGPwOJ7lFU",
  "property_youtube_url": "https://www.youtube.com/@WeidnerApartments",
  "property_yelp_url": null,
  "property_tiktok_url": null,
  "property_specialoffer_title": null,
  "property_specialoffer_description": null,
  "property_specialoffer_disclaimer": null,
  "property_home_hero_title": "Welcome to Fitzroy Grove",
  "property_home_romance_title": "Embrace Comfort and Connection in Your Dream Apartment Home",
  "property_home_amenities_blurb": "<p><strong>Amenities that make downtime easy.</strong> Stretch out by the resort-style pool cabanas, squeeze in a workout at the 24-hour health club, or settle in with coffee at the java bar and community work spaces. Outside, a putting green, bocce court, grilling stations, dog park, and grooming area add more ways to enjoy the day. Inside, polished finishes like granite countertops, stainless steel appliances, designer cabinetry, keyless entry, and in-home washer/dryer keep every detail feeling considered.</p>",
  "property_home_floorplans_blurb": "<p><strong>Find the layout that fits the way you live.</strong> Fitzroy Grove offers studio, one-, two-, and three-bedroom apartments in Rogers, AR, with easy-to-compare floor plan cards for pricing, availability, and layout. Inside, standout finishes include granite countertops, designer cabinetry, stainless steel appliances, in-home washer/dryer, oversized closets, and lofty ceilings, with select homes featuring kitchen islands and a patio or balcony.</p>",
  "property_home_gallery_blurb": "<p><strong>Get a closer look at Fitzroy Grove.</strong> Preview bright interiors with granite countertops, designer cabinetry, stainless steel appliances, and kitchen islands, then move outside to the resort-style pool, private cabanas, putting green, grilling areas, and pet-friendly green spaces. From airy ceilings and oversized closets to patios or balconies, keyless entry, and built-in USB ports, the gallery captures the details that make everyday living feel polished.</p>",
  "property_home_neighborhood_blurb": "<p><strong>Pinnacle Hills puts Rogers at your doorstep.</strong> From Fitzroy Grove, open-air shopping at Pinnacle Hills Promenade, dining near Village on the Creeks and The Plaza, and concerts at Walmart AMP are all close by. Trails and parks add fresh-air options, while I-49 keeps Bentonville, downtown Rogers, and Fayetteville easy to reach. Explore the map to see how connected life can feel here.</p>",
  "property_home_reviews_blurb": "<p><strong>See what stands out at Fitzroy Grove.</strong><br>Resident reviews share the everyday details that shape life here—from helpful interactions to the comfort, convenience, and community feel that make an impression. Browse real ratings and comments for a clearer look before planning your next visit.</p>",
  "property_neighborhood_blurb": "<p><strong>Start with the map—and notice how close the good stuff gets.</strong> From Fitzroy Grove, the Pinnacle Hills side of Rogers puts everyday errands, dinner plans, and weekend outings in one connected pocket of Northwest Arkansas. Browse open-air shopping at Pinnacle Hills Promenade, meet friends for crêpes, steak, sushi, or pizza near Village on the Creeks and The Plaza, then catch a concert at Walmart AMP without crossing town.</p><p>When you want a slower pace, nearby trails and Rogers parks give you room to get outside, while I-49 keeps Bentonville, downtown Rogers, and Fayetteville within easy reach. Explore the map below, then <a href=\"/schedule-a-tour\">schedule a tour</a> to see how Fitzroy Grove keeps you close to the neighborhood you’ll actually use.</p>",
  "property_accessibility_blurb": null,
  "property_amenities_blurb": "<p><strong>Let your routine stretch out a little.</strong> At Fitzroy Grove in Rogers, amenities are set up for the moments between errands, work, and downtime: claim shade by the resort-style pool cabanas, fit in a session at the 24-hour health club, or reset with a coffee at the java bar before settling into the business center or community work spaces.</p><p>When you want something more social, the putting green, bocce court, grilling stations, and recreational lounge give you easy options close to home. Pet-friendly perks include a dog park and grooming area, while package service, elevators, private garages, Wi‑Fi in amenity areas, and online tools simplify the everyday. Inside, granite countertops, stainless steel appliances, designer cabinetry, washer/dryer, keyless entry, USB ports, and airy ceilings bring the polished finish you can preview in the <a href=\"/gallery\">photo gallery</a> or on a <a href=\"/schedule-a-tour\">tour</a>.</p>",
  "property_applynow_blurb": "<p><strong>Start your Fitzroy Grove application online.</strong><br>Resort-inspired living meets everyday ease with polished studio, one-, two-, and three-bedroom apartments featuring granite countertops, stainless steel appliances, oversized closets, in-home washer/dryer, and keyless entry. If Fitzroy Grove feels like home, take the next step and apply today.</p>",
  "property_contactus_blurb": "<p><strong>Have questions or need directions?</strong> Connect with the Fitzroy Grove leasing team for help with apartment layouts, polished in-home finishes, resort-inspired community spaces, and our convenient Rogers location just off I-49. We’re here to make your next step simple.</p>",
  "property_faqs_blurb": "<p><strong>Questions about Fitzroy Grove?</strong> Start here for quick answers on apartment layouts, community features, leasing details, and everyday living in our resort-inspired Rogers community. If you don’t see what you need, the leasing team is happy to help.</p>",
  "property_floorplans_blurb": "<p><strong>Start with the way your space should work.</strong> At Fitzroy Grove in Rogers, you can compare studio, one-bedroom, two-bedroom, and three-bedroom apartments side by side, with floor plan cards that make it easy to weigh layout, availability, and pricing.</p><p>Inside, look for polished details that make each plan feel considered: granite countertops, designer cabinetry, stainless steel appliances, kitchen islands in select layouts, in-home washer/dryer, oversized closets, and lofty ceilings that open up the room. Choose a compact plan with smart flow or a larger layout with more separation, then picture mornings at the kitchen island, quiet evenings on your patio or balcony, and everyday convenience built right in. Browse the options below, view more <a href=\"/amenities\">apartment features</a>, or <a href=\"/schedule-a-tour\">schedule a tour</a> to see your favorite in person.</p>",
  "property_gallery_blurb": "<p><strong>See the texture of everyday life at Fitzroy Grove.</strong> Browse photos that move from bright apartment interiors to poolside scenes, giving you a closer look at the finishes, spaces, and gathering spots that shape this Rogers community.</p><p>Pause on kitchens with granite countertops, designer cabinetry, stainless steel appliances, and islands made for easy prep or casual seating. Then explore the <a href=\"/amenities\">resort-style pool</a> with private cabanas, the clubroom and java bar, fitness spaces, putting green, outdoor grilling areas, and pet-friendly outdoor spaces. As you click through the gallery, notice the small details too: airy ceilings, oversized closets, patios or balconies, keyless entry, and built-in USB ports. When a favorite view catches your eye, compare available <a href=\"/floor-plans\">studio to three-bedroom layouts</a> or <a href=\"/schedule-a-tour\">schedule a tour</a> to see the spaces in person.</p>",
  "property_interactivemap_blurb": "<p><strong>Find your place in Rogers’ Pinnacle Hills corridor.</strong><br>Use the interactive map to explore available apartments at Fitzroy Grove, then see how close home is to I-49, Uptown Rogers, Bentonville, downtown Rogers, and major Northwest Arkansas employment hubs.</p>",
  "property_pets_blurb": "<p><strong>Life with pets feels easier here.</strong> Fitzroy Grove welcomes cats and dogs, with policy details and breed restrictions outlined below. On site, the dog park gives pups a convenient place to stretch their legs, while the grooming area helps keep bath time close to home and muddy paws out of your everyday routine.</p><p>Inside your apartment, in-home laundry, oversized closets, and patios or balconies add practical comfort for pet supplies, cozy corners, and post-walk cleanup. In Rogers, nearby trails, veterinary care, and pet supply stops help simplify the rest of the routine. Explore our <a href=\"/amenities\">pet-friendly amenities</a> or <a href=\"/schedule-a-tour\">schedule a tour</a> to see the dog park and grooming space in person.</p>",
  "property_referafriend_blurb": "<p><strong>Love life at Fitzroy Grove?</strong> Share the resort-inspired living, polished apartment finishes, and everyday ease you enjoy in Rogers’ Pinnacle Hills corridor. Invite a friend to take a look, choose their layout, and make Fitzroy Grove their next home.</p>",
  "property_residentaccess_blurb": "<p><strong>Resident access, made easy.</strong><br>Manage life at Fitzroy Grove from one convenient place—pay rent, submit maintenance requests, and keep your account up to date, then get back to enjoying polished apartment living in Rogers’ Pinnacle Hills corridor.</p>",
  "property_reviews_blurb": "<p><strong>Real experiences, all in one place.</strong><br>As you explore Fitzroy Grove, the reviews below offer a firsthand look at what living here is like—from everyday interactions to the details that shape daily comfort. Read through resident ratings and comments to see what stands out, compare perspectives, and get a clearer feel for the community before you plan your next step.</p>",
  "property_created_at": "1783363733262",
  "property_scheduletour_blurb": "<p><strong>See Fitzroy Grove in person.</strong> Tour polished studio, one-, two-, and three-bedroom layouts with granite countertops, stainless steel appliances, oversized closets, in-home washer/dryer, and airy ceilings—then explore resort-inspired spaces built for relaxing, focusing, and gathering. Schedule your tour today and picture life in Rogers’ Pinnacle Hills corridor.</p>",
  "property_thankyou_blurb": "<p><strong>Thank you—we’ve received your inquiry.</strong><br>Our leasing team will be in touch soon. In the meantime, picture resort-inspired living in Rogers’ Pinnacle Hills corridor, with polished apartment layouts, airy interiors, and spaces designed to help you recharge, focus, and gather.</p>",
  "property_virtualtours_blurb": null,
  "property_copyright": "2026 All Rights Reserved. Fitzroy Grove",
  "property_seo_title_home": "Fitzroy Grove |  Apartments in Rogers, AR",
  "property_seo_description_home": "Discover luxury living at Fitzroy Grove in Rogers, AR—resort-style amenities, flexible rent options, and a perfect mix of comfort and community.",
  "property_seo_title_floorplans": "Floor Plans | Rogers, AR Apartments for Rent",
  "property_seo_description_floorplans": "Find your ideal space at Fitzroy Grove in Rogers, AR! Choose from stylish studios to spacious three-bedrooms. Browse our diverse floor plans today!",
  "property_seo_title_amenities": "Amenities | Rogers, AR Apartments for Rent",
  "property_seo_description_amenities": "Unwind at Fitzroy Grove in Rogers, AR. Enjoy luxury amenities like a resort-style pool, state-of-the-art fitness center, pet-friendly spaces, and more.",
  "property_seo_title_gallery": "Gallery | Apartments in Rogers, AR",
  "property_seo_description_gallery": "Picture life at Fitzroy Grove in Rogers, AR! Luxury amenities, stunning floor plans, and pet-friendly spaces await. Your dream home starts here!",
  "property_seo_title_virtualtours": "Virtual Tours | Fitzroy Grove Apartments",
  "property_seo_description_virtualtours": "Step into Fitzroy Grove in Rogers, AR! Enjoy stunning virtual tours of our stylish studio, one, two, and three-bedroom apartments for rent.",
  "property_seo_title_interactivemap": "Interactive Map | Fitzroy Grove Apartments",
  "property_seo_description_interactivemap": "Find your perfect home at Fitzroy Grove in Rogers, AR! Use our interactive map to explore spacious floor plans, modern amenities, and vibrant community life!",
  "property_seo_title_neighborhood": "Neighborhood | Apartments in Rogers, AR",
  "property_seo_description_neighborhood": "Uncover vibrant local gems around Fitzroy Grove in Rogers, AR. Check out favorite hotspots and discover the perfect blend of community and convenience!",
  "property_seo_title_contact": "Contact Us | Fitzroy Grove",
  "property_seo_description_contact": "Connect with Fitzroy Grove in Rogers, AR! Whether you're seeking a studio or a spacious three-bedroom, our leasing team is here to answer all your questions!",
  "property_seo_title_faqs": "FAQs | Apartments in Rogers, AR",
  "property_seo_description_faqs": "Find answers to your queries about Fitzroy Grove in Rogers, AR. Learn about our flexible rent options, luxury amenities, and pet-friendly lifestyle today!",
  "property_seo_title_reviews": "Resident Reviews | Apartments in Rogers, AR",
  "property_seo_description_reviews": "Join the Fitzroy Grove community in Rogers, AR! Read resident reviews and see why our stylish apartments and top-notch amenities make living here exceptional!",
  "property_seo_title_applynow": "Apply Now | Apartments in Rogers, AR",
  "property_seo_description_applynow": "Discover luxury living at Fitzroy Grove, Rogers, AR. Choose stylish floor plans, resort-style amenities, and flexible payments. Your dream home awaits!",
  "property_seo_title_residentaccess": "Resident Access | Fitzroy Grove",
  "property_seo_description_residentaccess": "Login to your Fitzroy Grove resident portal and manage your home effortlessly—pay rent, request maintenance, and connect with your community in Rogers, AR!",
  "property_seo_title_referafriend": "Refer A Friend | Fitzroy Grove",
  "property_seo_description_referafriend": "Refer a friend to Fitzroy Grove in Rogers, AR! Enjoy vibrant living with great neighbors in a community that feels like home. Join us today!",
  "property_seo_title_scheduletour": "Schedule a Tour | Fitzroy Grove",
  "property_seo_description_scheduletour": "Experience life at Fitzroy Grove in Rogers, AR. Schedule your tour today and step into your future home, surrounded by comfort and community. Let’s connect!",
  "property_seo_title_privacy": "Privacy Policy | Fitzroy Grove",
  "property_seo_description_privacy": "At Fitzroy Grove in Rogers, AR, your privacy matters. Learn how we protect your information and maintain a secure living environment. View our privacy policy.",
  "property_seo_title_accessibility": "Website Accessibility | Fitzroy Grove",
  "property_seo_description_accessibility": "At Fitzroy Grove in Rogers, AR, we're committed to digital inclusion. Experience accessible living that welcomes everyone. Join our community today!",
  "property_seo_title_sitemap": "Sitemap | Fitzroy Grove",
  "property_seo_description_sitemap": "Uncover the essence of Fitzroy Grove in Rogers, AR. Dive into our sitemap for a clear path to your dream apartment and vibrant community life.",
  "property_seo_title_thankyou": "Thank You | Fitzroy Grove",
  "property_seo_description_thankyou": "Thank you for reaching out! At Fitzroy Grove, your future home in Rogers, AR awaits. Expect a prompt response from our team to assist you further!",
  "property_seo_title_pets": "Pet Policy | Apartments in Rogers, AR",
  "property_seo_description_pets": "Discover our comprehensive pet policy designed to ensure a comfortable and welcoming environment for you and your furry companions.",
  "property_updated_at": "1787767360161",
  "amenities": [
    {
      "id": "ec_29c8358f5c6ab289ce4bf446",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167553",
      "source": "generator",
      "external_id": "false",
      "title": "Flex. Now Accepted — Move in now, pay over time or split your rent into smaller payments",
      "amount": "false",
      "description": "Featured amenity—flexible payment option",
      "group": "Community",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_6b1b0ad252cdf684c3cf0095",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167553",
      "source": "generator",
      "external_id": "false",
      "title": "Resort‑Style Pool",
      "amount": "false",
      "description": "false",
      "group": "Community",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_62c8623092173492114e9d69",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167553",
      "source": "generator",
      "external_id": "false",
      "title": "Private Poolside Cabanas",
      "amount": "false",
      "description": "false",
      "group": "Community",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_4ab8da91912700779ee9280e",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167553",
      "source": "generator",
      "external_id": "false",
      "title": "Putting Green",
      "amount": "false",
      "description": "false",
      "group": "Community",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_eb01f8590b337b860faaf7db",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167553",
      "source": "generator",
      "external_id": "false",
      "title": "Recreational Lounge",
      "amount": "false",
      "description": "false",
      "group": "Community",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_0a9153f24cba7af102876ce0",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167553",
      "source": "generator",
      "external_id": "false",
      "title": "Business Center",
      "amount": "false",
      "description": "false",
      "group": "Community",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_9a4c5e787623dc31744affbb",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167553",
      "source": "generator",
      "external_id": "false",
      "title": "Java Bar",
      "amount": "false",
      "description": "false",
      "group": "Community",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_6a92391654e5db40ba0a6fdf",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167553",
      "source": "generator",
      "external_id": "false",
      "title": "24‑Hour Health Club",
      "amount": "false",
      "description": "false",
      "group": "Community",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_33237a0c364560a55dbedc3d",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167553",
      "source": "generator",
      "external_id": "false",
      "title": "Bike Stations",
      "amount": "false",
      "description": "false",
      "group": "Community",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_500789f6de4835ccac8591a8",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167553",
      "source": "generator",
      "external_id": "false",
      "title": "Bocce Court",
      "amount": "false",
      "description": "false",
      "group": "Community",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_566847c2a877edd748dd3e8b",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167553",
      "source": "generator",
      "external_id": "false",
      "title": "Outdoor Grilling Stations",
      "amount": "false",
      "description": "false",
      "group": "Community",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_42a2abbe04aa07a540966bc7",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167553",
      "source": "generator",
      "external_id": "false",
      "title": "Community Work Spaces",
      "amount": "false",
      "description": "false",
      "group": "Community",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_108daff0d85468467c492d8c",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167553",
      "source": "generator",
      "external_id": "false",
      "title": "Dog Park & Grooming Area",
      "amount": "false",
      "description": "false",
      "group": "Community",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_b96a69a471c36edf88a56f55",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167553",
      "source": "generator",
      "external_id": "false",
      "title": "Elevators",
      "amount": "false",
      "description": "false",
      "group": "Community",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_5cc3d773a2e0fc53c447a674",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167553",
      "source": "generator",
      "external_id": "false",
      "title": "Package Center",
      "amount": "false",
      "description": "false",
      "group": "Community",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_3c54896a3a835edeb341527b",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167553",
      "source": "generator",
      "external_id": "false",
      "title": "Private Garages",
      "amount": "false",
      "description": "false",
      "group": "Community",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_e034b5cf7b9eff0242864fed",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167553",
      "source": "generator",
      "external_id": "false",
      "title": "Wi‑Fi at Pool & Amenity Areas",
      "amount": "false",
      "description": "false",
      "group": "Community",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_b1d3cbfa88e22ccc5a571593",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167553",
      "source": "generator",
      "external_id": "false",
      "title": "Online Resident Portal",
      "amount": "false",
      "description": "false",
      "group": "Community",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_fe5e8f630cf7538153ecb46f",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167553",
      "source": "generator",
      "external_id": "false",
      "title": "Pet Friendly",
      "amount": "false",
      "description": "false",
      "group": "Community",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_419aae939e4cf5ecc21a9a1a",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167553",
      "source": "generator",
      "external_id": "false",
      "title": "Granite Countertops",
      "amount": "false",
      "description": "false",
      "group": "Apartment",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_184e3b1151d205bc280a4dbc",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167553",
      "source": "generator",
      "external_id": "false",
      "title": "Designer Cabinetry",
      "amount": "false",
      "description": "false",
      "group": "Apartment",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_87b9482b27076b1368a273c7",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167553",
      "source": "generator",
      "external_id": "false",
      "title": "Kitchen Island",
      "amount": "false",
      "description": "false",
      "group": "Apartment",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_166d234c2c89e5c606a0744d",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167553",
      "source": "generator",
      "external_id": "false",
      "title": "Designer Tile Backsplash",
      "amount": "false",
      "description": "false",
      "group": "Apartment",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_0358badda74b43a92f1ebe90",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167553",
      "source": "generator",
      "external_id": "false",
      "title": "Stainless Steel Appliances",
      "amount": "false",
      "description": "false",
      "group": "Apartment",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_9bdf92ccebdde98daf69c6b5",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167553",
      "source": "generator",
      "external_id": "false",
      "title": "Pantry",
      "amount": "false",
      "description": "false",
      "group": "Apartment",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_3cb954932598cddb41e42fb4",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167553",
      "source": "generator",
      "external_id": "false",
      "title": "Washer/Dryer",
      "amount": "false",
      "description": "false",
      "group": "Apartment",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_927d7759c4444dee00ef86ff",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167553",
      "source": "generator",
      "external_id": "false",
      "title": "9ft ‑ 14ft Ceilings",
      "amount": "false",
      "description": "false",
      "group": "Apartment",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_cc4485993a921abd948db72d",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167553",
      "source": "generator",
      "external_id": "false",
      "title": "Ceiling Fans",
      "amount": "false",
      "description": "false",
      "group": "Apartment",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_48b326781db1ecc5ab0a654a",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167553",
      "source": "generator",
      "external_id": "false",
      "title": "Disability Access",
      "amount": "false",
      "description": "false",
      "group": "Apartment",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_f711a7f21131e65ec0c7e85a",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167553",
      "source": "generator",
      "external_id": "false",
      "title": "Energy‑Efficient Windows",
      "amount": "false",
      "description": "false",
      "group": "Apartment",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_e801457587967bb7ed339677",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167553",
      "source": "generator",
      "external_id": "false",
      "title": "Oversized Closets",
      "amount": "false",
      "description": "false",
      "group": "Apartment",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_34d20fdd22179e81c9605f77",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167553",
      "source": "generator",
      "external_id": "false",
      "title": "Fireplace",
      "amount": "false",
      "description": "false",
      "group": "Apartment",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_07abc21bddc2a82a00b71b19",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167553",
      "source": "generator",
      "external_id": "false",
      "title": "Garden Tub",
      "amount": "false",
      "description": "false",
      "group": "Apartment",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_c725d76044ddb4b9d97672fa",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167553",
      "source": "generator",
      "external_id": "false",
      "title": "Patio/Balcony",
      "amount": "false",
      "description": "false",
      "group": "Apartment",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_677a0255bdaad90e2d3a53f8",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167553",
      "source": "generator",
      "external_id": "false",
      "title": "Keyless Entry",
      "amount": "false",
      "description": "false",
      "group": "Apartment",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_cea931dac88f7eb12dbbe005",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167553",
      "source": "generator",
      "external_id": "false",
      "title": "Built‑in USB Ports",
      "amount": "false",
      "description": "false",
      "group": "Apartment",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_499afa0bd83ea5c1469c5b46",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167553",
      "source": "generator",
      "external_id": "false",
      "title": "High‑Speed Internet",
      "amount": "false",
      "description": "false",
      "group": "Apartment",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    }
  ],
  "photo_gallery": [
    {
      "id": "ec_58421349586af6e9cbaf7741",
      "source": "generator",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167553",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167553/019f38c4-c72c-7560-99ed-a28d1ae1c1bb.webp",
      "image_media": {
        "alt_text": "Property Logo at Fitzroy Grove, Arkansas",
        "public_id": "019f38c4-c72c-7560-99ed-a28d1ae1c1bb",
        "storage_key": "property/6767906449167553/019f38c4-c72c-7560-99ed-a28d1ae1c1bb.webp",
        "width": 1080,
        "height": 1080
      },
      "title": "Logo",
      "description": "Property Logo",
      "link": "false",
      "alt_text": "Property Logo at Fitzroy Grove, Arkansas",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://resource.rentcafe.com/image/upload/s3/2/212041/fitzroy%20logo%20white.png"
    },
    {
      "id": "ec_91ff5745134415359d6f78cc",
      "source": "generator",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167553",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167553/019f38c4-c927-7796-9eea-12b20e2dbb4e.webp",
      "image_media": {
        "alt_text": "Thumbnail 1 of 35 - a building with a mini golf course in front of it at Fitzroy Grove, Rogers, AR, 72758",
        "public_id": "019f38c4-c927-7796-9eea-12b20e2dbb4e",
        "storage_key": "property/6767906449167553/019f38c4-c927-7796-9eea-12b20e2dbb4e.webp",
        "width": 1024,
        "height": 396
      },
      "title": "Community",
      "description": "Thumbnail 1 of 35 - a building with a mini golf course in front of it at Fitzroy Grove, Rogers, AR, 72758",
      "link": "false",
      "alt_text": "Thumbnail 1 of 35 - a building with a mini golf course in front of it at Fitzroy Grove, Rogers, AR, 72758",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://resource.rentcafe.com/image/upload/s3/2/212041/p1744377_10_1_photogallery.jpg"
    },
    {
      "id": "ec_d2ab42ad81a18affd0cb9639",
      "source": "generator",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167553",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167553/019f38c4-c9fa-756d-94bc-91389b24cbfe.webp",
      "image_media": {
        "alt_text": "Thumbnail 2 of 35 - a patio with chairs and a fire pit in front of a building at Fitzroy Grove, Arkansas",
        "public_id": "019f38c4-c9fa-756d-94bc-91389b24cbfe",
        "storage_key": "property/6767906449167553/019f38c4-c9fa-756d-94bc-91389b24cbfe.webp",
        "width": 1024,
        "height": 1325
      },
      "title": "Community",
      "description": "Thumbnail 2 of 35 - a patio with chairs and a fire pit in front of a building at Fitzroy Grove, Arkansas",
      "link": "false",
      "alt_text": "Thumbnail 2 of 35 - a patio with chairs and a fire pit in front of a building at Fitzroy Grove, Arkansas",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://resource.rentcafe.com/image/upload/s3/2/212041/p1744377_14_1_photogallery.jpg"
    },
    {
      "id": "ec_b473644b11be8c2de1c5ebdf",
      "source": "generator",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167553",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167553/019f38c4-ca05-73fb-af03-77a2fc97225a.webp",
      "image_media": {
        "alt_text": "Thumbnail 3 of 35 - a building with a pool in front of it at Fitzroy Grove, Arkansas, 72758",
        "public_id": "019f38c4-ca05-73fb-af03-77a2fc97225a",
        "storage_key": "property/6767906449167553/019f38c4-ca05-73fb-af03-77a2fc97225a.webp",
        "width": 1024,
        "height": 1325
      },
      "title": "Community",
      "description": "Thumbnail 3 of 35 - a building with a pool in front of it at Fitzroy Grove, Arkansas, 72758",
      "link": "false",
      "alt_text": "Thumbnail 3 of 35 - a building with a pool in front of it at Fitzroy Grove, Arkansas, 72758",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://resource.rentcafe.com/image/upload/s3/2/212041/p1744377_24_1_photogallery.jpg"
    },
    {
      "id": "ec_22fc62d1c487126eda21709d",
      "source": "generator",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167553",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167553/019f38c4-c6e4-7782-b318-c92c328f9014.webp",
      "image_media": {
        "alt_text": "Thumbnail 4 of 35 - a swimming pool with a building in the background at Fitzroy Grove, Rogers, AR",
        "public_id": "019f38c4-c6e4-7782-b318-c92c328f9014",
        "storage_key": "property/6767906449167553/019f38c4-c6e4-7782-b318-c92c328f9014.webp",
        "width": 1024,
        "height": 1325
      },
      "title": "Community",
      "description": "Thumbnail 4 of 35 - a swimming pool with a building in the background at Fitzroy Grove, Rogers, AR",
      "link": "false",
      "alt_text": "Thumbnail 4 of 35 - a swimming pool with a building in the background at Fitzroy Grove, Rogers, AR",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://resource.rentcafe.com/image/upload/s3/2/212041/p1744377_25_1_photogallery.jpg"
    },
    {
      "id": "ec_6e6a5cf48dd8316d571f4777",
      "source": "generator",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167553",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167553/019f38c4-c929-76ea-9474-c544427773ed.webp",
      "image_media": {
        "alt_text": "Thumbnail 5 of 35 - Community Clubhouse at Fitzroy Grove, Rogers",
        "public_id": "019f38c4-c929-76ea-9474-c544427773ed",
        "storage_key": "property/6767906449167553/019f38c4-c929-76ea-9474-c544427773ed.webp",
        "width": 1024,
        "height": 683
      },
      "title": "Community",
      "description": "Thumbnail 5 of 35 - Community Clubhouse at Fitzroy Grove, Rogers",
      "link": "false",
      "alt_text": "Thumbnail 5 of 35 - Community Clubhouse at Fitzroy Grove, Rogers",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://resource.rentcafe.com/image/upload/s3/2/212041/p1744377_29_1_photogallery.jpg"
    },
    {
      "id": "ec_e95a87b36d1db33be8436459",
      "source": "generator",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167553",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167553/019f38c4-c91f-72e1-9cf3-44d9db2d943e.webp",
      "image_media": {
        "alt_text": "Thumbnail 6 of 35 - Shuffleboard at Fitzroy Grove, Rogers, AR, 72758",
        "public_id": "019f38c4-c91f-72e1-9cf3-44d9db2d943e",
        "storage_key": "property/6767906449167553/019f38c4-c91f-72e1-9cf3-44d9db2d943e.webp",
        "width": 1024,
        "height": 396
      },
      "title": "Community",
      "description": "Thumbnail 6 of 35 - Shuffleboard at Fitzroy Grove, Rogers, AR, 72758",
      "link": "false",
      "alt_text": "Thumbnail 6 of 35 - Shuffleboard at Fitzroy Grove, Rogers, AR, 72758",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://resource.rentcafe.com/image/upload/s3/2/212041/p1744377_30_1_photogallery.jpg"
    },
    {
      "id": "ec_df95c0ffea5d182896f222f8",
      "source": "generator",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167553",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167553/019f38c4-c6e4-7782-b318-c423b6f7d67d.webp",
      "image_media": {
        "alt_text": "Thumbnail 7 of 35 - a long bar in a restaurant with chairs at Fitzroy Grove, Rogers, AR, 72758",
        "public_id": "019f38c4-c6e4-7782-b318-c423b6f7d67d",
        "storage_key": "property/6767906449167553/019f38c4-c6e4-7782-b318-c423b6f7d67d.webp",
        "width": 1024,
        "height": 396
      },
      "title": "Community",
      "description": "Thumbnail 7 of 35 - a long bar in a restaurant with chairs at Fitzroy Grove, Rogers, AR, 72758",
      "link": "false",
      "alt_text": "Thumbnail 7 of 35 - a long bar in a restaurant with chairs at Fitzroy Grove, Rogers, AR, 72758",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://resource.rentcafe.com/image/upload/s3/2/212041/p1744377_31_1_photogallery.jpg"
    },
    {
      "id": "ec_8fe290f18897d685a1ecbc72",
      "source": "generator",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167553",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167553/019f38c4-ca47-7103-8974-376c03f26a2b.webp",
      "image_media": {
        "alt_text": "Thumbnail 8 of 35 - Resident Lounge at Fitzroy Grove, Rogers, AR",
        "public_id": "019f38c4-ca47-7103-8974-376c03f26a2b",
        "storage_key": "property/6767906449167553/019f38c4-ca47-7103-8974-376c03f26a2b.webp",
        "width": 1024,
        "height": 396
      },
      "title": "Community",
      "description": "Thumbnail 8 of 35 - Resident Lounge at Fitzroy Grove, Rogers, AR",
      "link": "false",
      "alt_text": "Thumbnail 8 of 35 - Resident Lounge at Fitzroy Grove, Rogers, AR",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://resource.rentcafe.com/image/upload/s3/2/212041/p1744377_32_1_photogallery.jpg"
    },
    {
      "id": "ec_d6a274f91deb360daf6ce574",
      "source": "generator",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167553",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167553/019f38c4-c9f6-7578-a0ae-8037a55f694a.webp",
      "image_media": {
        "alt_text": "Thumbnail 9 of 35 - a restaurant with a long bar and a counter with chairs at Fitzroy Grove, Rogers, Arkansas",
        "public_id": "019f38c4-c9f6-7578-a0ae-8037a55f694a",
        "storage_key": "property/6767906449167553/019f38c4-c9f6-7578-a0ae-8037a55f694a.webp",
        "width": 1024,
        "height": 396
      },
      "title": "Community",
      "description": "Thumbnail 9 of 35 - a restaurant with a long bar and a counter with chairs at Fitzroy Grove, Rogers, Arkansas",
      "link": "false",
      "alt_text": "Thumbnail 9 of 35 - a restaurant with a long bar and a counter with chairs at Fitzroy Grove, Rogers, Arkansas",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://resource.rentcafe.com/image/upload/s3/2/212041/p1744377_33_1_photogallery.jpg"
    },
    {
      "id": "ec_e513c27a32eda9865c189697",
      "source": "generator",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167553",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167553/019f38c4-d811-70ce-a4d4-3a4afbfe5dff.webp",
      "image_media": {
        "alt_text": "Thumbnail 10 of 35 - Clubroom at Fitzroy Grove, Rogers, AR, 72758",
        "public_id": "019f38c4-d811-70ce-a4d4-3a4afbfe5dff",
        "storage_key": "property/6767906449167553/019f38c4-d811-70ce-a4d4-3a4afbfe5dff.webp",
        "width": 1024,
        "height": 683
      },
      "title": "Community",
      "description": "Thumbnail 10 of 35 - Clubroom at Fitzroy Grove, Rogers, AR, 72758",
      "link": "false",
      "alt_text": "Thumbnail 10 of 35 - Clubroom at Fitzroy Grove, Rogers, AR, 72758",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://resource.rentcafe.com/image/upload/s3/2/212041/p1744377_34_1_photogallery.jpg"
    },
    {
      "id": "ec_5193b28885a78a951df6d46f",
      "source": "generator",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167553",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167553/019f38c4-d820-75d7-91f0-796e5b5f355a.webp",
      "image_media": {
        "alt_text": "Thumbnail 11 of 35 - Community Room at Fitzroy Grove, Rogers, Arkansas",
        "public_id": "019f38c4-d820-75d7-91f0-796e5b5f355a",
        "storage_key": "property/6767906449167553/019f38c4-d820-75d7-91f0-796e5b5f355a.webp",
        "width": 1024,
        "height": 683
      },
      "title": "Community",
      "description": "Thumbnail 11 of 35 - Community Room at Fitzroy Grove, Rogers, Arkansas",
      "link": "false",
      "alt_text": "Thumbnail 11 of 35 - Community Room at Fitzroy Grove, Rogers, Arkansas",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://resource.rentcafe.com/image/upload/s3/2/212041/p1744377_35_1_photogallery.jpg"
    },
    {
      "id": "ec_12b99ecd374f9fd3b92362cb",
      "source": "generator",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167553",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167553/019f38c4-da8d-74d8-8cc7-0c509f2c3dad.webp",
      "image_media": {
        "alt_text": "Thumbnail 12 of 35 - Coffee Bar Lounge at Fitzroy Grove, Rogers, AR, 72758",
        "public_id": "019f38c4-da8d-74d8-8cc7-0c509f2c3dad",
        "storage_key": "property/6767906449167553/019f38c4-da8d-74d8-8cc7-0c509f2c3dad.webp",
        "width": 1024,
        "height": 683
      },
      "title": "Community",
      "description": "Thumbnail 12 of 35 - Coffee Bar Lounge at Fitzroy Grove, Rogers, AR, 72758",
      "link": "false",
      "alt_text": "Thumbnail 12 of 35 - Coffee Bar Lounge at Fitzroy Grove, Rogers, AR, 72758",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://resource.rentcafe.com/image/upload/s3/2/212041/p1744377_36_1_photogallery.jpg"
    },
    {
      "id": "ec_dd5a117065db4fc3e22c1e5a",
      "source": "generator",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167553",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167553/019f38c4-ddd4-70cc-9687-d431ad2dd2b4.webp",
      "image_media": {
        "alt_text": "Thumbnail 13 of 35 - Lobby And Reception Area at Fitzroy Grove, Rogers, Arkansas",
        "public_id": "019f38c4-ddd4-70cc-9687-d431ad2dd2b4",
        "storage_key": "property/6767906449167553/019f38c4-ddd4-70cc-9687-d431ad2dd2b4.webp",
        "width": 1024,
        "height": 683
      },
      "title": "Community",
      "description": "Thumbnail 13 of 35 - Lobby And Reception Area at Fitzroy Grove, Rogers, Arkansas",
      "link": "false",
      "alt_text": "Thumbnail 13 of 35 - Lobby And Reception Area at Fitzroy Grove, Rogers, Arkansas",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://resource.rentcafe.com/image/upload/s3/2/212041/p1744377_37_1_photogallery.jpg"
    },
    {
      "id": "ec_402f5a6b1dabcc6c9a0dd480",
      "source": "generator",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167553",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167553/019f38c4-dbb6-738c-8033-d7905661fae5.webp",
      "image_media": {
        "alt_text": "Thumbnail 14 of 35 - a restaurant with a long bar and a green painting on the wall at Fitzroy Grove, Rogers, Arkansas",
        "public_id": "019f38c4-dbb6-738c-8033-d7905661fae5",
        "storage_key": "property/6767906449167553/019f38c4-dbb6-738c-8033-d7905661fae5.webp",
        "width": 1024,
        "height": 683
      },
      "title": "Community",
      "description": "Thumbnail 14 of 35 - a restaurant with a long bar and a green painting on the wall at Fitzroy Grove, Rogers, Arkansas",
      "link": "false",
      "alt_text": "Thumbnail 14 of 35 - a restaurant with a long bar and a green painting on the wall at Fitzroy Grove, Rogers, Arkansas",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://resource.rentcafe.com/image/upload/s3/2/212041/p1744377_38_1_photogallery.jpg"
    },
    {
      "id": "ec_b93523d3b3a97259dfc46124",
      "source": "generator",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167553",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167553/019f38c4-dbd9-722b-b541-d62200fdf074.webp",
      "image_media": {
        "alt_text": "Thumbnail 15 of 35 - Golf Simulator at Fitzroy Grove, Rogers, 72758",
        "public_id": "019f38c4-dbd9-722b-b541-d62200fdf074",
        "storage_key": "property/6767906449167553/019f38c4-dbd9-722b-b541-d62200fdf074.webp",
        "width": 1024,
        "height": 683
      },
      "title": "Community",
      "description": "Thumbnail 15 of 35 - Golf Simulator at Fitzroy Grove, Rogers, 72758",
      "link": "false",
      "alt_text": "Thumbnail 15 of 35 - Golf Simulator at Fitzroy Grove, Rogers, 72758",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://resource.rentcafe.com/image/upload/s3/2/212041/p1744377_40_1_photogallery.jpg"
    },
    {
      "id": "ec_9ad00876b2f995b42ebaafab",
      "source": "generator",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167553",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167553/019f38c4-ddd3-7476-b82e-b438a79571fc.webp",
      "image_media": {
        "alt_text": "Thumbnail 16 of 35 - Social Nooks at Fitzroy Grove, Rogers, AR",
        "public_id": "019f38c4-ddd3-7476-b82e-b438a79571fc",
        "storage_key": "property/6767906449167553/019f38c4-ddd3-7476-b82e-b438a79571fc.webp",
        "width": 1024,
        "height": 1325
      },
      "title": "Community",
      "description": "Thumbnail 16 of 35 - Social Nooks at Fitzroy Grove, Rogers, AR",
      "link": "false",
      "alt_text": "Thumbnail 16 of 35 - Social Nooks at Fitzroy Grove, Rogers, AR",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://resource.rentcafe.com/image/upload/s3/2/212041/p1744377_43_1_photogallery.jpg"
    },
    {
      "id": "ec_9b418c8c20772a251a873b00",
      "source": "generator",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167553",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167553/019f38c4-e134-7451-9523-6c3c5b36ccf4.webp",
      "image_media": {
        "alt_text": "Thumbnail 17 of 35 - Catering Kitchen at Fitzroy Grove, Arkansas",
        "public_id": "019f38c4-e134-7451-9523-6c3c5b36ccf4",
        "storage_key": "property/6767906449167553/019f38c4-e134-7451-9523-6c3c5b36ccf4.webp",
        "width": 1024,
        "height": 1325
      },
      "title": "Community",
      "description": "Thumbnail 17 of 35 - Catering Kitchen at Fitzroy Grove, Arkansas",
      "link": "false",
      "alt_text": "Thumbnail 17 of 35 - Catering Kitchen at Fitzroy Grove, Arkansas",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://resource.rentcafe.com/image/upload/s3/2/212041/p1744377_44_1_photogallery.jpg"
    },
    {
      "id": "ec_3d279b159f88a43c0183e6d9",
      "source": "generator",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167553",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167553/019f38c4-e2f6-768c-8e58-d4ec09866a80.webp",
      "image_media": {
        "alt_text": "Thumbnail 18 of 35 - Balcony And Patio at Fitzroy Grove, Rogers",
        "public_id": "019f38c4-e2f6-768c-8e58-d4ec09866a80",
        "storage_key": "property/6767906449167553/019f38c4-e2f6-768c-8e58-d4ec09866a80.webp",
        "width": 1024,
        "height": 683
      },
      "title": "Apartment",
      "description": "Thumbnail 18 of 35 - Balcony And Patio at Fitzroy Grove, Rogers",
      "link": "false",
      "alt_text": "Thumbnail 18 of 35 - Balcony And Patio at Fitzroy Grove, Rogers",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://resource.rentcafe.com/image/upload/s3/2/212041/p1744377_46_1_photogallery.jpg"
    },
    {
      "id": "ec_3ac1c8ff6983cef1b58613e6",
      "source": "generator",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167553",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167553/019f38c4-e607-715a-af5f-1b6e0098aa4c.webp",
      "image_media": {
        "alt_text": "Thumbnail 19 of 35 - Gym at Fitzroy Grove, Rogers, AR",
        "public_id": "019f38c4-e607-715a-af5f-1b6e0098aa4c",
        "storage_key": "property/6767906449167553/019f38c4-e607-715a-af5f-1b6e0098aa4c.webp",
        "width": 1024,
        "height": 396
      },
      "title": "Community",
      "description": "Thumbnail 19 of 35 - Gym at Fitzroy Grove, Rogers, AR",
      "link": "false",
      "alt_text": "Thumbnail 19 of 35 - Gym at Fitzroy Grove, Rogers, AR",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://resource.rentcafe.com/image/upload/s3/2/212041/p1744377_47_1_photogallery.jpg"
    },
    {
      "id": "ec_2bff592ea40b310f7e546e26",
      "source": "generator",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167553",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167553/019f38c4-e6da-721e-aa34-a5a361e7b747.webp",
      "image_media": {
        "alt_text": "Thumbnail 20 of 35 - Cardio Machines at Fitzroy Grove, Rogers",
        "public_id": "019f38c4-e6da-721e-aa34-a5a361e7b747",
        "storage_key": "property/6767906449167553/019f38c4-e6da-721e-aa34-a5a361e7b747.webp",
        "width": 1024,
        "height": 1325
      },
      "title": "Community",
      "description": "Thumbnail 20 of 35 - Cardio Machines at Fitzroy Grove, Rogers",
      "link": "false",
      "alt_text": "Thumbnail 20 of 35 - Cardio Machines at Fitzroy Grove, Rogers",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://resource.rentcafe.com/image/upload/s3/2/212041/p1744377_48_1_photogallery.jpg"
    },
    {
      "id": "ec_a61d793a8c2b5d88d37013ca",
      "source": "generator",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167553",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167553/019f38c4-e935-768b-a20b-7be9a807e527.webp",
      "image_media": {
        "alt_text": "Thumbnail 21 of 35 - Fitness Center at Fitzroy Grove, Rogers, Arkansas",
        "public_id": "019f38c4-e935-768b-a20b-7be9a807e527",
        "storage_key": "property/6767906449167553/019f38c4-e935-768b-a20b-7be9a807e527.webp",
        "width": 1024,
        "height": 683
      },
      "title": "Community",
      "description": "Thumbnail 21 of 35 - Fitness Center at Fitzroy Grove, Rogers, Arkansas",
      "link": "false",
      "alt_text": "Thumbnail 21 of 35 - Fitness Center at Fitzroy Grove, Rogers, Arkansas",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://resource.rentcafe.com/image/upload/s3/2/212041/p1744377_49_1_photogallery.jpg"
    },
    {
      "id": "ec_83f4a379b5272da7b65bef18",
      "source": "generator",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167553",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167553/019f38c4-e90e-779a-b186-ee5e7f2ba5c8.webp",
      "image_media": {
        "alt_text": "Thumbnail 22 of 35 - Yoga Studio at Fitzroy Grove, Rogers, AR",
        "public_id": "019f38c4-e90e-779a-b186-ee5e7f2ba5c8",
        "storage_key": "property/6767906449167553/019f38c4-e90e-779a-b186-ee5e7f2ba5c8.webp",
        "width": 1024,
        "height": 1325
      },
      "title": "Community",
      "description": "Thumbnail 22 of 35 - Yoga Studio at Fitzroy Grove, Rogers, AR",
      "link": "false",
      "alt_text": "Thumbnail 22 of 35 - Yoga Studio at Fitzroy Grove, Rogers, AR",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://resource.rentcafe.com/image/upload/s3/2/212041/p1744377_50_1_photogallery.jpg"
    },
    {
      "id": "ec_201fd1c2661e7957438e0f80",
      "source": "generator",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167553",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167553/019f38c4-e9f6-73c2-8553-76ebe6b05ada.webp",
      "image_media": {
        "alt_text": "Thumbnail 23 of 35 - Fitness Studio at Fitzroy Grove, Rogers, AR",
        "public_id": "019f38c4-e9f6-73c2-8553-76ebe6b05ada",
        "storage_key": "property/6767906449167553/019f38c4-e9f6-73c2-8553-76ebe6b05ada.webp",
        "width": 1024,
        "height": 683
      },
      "title": "Community",
      "description": "Thumbnail 23 of 35 - Fitness Studio at Fitzroy Grove, Rogers, AR",
      "link": "false",
      "alt_text": "Thumbnail 23 of 35 - Fitness Studio at Fitzroy Grove, Rogers, AR",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://resource.rentcafe.com/image/upload/s3/2/212041/p1744377_51_1_photogallery.jpg"
    },
    {
      "id": "ec_7996eaf8d06fca7633767de0",
      "source": "generator",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167553",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167553/019f38c4-eb1a-729d-9069-7b9313156914.webp",
      "image_media": {
        "alt_text": "Thumbnail 24 of 35 - Clubroom With TV at Fitzroy Grove, Rogers, AR, 72758",
        "public_id": "019f38c4-eb1a-729d-9069-7b9313156914",
        "storage_key": "property/6767906449167553/019f38c4-eb1a-729d-9069-7b9313156914.webp",
        "width": 1024,
        "height": 683
      },
      "title": "Apartment",
      "description": "Thumbnail 24 of 35 - Clubroom With TV at Fitzroy Grove, Rogers, AR, 72758",
      "link": "false",
      "alt_text": "Thumbnail 24 of 35 - Clubroom With TV at Fitzroy Grove, Rogers, AR, 72758",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://resource.rentcafe.com/image/upload/s3/2/212041/p1744377_52_1_photogallery.jpg"
    },
    {
      "id": "ec_44a04a49bded12188901a781",
      "source": "generator",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167553",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167553/019f38c4-ead0-73e8-84a5-98cbdb114132.webp",
      "image_media": {
        "alt_text": "Thumbnail 25 of 35 - Kitchen And Living Area at Fitzroy Grove, Rogers, AR",
        "public_id": "019f38c4-ead0-73e8-84a5-98cbdb114132",
        "storage_key": "property/6767906449167553/019f38c4-ead0-73e8-84a5-98cbdb114132.webp",
        "width": 1024,
        "height": 683
      },
      "title": "Apartment",
      "description": "Thumbnail 25 of 35 - Kitchen And Living Area at Fitzroy Grove, Rogers, AR",
      "link": "false",
      "alt_text": "Thumbnail 25 of 35 - Kitchen And Living Area at Fitzroy Grove, Rogers, AR",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://resource.rentcafe.com/image/upload/s3/2/212041/p1744377_54_1_photogallery.jpg"
    },
    {
      "id": "ec_0ea4c7891c828fb2acbda24d",
      "source": "generator",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167553",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167553/019f38c4-f00f-70ce-8eb6-3397d7b170b9.webp",
      "image_media": {
        "alt_text": "Thumbnail 26 of 35 - Kitchen And Living Room View at Fitzroy Grove, Rogers, AR",
        "public_id": "019f38c4-f00f-70ce-8eb6-3397d7b170b9",
        "storage_key": "property/6767906449167553/019f38c4-f00f-70ce-8eb6-3397d7b170b9.webp",
        "width": 1024,
        "height": 396
      },
      "title": "Apartment",
      "description": "Thumbnail 26 of 35 - Kitchen And Living Room View at Fitzroy Grove, Rogers, AR",
      "link": "false",
      "alt_text": "Thumbnail 26 of 35 - Kitchen And Living Room View at Fitzroy Grove, Rogers, AR",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://resource.rentcafe.com/image/upload/s3/2/212041/p1744377_55_1_photogallery.jpg"
    },
    {
      "id": "ec_c85ca7eddad4907a6e2b47f0",
      "source": "generator",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167553",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167553/019f38c4-f07a-7348-b608-5d8f93812469.webp",
      "image_media": {
        "alt_text": "Thumbnail 27 of 35 - Clubroom With Kitchen at Fitzroy Grove, Rogers, Arkansas",
        "public_id": "019f38c4-f07a-7348-b608-5d8f93812469",
        "storage_key": "property/6767906449167553/019f38c4-f07a-7348-b608-5d8f93812469.webp",
        "width": 1024,
        "height": 683
      },
      "title": "Apartment",
      "description": "Thumbnail 27 of 35 - Clubroom With Kitchen at Fitzroy Grove, Rogers, Arkansas",
      "link": "false",
      "alt_text": "Thumbnail 27 of 35 - Clubroom With Kitchen at Fitzroy Grove, Rogers, Arkansas",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://resource.rentcafe.com/image/upload/s3/2/212041/p1744377_57_1_photogallery.jpg"
    },
    {
      "id": "ec_5bbc56b969d30cc1f5ce4636",
      "source": "generator",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167553",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167553/019f38c4-f381-7382-a822-47fa39769a1b.webp",
      "image_media": {
        "alt_text": "Thumbnail 28 of 35 - a kitchen with a large island with three chairs at Fitzroy Grove, Rogers, 72758",
        "public_id": "019f38c4-f381-7382-a822-47fa39769a1b",
        "storage_key": "property/6767906449167553/019f38c4-f381-7382-a822-47fa39769a1b.webp",
        "width": 1024,
        "height": 1325
      },
      "title": "Apartment",
      "description": "Thumbnail 28 of 35 - a kitchen with a large island with three chairs at Fitzroy Grove, Rogers, 72758",
      "link": "false",
      "alt_text": "Thumbnail 28 of 35 - a kitchen with a large island with three chairs at Fitzroy Grove, Rogers, 72758",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://resource.rentcafe.com/image/upload/s3/2/212041/p1744377_61_1_photogallery.jpg"
    },
    {
      "id": "ec_784a76cd52cded2ce2b1f6a2",
      "source": "generator",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167553",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167553/019f38c4-f38a-74da-9ed3-1daae18a3b23.webp",
      "image_media": {
        "alt_text": "Thumbnail 29 of 35 - a kitchen with white cabinets and stainless steel appliances at Fitzroy Grove, Rogers, AR, 72758",
        "public_id": "019f38c4-f38a-74da-9ed3-1daae18a3b23",
        "storage_key": "property/6767906449167553/019f38c4-f38a-74da-9ed3-1daae18a3b23.webp",
        "width": 1024,
        "height": 683
      },
      "title": "Apartment",
      "description": "Thumbnail 29 of 35 - a kitchen with white cabinets and stainless steel appliances at Fitzroy Grove, Rogers, AR, 72758",
      "link": "false",
      "alt_text": "Thumbnail 29 of 35 - a kitchen with white cabinets and stainless steel appliances at Fitzroy Grove, Rogers, AR, 72758",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://resource.rentcafe.com/image/upload/s3/2/212041/p1744377_63_1_photogallery.jpg"
    },
    {
      "id": "ec_5cbe1b3ed8fdb6d357dd231c",
      "source": "generator",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167553",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167553/019f38c4-f492-75fd-825b-28dfffb3dbbc.webp",
      "image_media": {
        "alt_text": "Thumbnail 30 of 35 - an open kitchen and living room area with a dining table at Fitzroy Grove, Rogers, AR",
        "public_id": "019f38c4-f492-75fd-825b-28dfffb3dbbc",
        "storage_key": "property/6767906449167553/019f38c4-f492-75fd-825b-28dfffb3dbbc.webp",
        "width": 1024,
        "height": 683
      },
      "title": "Apartment",
      "description": "Thumbnail 30 of 35 - an open kitchen and living room area with a dining table at Fitzroy Grove, Rogers, AR",
      "link": "false",
      "alt_text": "Thumbnail 30 of 35 - an open kitchen and living room area with a dining table at Fitzroy Grove, Rogers, AR",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://resource.rentcafe.com/image/upload/s3/2/212041/p1744377_65_1_photogallery.jpg"
    },
    {
      "id": "ec_10908dcf23cecc04a5f13bbe",
      "source": "generator",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167553",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167553/019f38c4-f5f4-701f-9db8-b98341339c10.webp",
      "image_media": {
        "alt_text": "Thumbnail 31 of 35 - Bedroom Interior at Fitzroy Grove, Arkansas",
        "public_id": "019f38c4-f5f4-701f-9db8-b98341339c10",
        "storage_key": "property/6767906449167553/019f38c4-f5f4-701f-9db8-b98341339c10.webp",
        "width": 1024,
        "height": 683
      },
      "title": "Apartment",
      "description": "Thumbnail 31 of 35 - Bedroom Interior at Fitzroy Grove, Arkansas",
      "link": "false",
      "alt_text": "Thumbnail 31 of 35 - Bedroom Interior at Fitzroy Grove, Arkansas",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://resource.rentcafe.com/image/upload/s3/2/212041/p1744377_68_1_photogallery.jpg"
    },
    {
      "id": "ec_8213643f24b0302f96b6be3a",
      "source": "generator",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167553",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167553/019f38c4-f624-704e-9659-a592b6e05c2c.webp",
      "image_media": {
        "alt_text": "Thumbnail 32 of 35 - Spacious Bedroom at Fitzroy Grove, Rogers, 72758",
        "public_id": "019f38c4-f624-704e-9659-a592b6e05c2c",
        "storage_key": "property/6767906449167553/019f38c4-f624-704e-9659-a592b6e05c2c.webp",
        "width": 1024,
        "height": 683
      },
      "title": "Apartment",
      "description": "Thumbnail 32 of 35 - Spacious Bedroom at Fitzroy Grove, Rogers, 72758",
      "link": "false",
      "alt_text": "Thumbnail 32 of 35 - Spacious Bedroom at Fitzroy Grove, Rogers, 72758",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://resource.rentcafe.com/image/upload/s3/2/212041/p1744377_69_1_photogallery.jpg"
    },
    {
      "id": "ec_b7b2c204accc67d80bb879f2",
      "source": "generator",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167553",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167553/019f38c4-fa6a-75fa-8919-bc927a524ac3.webp",
      "image_media": {
        "alt_text": "Thumbnail 33 of 35 - Washer Dryer In Unit at Fitzroy Grove, Arkansas, 72758",
        "public_id": "019f38c4-fa6a-75fa-8919-bc927a524ac3",
        "storage_key": "property/6767906449167553/019f38c4-fa6a-75fa-8919-bc927a524ac3.webp",
        "width": 1024,
        "height": 1325
      },
      "title": "Apartment",
      "description": "Thumbnail 33 of 35 - Washer Dryer In Unit at Fitzroy Grove, Arkansas, 72758",
      "link": "false",
      "alt_text": "Thumbnail 33 of 35 - Washer Dryer In Unit at Fitzroy Grove, Arkansas, 72758",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://resource.rentcafe.com/image/upload/s3/2/212041/p1744377_71_1_photogallery.jpg"
    },
    {
      "id": "ec_5afb3bdba527898d90ccc96d",
      "source": "generator",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167553",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167553/019f38c4-fa74-74be-b246-e1f40ae9c516.webp",
      "image_media": {
        "alt_text": "Thumbnail 34 of 35 - Vanity Lights at Fitzroy Grove, Rogers, Arkansas",
        "public_id": "019f38c4-fa74-74be-b246-e1f40ae9c516",
        "storage_key": "property/6767906449167553/019f38c4-fa74-74be-b246-e1f40ae9c516.webp",
        "width": 1024,
        "height": 683
      },
      "title": "Apartment",
      "description": "Thumbnail 34 of 35 - Vanity Lights at Fitzroy Grove, Rogers, Arkansas",
      "link": "false",
      "alt_text": "Thumbnail 34 of 35 - Vanity Lights at Fitzroy Grove, Rogers, Arkansas",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://resource.rentcafe.com/image/upload/s3/2/212041/p1744377_73_1_photogallery.jpg"
    },
    {
      "id": "ec_c2e4ab86d598f81c0e5d5aa9",
      "source": "generator",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167553",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167553/019f38c4-fba6-73dd-befd-309b27fc3817.webp",
      "image_media": {
        "alt_text": "Thumbnail 35 of 35 - a white bathroom with a tub and a shower curtain at Fitzroy Grove, Rogers, AR, 72758",
        "public_id": "019f38c4-fba6-73dd-befd-309b27fc3817",
        "storage_key": "property/6767906449167553/019f38c4-fba6-73dd-befd-309b27fc3817.webp",
        "width": 1024,
        "height": 1325
      },
      "title": "Apartment",
      "description": "Thumbnail 35 of 35 - a white bathroom with a tub and a shower curtain at Fitzroy Grove, Rogers, AR, 72758",
      "link": "false",
      "alt_text": "Thumbnail 35 of 35 - a white bathroom with a tub and a shower curtain at Fitzroy Grove, Rogers, AR, 72758",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://resource.rentcafe.com/image/upload/s3/2/212041/p1744377_75_1_photogallery.jpg"
    },
    {
      "id": "ec_34cef65821c8e160e0e511b5",
      "source": "generator",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167553",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167553/019f38c4-fc23-76ab-8825-66045a7158e5.webp",
      "image_media": {
        "alt_text": "STEWARD + HELM\" Logo",
        "public_id": "019f38c4-fc23-76ab-8825-66045a7158e5",
        "storage_key": "property/6767906449167553/019f38c4-fc23-76ab-8825-66045a7158e5.webp",
        "width": 1546,
        "height": 354
      },
      "title": "Logo",
      "description": "STEWARD + HELM\" Logo",
      "link": "false",
      "alt_text": "STEWARD + HELM\" Logo",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://resource.rentcafe.com/image/upload/s3/2/212041/steward-helm-white-footerimagewithtm.png"
    },
    {
      "id": "ec_42d748518fe22c6f80347c02",
      "source": "generator",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167553",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167553/019f38c5-0091-755a-b40a-7e0e10487c44.webp",
      "image_media": {
        "alt_text": "FRS1 Floor Plan at Fitzroy Grove, Rogers, AR, 72758",
        "public_id": "019f38c5-0091-755a-b40a-7e0e10487c44",
        "storage_key": "property/6767906449167553/019f38c5-0091-755a-b40a-7e0e10487c44.webp",
        "width": 640,
        "height": 480
      },
      "title": "Floorplan",
      "description": "FRS1 Floor Plan",
      "link": "false",
      "alt_text": "FRS1 Floor Plan at Fitzroy Grove, Rogers, AR, 72758",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://resource.rentcafe.com/image/upload/s3/2/212041/ar_rogers_fitzroygrovelxv_p1744377_frs1_2_floorplan.jpg"
    },
    {
      "id": "ec_cb08f80facb45d102b261be8",
      "source": "generator",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167553",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167553/019f38c5-0057-7539-ab6e-924a8e58e8cc.webp",
      "image_media": {
        "alt_text": "FRA1 Floor Plan at Fitzroy Grove, Rogers, AR",
        "public_id": "019f38c5-0057-7539-ab6e-924a8e58e8cc",
        "storage_key": "property/6767906449167553/019f38c5-0057-7539-ab6e-924a8e58e8cc.webp",
        "width": 640,
        "height": 480
      },
      "title": "Floorplan",
      "description": "FRA1 Floor Plan",
      "link": "false",
      "alt_text": "FRA1 Floor Plan at Fitzroy Grove, Rogers, AR",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://resource.rentcafe.com/image/upload/s3/2/212041/ar_rogers_fitzroygrovelxv_p1744377_fra1_2_floorplan.jpg"
    },
    {
      "id": "ec_2bae4704978a777b8e1ae619",
      "source": "generator",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167553",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167553/019f38c5-0162-71a8-a87a-4a71048ff50c.webp",
      "image_media": {
        "alt_text": "FRA2 Floor Plan at Fitzroy Grove, Rogers, 72758",
        "public_id": "019f38c5-0162-71a8-a87a-4a71048ff50c",
        "storage_key": "property/6767906449167553/019f38c5-0162-71a8-a87a-4a71048ff50c.webp",
        "width": 640,
        "height": 480
      },
      "title": "Floorplan",
      "description": "FRA2 Floor Plan",
      "link": "false",
      "alt_text": "FRA2 Floor Plan at Fitzroy Grove, Rogers, 72758",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://resource.rentcafe.com/image/upload/s3/2/212041/ar_rogers_fitzroygrovelxv_p1744377_fra2_2_floorplan.jpg"
    },
    {
      "id": "ec_7b0a379bb0183b1e2d9cf3a7",
      "source": "generator",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167553",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167553/019f38c5-026b-75dc-9f17-1f9731aa5f71.webp",
      "image_media": {
        "alt_text": "FRB2 Floor Plan at Fitzroy Grove, Rogers",
        "public_id": "019f38c5-026b-75dc-9f17-1f9731aa5f71",
        "storage_key": "property/6767906449167553/019f38c5-026b-75dc-9f17-1f9731aa5f71.webp",
        "width": 640,
        "height": 480
      },
      "title": "Floorplan",
      "description": "FRB2 Floor Plan",
      "link": "false",
      "alt_text": "FRB2 Floor Plan at Fitzroy Grove, Rogers",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://resource.rentcafe.com/image/upload/s3/2/212041/ar_rogers_fitzroygrovelxv_p1744377_frb2_2_floorplan.jpg"
    },
    {
      "id": "ec_fb64de0adf44891d352eb1ed",
      "source": "generator",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167553",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167553/019f38c5-0325-73dc-9d1d-33b0f8179af2.webp",
      "image_media": {
        "alt_text": "FRB3 Floor Plan at Fitzroy Grove, Arkansas",
        "public_id": "019f38c5-0325-73dc-9d1d-33b0f8179af2",
        "storage_key": "property/6767906449167553/019f38c5-0325-73dc-9d1d-33b0f8179af2.webp",
        "width": 640,
        "height": 480
      },
      "title": "Floorplan",
      "description": "FRB3 Floor Plan",
      "link": "false",
      "alt_text": "FRB3 Floor Plan at Fitzroy Grove, Arkansas",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://resource.rentcafe.com/image/upload/s3/2/212041/ar_rogers_fitzroygrovelxv_p1744377_frb3_2_floorplan.jpg"
    },
    {
      "id": "ec_4170e6804518188d30d3b380",
      "source": "generator",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167553",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167553/019f38c5-044a-70c9-b127-5aa6d4f27287.webp",
      "image_media": {
        "alt_text": "FRB1 Floor Plan at Fitzroy Grove, Arkansas, 72758",
        "public_id": "019f38c5-044a-70c9-b127-5aa6d4f27287",
        "storage_key": "property/6767906449167553/019f38c5-044a-70c9-b127-5aa6d4f27287.webp",
        "width": 640,
        "height": 480
      },
      "title": "Floorplan",
      "description": "FRB1 Floor Plan",
      "link": "false",
      "alt_text": "FRB1 Floor Plan at Fitzroy Grove, Arkansas, 72758",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://resource.rentcafe.com/image/upload/s3/2/212041/ar_rogers_fitzroygrovelxv_p1744377_frb1_2_floorplan.jpg"
    },
    {
      "id": "ec_a9b775aa055e6485ae6e455e",
      "source": "generator",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167553",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167553/019f38c5-05c6-730b-8765-d0b1853c8367.webp",
      "image_media": {
        "alt_text": "FRC1 Floor Plan at Fitzroy Grove, Rogers, Arkansas",
        "public_id": "019f38c5-05c6-730b-8765-d0b1853c8367",
        "storage_key": "property/6767906449167553/019f38c5-05c6-730b-8765-d0b1853c8367.webp",
        "width": 640,
        "height": 480
      },
      "title": "Floorplan",
      "description": "FRC1 Floor Plan",
      "link": "false",
      "alt_text": "FRC1 Floor Plan at Fitzroy Grove, Rogers, Arkansas",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://resource.rentcafe.com/image/upload/s3/2/212041/ar_rogers_fitzroygrovelxv_p1744377_frc1_2_floorplan.jpg"
    },
    {
      "id": "ec_f47eccf49fcb1275f0e4fbfc",
      "source": "generator",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167553",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167553/019f38c5-05c7-713f-8a2e-f4a8bd21cfbf.webp",
      "image_media": {
        "alt_text": "Map showing surrounding area with roads and hospitals.",
        "public_id": "019f38c5-05c7-713f-8a2e-f4a8bd21cfbf",
        "storage_key": "property/6767906449167553/019f38c5-05c7-713f-8a2e-f4a8bd21cfbf.webp",
        "width": 512,
        "height": 512
      },
      "title": "Other",
      "description": "Map illustration of the area surrounding the property, highlighting major roads and nearby landmarks like Mercy Hospital.",
      "link": "false",
      "alt_text": "Map showing surrounding area with roads and hospitals.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://api.mapbox.com/styles/v1/mapbox/streets-v11/tiles/12/976/1604?access_token=pk.eyJ1IjoiYW5kcmVpZDIwIiwiYSI6ImNreWQ5aWZrczA3d20yb255dXYybG9vNmMifQ.RwPxuIPIFcNG61l86xw2Ww"
    },
    {
      "id": "ec_ee55e2e0e964e10388a669c2",
      "source": "generator",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167553",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167553/019f38c5-07d1-72dc-a48a-21738877f1c2.webp",
      "image_media": {
        "alt_text": "Map showing Osage Mills and Cave Springs areas.",
        "public_id": "019f38c5-07d1-72dc-a48a-21738877f1c2",
        "storage_key": "property/6767906449167553/019f38c5-07d1-72dc-a48a-21738877f1c2.webp",
        "width": 512,
        "height": 512
      },
      "title": "Other",
      "description": "A map displaying the Osage Mills and Cave Springs communities, highlighting local roads and points of interest like the West Arkansas Regional Airport.",
      "link": "false",
      "alt_text": "Map showing Osage Mills and Cave Springs areas.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://api.mapbox.com/styles/v1/mapbox/streets-v11/tiles/12/975/1604?access_token=pk.eyJ1IjoiYW5kcmVpZDIwIiwiYSI6ImNreWQ5aWZrczA3d20yb255dXYybG9vNmMifQ.RwPxuIPIFcNG61l86xw2Ww"
    },
    {
      "id": "ec_7c4b9100f872c206d881f892",
      "source": "generator",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167553",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167553/019f38c5-07a3-72ba-abc3-0f25ed39799a.webp",
      "image_media": {
        "alt_text": "Map showing Beaver Lake and surrounding roads, including Monte Ne Shores and Cross Hollow.",
        "public_id": "019f38c5-07a3-72ba-abc3-0f25ed39799a",
        "storage_key": "property/6767906449167553/019f38c5-07a3-72ba-abc3-0f25ed39799a.webp",
        "width": 512,
        "height": 512
      },
      "title": "Other",
      "description": "A map highlighting the proximity of Monte Ne Shores and Cross Hollow to Beaver Lake, with major roads visible.",
      "link": "false",
      "alt_text": "Map showing Beaver Lake and surrounding roads, including Monte Ne Shores and Cross Hollow.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://api.mapbox.com/styles/v1/mapbox/streets-v11/tiles/12/977/1604?access_token=pk.eyJ1IjoiYW5kcmVpZDIwIiwiYSI6ImNreWQ5aWZrczA3d20yb255dXYybG9vNmMifQ.RwPxuIPIFcNG61l86xw2Ww"
    },
    {
      "id": "ec_fd0f47d45ba8ac69a9747597",
      "source": "generator",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167553",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167553/019f38c5-0759-711e-80ca-659e564435b0.webp",
      "image_media": {
        "alt_text": "Map marker pin for Fitzroy Grove",
        "public_id": "019f38c5-0759-711e-80ca-659e564435b0",
        "storage_key": "property/6767906449167553/019f38c5-0759-711e-80ca-659e564435b0.webp",
        "width": 35,
        "height": 90
      },
      "title": "Other",
      "description": "Fitzroy Grove",
      "link": "false",
      "alt_text": "Map marker pin for Fitzroy Grove",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://api.mapbox.com/v4/marker/pin-l-building+000000.png?access_token=pk.eyJ1IjoiYW5kcmVpZDIwIiwiYSI6ImNreWQ5aWZrczA3d20yb255dXYybG9vNmMifQ.RwPxuIPIFcNG61l86xw2Ww"
    },
    {
      "id": "ec_8541b06f3216b67549c8208b",
      "source": "generator",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167553",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167553/019f38c5-0953-725a-bf06-252654060256.webp",
      "image_media": {
        "alt_text": "Guided Tour",
        "public_id": "019f38c5-0953-725a-bf06-252654060256",
        "storage_key": "property/6767906449167553/019f38c5-0953-725a-bf06-252654060256.webp",
        "width": 292,
        "height": 292
      },
      "title": "Other",
      "description": "Guided Tour",
      "link": "false",
      "alt_text": "Guided Tour",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://resource.rentcafe.com/image/upload/s3/c-tour-guide.svg"
    },
    {
      "id": "ec_5b44762db4e0482484591921",
      "source": "generator",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167553",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167553/019f38c5-0999-7268-9982-8a46a387115e.webp",
      "image_media": {
        "alt_text": "Live Video Tour",
        "public_id": "019f38c5-0999-7268-9982-8a46a387115e",
        "storage_key": "property/6767906449167553/019f38c5-0999-7268-9982-8a46a387115e.webp",
        "width": 292,
        "height": 292
      },
      "title": "Other",
      "description": "Live Video Tour",
      "link": "false",
      "alt_text": "Live Video Tour",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://resource.rentcafe.com/image/upload/s3/c-tour-video.svg"
    }
  ],
  "neighborhood_pois": [
    {
      "id": "custom_82079717-ece4-4ce1-aa1e-888deed7afc7",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167553",
      "source": "custom",
      "poi_name": "The Blackberry Brasserie",
      "poi_type": "Restaurants",
      "poi_address": "3300 S Pinnacle Hills Pkwy, Rogers, AR 72758, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167553/019f38c5-86f2-7759-8666-463a3dacb081.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f38c5-86f2-7759-8666-463a3dacb081",
        "storage_key": "property/6767906449167553/019f38c5-86f2-7759-8666-463a3dacb081.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "http://blackberrynwa.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=6367645129074707333&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "the-blackberry-brasserie",
      "poi_latitude": "36.3063693",
      "poi_longitude": "-94.1873265",
      "poi_miles_from_property": "2.9",
      "poi_walking_minutes": "1 hour 4 mins",
      "poi_biking_minutes": "18 mins",
      "poi_driving_minutes": "8 mins",
      "poi_business_phone": "+1 479-367-2994",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167553/019f38c3-4bc4-743d-8697-11f6d945350c.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019f38c3-4bc4-743d-8697-11f6d945350c",
        "storage_key": "property/6767906449167553/019f38c3-4bc4-743d-8697-11f6d945350c.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJG3zvKgkRyYcRhYs-9oFrXlg",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "restaurant"
    },
    {
      "id": "custom_58a93d60-74bf-4fca-adeb-0179abb8c8b5",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167553",
      "source": "custom",
      "poi_name": "The Grill at Pinnacle Hills",
      "poi_type": "Restaurants",
      "poi_address": "5001 W Pauline Whitaker Pkwy #100, Rogers, AR 72758, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167553/019f38c5-8ba8-7689-9c06-5611fa232a66.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f38c5-8ba8-7689-9c06-5611fa232a66",
        "storage_key": "property/6767906449167553/019f38c5-8ba8-7689-9c06-5611fa232a66.webp",
        "width": 1280,
        "height": 853
      },
      "poi_business_url": "",
      "poi_directions_map_url": "https://maps.google.com/?cid=15630961630962166776&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "the-grill-at-pinnacle-hills",
      "poi_latitude": "36.2979431",
      "poi_longitude": "-94.185801",
      "poi_miles_from_property": "2.4",
      "poi_walking_minutes": "52 mins",
      "poi_biking_minutes": "14 mins",
      "poi_driving_minutes": "7 mins",
      "poi_business_phone": "+1 479-899-6580",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167553/019f38c3-4bc4-743d-8697-11f6d945350c.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019f38c3-4bc4-743d-8697-11f6d945350c",
        "storage_key": "property/6767906449167553/019f38c3-4bc4-743d-8697-11f6d945350c.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJ6cQfOHMRyYcR-KtCd8lU7Ng",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "american_restaurant"
    },
    {
      "id": "custom_37d91222-14c2-4b00-82ab-d194d030252e",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167553",
      "source": "custom",
      "poi_name": "Hideaway Pizza",
      "poi_type": "Restaurants",
      "poi_address": "4886 W Pauline Whitaker Pkwy, Rogers, AR 72758, USA",
      "poi_short_description": "Local chain featuring build-your-own pies, a variety of Italian fare & a kids' menu.",
      "poi_long_description": "Local chain featuring build-your-own pies, a variety of Italian fare & a kids' menu.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167553/019f38c5-883e-76f9-adbb-3749273d659d.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f38c5-883e-76f9-adbb-3749273d659d",
        "storage_key": "property/6767906449167553/019f38c5-883e-76f9-adbb-3749273d659d.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "http://www.hideawaypizza.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=7179879957414553439&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "hideaway-pizza",
      "poi_latitude": "36.2976492",
      "poi_longitude": "-94.1809399",
      "poi_miles_from_property": "2.1",
      "poi_walking_minutes": "46 mins",
      "poi_biking_minutes": "12 mins",
      "poi_driving_minutes": "6 mins",
      "poi_business_phone": "+1 479-477-8777",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167553/019f38c3-4bc4-743d-8697-11f6d945350c.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019f38c3-4bc4-743d-8697-11f6d945350c",
        "storage_key": "property/6767906449167553/019f38c3-4bc4-743d-8697-11f6d945350c.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJGZQhSQARyYcRXyek18cOpGM",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "pizza_restaurant"
    },
    {
      "id": "custom_45b20d9f-7c43-4699-ac6a-7817d7366558",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167553",
      "source": "custom",
      "poi_name": "Ruth's Chris Steak House",
      "poi_type": "Restaurants",
      "poi_address": "5401 W Northgate Rd, Rogers, AR 72758, USA",
      "poi_short_description": "Outpost of upmarket steakhouse chain known for sizzling, butter-topped beef in an elegant setting",
      "poi_long_description": "Outpost of upmarket steakhouse chain known for sizzling, butter-topped beef in an elegant setting",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167553/019f38c5-8d9b-7768-ac54-1a4dda320fd3.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f38c5-8d9b-7768-ac54-1a4dda320fd3",
        "storage_key": "property/6767906449167553/019f38c5-8d9b-7768-ac54-1a4dda320fd3.webp",
        "width": 1280,
        "height": 854
      },
      "poi_business_url": "https://www.ruthschrisphg.com/rogers",
      "poi_directions_map_url": "https://maps.google.com/?cid=10428203938960237312&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "ruths-chris-steak-house",
      "poi_latitude": "36.3052544",
      "poi_longitude": "-94.1900383",
      "poi_miles_from_property": "3",
      "poi_walking_minutes": "1 hour 6 mins",
      "poi_biking_minutes": "18 mins",
      "poi_driving_minutes": "8 mins",
      "poi_business_phone": "+1 479-633-8331",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167553/019f38c3-4bc4-743d-8697-11f6d945350c.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019f38c3-4bc4-743d-8697-11f6d945350c",
        "storage_key": "property/6767906449167553/019f38c3-4bc4-743d-8697-11f6d945350c.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJs4MO4AsRyYcRAOMNQztsuJA",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "restaurant"
    },
    {
      "id": "custom_de3ebf48-d9bf-4631-8fb0-32be80514303",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167553",
      "source": "custom",
      "poi_name": "Big Orange | Rogers",
      "poi_type": "Restaurants",
      "poi_address": "2203 S Promenade Blvd #3100, Rogers, AR 72758, USA",
      "poi_short_description": "Bright & modern joint serving up creative burgers & salads, with handmade shakes & craft beers.",
      "poi_long_description": "Bright & modern joint serving up creative burgers & salads, with handmade shakes & craft beers.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167553/019f38c5-8762-724a-8e5d-354cffd48bb6.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f38c5-8762-724a-8e5d-354cffd48bb6",
        "storage_key": "property/6767906449167553/019f38c5-8762-724a-8e5d-354cffd48bb6.webp",
        "width": 953,
        "height": 591
      },
      "poi_business_url": "http://www.bigorangeburger.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=1032138039371757188&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "big-orange--rogers",
      "poi_latitude": "36.3036794",
      "poi_longitude": "-94.1754964",
      "poi_miles_from_property": "2",
      "poi_walking_minutes": "44 mins",
      "poi_biking_minutes": "11 mins",
      "poi_driving_minutes": "6 mins",
      "poi_business_phone": "+1 479-202-5339",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167553/019f38c3-4bc4-743d-8697-11f6d945350c.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019f38c3-4bc4-743d-8697-11f6d945350c",
        "storage_key": "property/6767906449167553/019f38c3-4bc4-743d-8697-11f6d945350c.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJMwWgIxQRyYcRhPbrCxTkUg4",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "restaurant"
    },
    {
      "id": "custom_135c88d8-c2ab-4f06-8d8b-0509d5cbbcf5",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167553",
      "source": "custom",
      "poi_name": "Local Lime",
      "poi_type": "Restaurants",
      "poi_address": "2103 S Promenade Blvd, Rogers, AR 72758, USA",
      "poi_short_description": "Locally sourced ingredients go into the fresh Mexican dishes at this casual restaurant.",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167553/019f38c5-87d0-75cd-a872-cc9d41599ad6.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f38c5-87d0-75cd-a872-cc9d41599ad6",
        "storage_key": "property/6767906449167553/019f38c5-87d0-75cd-a872-cc9d41599ad6.webp",
        "width": 1280,
        "height": 948
      },
      "poi_business_url": "http://www.locallimetaco.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=7008082005031098772&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "local-lime",
      "poi_latitude": "36.3054078",
      "poi_longitude": "-94.1773431",
      "poi_miles_from_property": "2.2",
      "poi_walking_minutes": "48 mins",
      "poi_biking_minutes": "11 mins",
      "poi_driving_minutes": "7 mins",
      "poi_business_phone": "+1 479-903-7300",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167553/019f38c3-4bc4-743d-8697-11f6d945350c.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019f38c3-4bc4-743d-8697-11f6d945350c",
        "storage_key": "property/6767906449167553/019f38c3-4bc4-743d-8697-11f6d945350c.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJ277g6fQRyYcRlJmvAnS1QWE",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "mexican_restaurant"
    },
    {
      "id": "custom_c46ea99e-573d-4ecd-b48c-cafed41abf3e",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167553",
      "source": "custom",
      "poi_name": "Artisan Wood Fired Kitchen",
      "poi_type": "Restaurants",
      "poi_address": "2203 S Promenade Blvd #3110, Rogers, AR 72758, USA",
      "poi_short_description": "Lively pizzeria featuring wood-fired pies, pastas, appetizers and gluten-free options.",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167553/019f38c5-8536-715e-b347-1c1e572ac093.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f38c5-8536-715e-b347-1c1e572ac093",
        "storage_key": "property/6767906449167553/019f38c5-8536-715e-b347-1c1e572ac093.webp",
        "width": 1000,
        "height": 667
      },
      "poi_business_url": "https://artisanwoodfiredkitchen.com/?utm_source=google",
      "poi_directions_map_url": "https://maps.google.com/?cid=13380041684103572094&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "artisan-wood-fired-kitchen",
      "poi_latitude": "36.3037743",
      "poi_longitude": "-94.1754255",
      "poi_miles_from_property": "2.1",
      "poi_walking_minutes": "44 mins",
      "poi_biking_minutes": "11 mins",
      "poi_driving_minutes": "6 mins",
      "poi_business_phone": "+1 479-877-6732",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167553/019f38c3-4bc4-743d-8697-11f6d945350c.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019f38c3-4bc4-743d-8697-11f6d945350c",
        "storage_key": "property/6767906449167553/019f38c3-4bc4-743d-8697-11f6d945350c.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJK8pwchERyYcRfqrpbAV1r7k",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "pizza_restaurant"
    },
    {
      "id": "custom_ca607c6c-9ee8-47dd-bae2-0e43c083535b",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167553",
      "source": "custom",
      "poi_name": "Bonefish Grill",
      "poi_type": "Restaurants",
      "poi_address": "3201 S Market St, Rogers, AR 72758, USA",
      "poi_short_description": "Contemporary grill chain offering a seafood-centric menu, plus steaks & cocktails.",
      "poi_long_description": "Contemporary grill chain offering a seafood-centric menu, plus steaks & cocktails.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167553/019f38c5-88e7-74a8-8b95-4159e445152c.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f38c5-88e7-74a8-8b95-4159e445152c",
        "storage_key": "property/6767906449167553/019f38c5-88e7-74a8-8b95-4159e445152c.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://locations.bonefishgrill.com/arkansas/rogers/3201-market-street?y_source=1_MTU1MDI3MjEtNzE1LWxvY2F0aW9uLndlYnNpdGU%3D",
      "poi_directions_map_url": "https://maps.google.com/?cid=4220863620579458576&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "bonefish-grill",
      "poi_latitude": "36.3071944",
      "poi_longitude": "-94.1882103",
      "poi_miles_from_property": "3.1",
      "poi_walking_minutes": "1 hour 7 mins",
      "poi_biking_minutes": "18 mins",
      "poi_driving_minutes": "10 mins",
      "poi_business_phone": "+1 479-273-0916",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167553/019f38c3-4bc4-743d-8697-11f6d945350c.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019f38c3-4bc4-743d-8697-11f6d945350c",
        "storage_key": "property/6767906449167553/019f38c3-4bc4-743d-8697-11f6d945350c.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJzTGLxAgRyYcREP4BjhmFkzo",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "seafood_restaurant"
    },
    {
      "id": "custom_3bd6167f-fc6e-412a-bec2-a52a7bc726ad",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167553",
      "source": "custom",
      "poi_name": "Fish City Grill",
      "poi_type": "Restaurants",
      "poi_address": "2003 S Bellview Rd, Rogers, AR 72758, USA",
      "poi_short_description": "Easygoing chain outpost dishing up Southern-style seafood with daily chalkboard specials.",
      "poi_long_description": "Easygoing chain outpost dishing up Southern-style seafood with daily chalkboard specials.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167553/019f38c5-8536-715e-b347-212023ec9716.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f38c5-8536-715e-b347-212023ec9716",
        "storage_key": "property/6767906449167553/019f38c5-8536-715e-b347-212023ec9716.webp",
        "width": 1280,
        "height": 720
      },
      "poi_business_url": "https://fishcitygrill.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=8171458314084480286&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "fish-city-grill",
      "poi_latitude": "36.311405",
      "poi_longitude": "-94.1721189",
      "poi_miles_from_property": "2.5",
      "poi_walking_minutes": "53 mins",
      "poi_biking_minutes": "12 mins",
      "poi_driving_minutes": "6 mins",
      "poi_business_phone": "+1 479-636-8833",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167553/019f38c3-4bc4-743d-8697-11f6d945350c.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019f38c3-4bc4-743d-8697-11f6d945350c",
        "storage_key": "property/6767906449167553/019f38c3-4bc4-743d-8697-11f6d945350c.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJHXDcZhYRyYcRHvXq2wraZnE",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "seafood_restaurant"
    },
    {
      "id": "custom_6968d7c8-5398-4066-b24c-54715798fbac",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167553",
      "source": "custom",
      "poi_name": "Onyx Coffee Lab - Rogers HQ",
      "poi_type": "Restaurants",
      "poi_address": "101 E Walnut St, Rogers, AR 72756, USA",
      "poi_short_description": "Coffeehouse providing espresso drinks made with locally roasted, carefully sourced beans.",
      "poi_long_description": "Coffeehouse providing espresso drinks made with locally roasted, carefully sourced beans.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167553/019f38c5-8697-7649-b06c-e99262dff3bc.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f38c5-8697-7649-b06c-e99262dff3bc",
        "storage_key": "property/6767906449167553/019f38c5-8697-7649-b06c-e99262dff3bc.webp",
        "width": 1280,
        "height": 720
      },
      "poi_business_url": "https://onyxcoffeelab.com/pages/rogers",
      "poi_directions_map_url": "https://maps.google.com/?cid=14602560282996906045&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "onyx-coffee-lab---rogers-hq",
      "poi_latitude": "36.3331906",
      "poi_longitude": "-94.1159044",
      "poi_miles_from_property": "5.1",
      "poi_walking_minutes": "1 hour 52 mins",
      "poi_biking_minutes": "28 mins",
      "poi_driving_minutes": "13 mins",
      "poi_business_phone": "+1 479-899-6750",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167553/019f38c5-cd79-740f-b06c-e4f8fc131721.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019f38c5-cd79-740f-b06c-e4f8fc131721",
        "storage_key": "property/6767906449167553/019f38c5-cd79-740f-b06c-e4f8fc131721.webp",
        "width": 192,
        "height": 144
      },
      "poi_google_place_id": "ChIJ69YkJF8XyYcRPRhCrzW3pso",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "coffee_shop"
    },
    {
      "id": "custom_5aab274c-46c8-45f3-ae2d-717b53731d37",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167553",
      "source": "custom",
      "poi_name": "Iron Horse Coffee Company",
      "poi_type": "Restaurants",
      "poi_address": "220 S 1st St, Rogers, AR 72756, USA",
      "poi_short_description": "Casual coffee shop with sandwiches and a cozy area for reading or working upstairs.",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167553/019f38c5-91b0-77ac-8235-bfc618295172.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f38c5-91b0-77ac-8235-bfc618295172",
        "storage_key": "property/6767906449167553/019f38c5-91b0-77ac-8235-bfc618295172.webp",
        "width": 1280,
        "height": 853
      },
      "poi_business_url": "https://www.ironhorsecoffee.net/",
      "poi_directions_map_url": "https://maps.google.com/?cid=9639535987301849921&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "iron-horse-coffee-company",
      "poi_latitude": "36.3313487",
      "poi_longitude": "-94.1166172",
      "poi_miles_from_property": "4.9",
      "poi_walking_minutes": "1 hour 49 mins",
      "poi_biking_minutes": "27 mins",
      "poi_driving_minutes": "12 mins",
      "poi_business_phone": "+1 479-631-9977",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167553/019f38c5-cd79-740f-b06c-e4f8fc131721.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019f38c5-cd79-740f-b06c-e4f8fc131721",
        "storage_key": "property/6767906449167553/019f38c5-cd79-740f-b06c-e4f8fc131721.webp",
        "width": 192,
        "height": 144
      },
      "poi_google_place_id": "ChIJsecixAUXyYcRQZu4cuiCxoU",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "coffee_shop"
    },
    {
      "id": "custom_c4821913-df0c-4fd9-9f90-8419b8019cdf",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167553",
      "source": "custom",
      "poi_name": "Bariola's Pizzeria",
      "poi_type": "Restaurants",
      "poi_address": "1728 S 46th St #101, Rogers, AR 72758, USA",
      "poi_short_description": "Casual pizza spot with thin-crust pies and salads offering carryout and delivery.",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167553/019f38c5-8ed4-73ff-bd94-bd7cb07bceb1.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f38c5-8ed4-73ff-bd94-bd7cb07bceb1",
        "storage_key": "property/6767906449167553/019f38c5-8ed4-73ff-bd94-bd7cb07bceb1.webp",
        "width": 600,
        "height": 438
      },
      "poi_business_url": "https://www.bariolas.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=10787472065404679132&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "bariolas-pizzeria",
      "poi_latitude": "36.3151646",
      "poi_longitude": "-94.181756",
      "poi_miles_from_property": "3",
      "poi_walking_minutes": "1 hour 5 mins",
      "poi_biking_minutes": "18 mins",
      "poi_driving_minutes": "8 mins",
      "poi_business_phone": "+1 479-636-0088",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167553/019f38c3-4bc4-743d-8697-11f6d945350c.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019f38c3-4bc4-743d-8697-11f6d945350c",
        "storage_key": "property/6767906449167553/019f38c3-4bc4-743d-8697-11f6d945350c.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJf7-0WorKRIYR3DPlYrDMtJU",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "restaurant"
    },
    {
      "id": "custom_e273d44d-9cc2-4c80-8e93-8cc2bedc5491",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167553",
      "source": "custom",
      "poi_name": "El Rinconcito",
      "poi_type": "Restaurants",
      "poi_address": "1803 S 8th St Ste 10, Rogers, AR 72756, USA",
      "poi_short_description": "Casual restaurant serving a range of traditional Mexican eats, including breakfast, and a good selection of beer.",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167553/019f38c5-91b0-77ac-8235-ba1b466dffa4.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f38c5-91b0-77ac-8235-ba1b466dffa4",
        "storage_key": "property/6767906449167553/019f38c5-91b0-77ac-8235-ba1b466dffa4.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "",
      "poi_directions_map_url": "https://maps.google.com/?cid=1288756187849582016&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "el-rinconcito",
      "poi_latitude": "36.3143527",
      "poi_longitude": "-94.1255489",
      "poi_miles_from_property": "3.3",
      "poi_walking_minutes": "1 hour 13 mins",
      "poi_biking_minutes": "18 mins",
      "poi_driving_minutes": "8 mins",
      "poi_business_phone": "+1 479-372-4054",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167553/019f38c3-4bc4-743d-8697-11f6d945350c.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019f38c3-4bc4-743d-8697-11f6d945350c",
        "storage_key": "property/6767906449167553/019f38c3-4bc4-743d-8697-11f6d945350c.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJBdJqGWMXyYcRwGXcuuyU4hE",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "restaurant"
    },
    {
      "id": "custom_253d8d30-9e77-49e7-a51e-00c9b58d21ae",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167553",
      "source": "custom",
      "poi_name": "Walmart Supercenter",
      "poi_type": "Shopping & Retail",
      "poi_address": "4208 S Pleasant Crossing Blvd, Rogers, AR 72758, USA",
      "poi_short_description": "Clean spot for groceries, home goods, apparel, electronics and toys, plus pharmacy & bakery.",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167553/019f38c5-94c2-7731-9259-9cb45f3b5ccd.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f38c5-94c2-7731-9259-9cb45f3b5ccd",
        "storage_key": "property/6767906449167553/019f38c5-94c2-7731-9259-9cb45f3b5ccd.webp",
        "width": 1067,
        "height": 600
      },
      "poi_business_url": "https://www.walmart.com/store/5260-rogers-ar/?veh=seo_loc",
      "poi_directions_map_url": "https://maps.google.com/?cid=11144056474294068001&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "walmart-supercenter",
      "poi_latitude": "36.2788311",
      "poi_longitude": "-94.1512165",
      "poi_miles_from_property": "0.9",
      "poi_walking_minutes": "19 mins",
      "poi_biking_minutes": "5 mins",
      "poi_driving_minutes": "5 mins",
      "poi_business_phone": "+1 479-621-9769",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167553/019f38c3-4bc3-777d-9c52-2b0243e394d3.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019f38c3-4bc3-777d-9c52-2b0243e394d3",
        "storage_key": "property/6767906449167553/019f38c3-4bc3-777d-9c52-2b0243e394d3.webp",
        "width": 192,
        "height": 177
      },
      "poi_google_place_id": "ChIJXXmk0lQRyYcRIaMw01Gkp5o",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "department_store"
    },
    {
      "id": "custom_ca4d4623-c663-44e1-91f9-4f83e60a6dd4",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167553",
      "source": "custom",
      "poi_name": "Walmart Neighborhood Market",
      "poi_type": "Shopping & Retail",
      "poi_address": "Neighborhood Market #3479, 1819 S 8th St, Rogers, AR 72756, USA",
      "poi_short_description": "Neighborhood grocery outlet with a deli and pharmacy, plus electronics and other merchandise.",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167553/019f38c5-91fd-7467-b998-9c802b9f0102.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f38c5-91fd-7467-b998-9c802b9f0102",
        "storage_key": "property/6767906449167553/019f38c5-91fd-7467-b998-9c802b9f0102.webp",
        "width": 1280,
        "height": 720
      },
      "poi_business_url": "https://www.walmart.com/store/3479-rogers-ar/?veh=seo_loc",
      "poi_directions_map_url": "https://maps.google.com/?cid=17089699603379268895&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "walmart-neighborhood-market",
      "poi_latitude": "36.3132437",
      "poi_longitude": "-94.1243516",
      "poi_miles_from_property": "3.3",
      "poi_walking_minutes": "1 hour 13 mins",
      "poi_biking_minutes": "18 mins",
      "poi_driving_minutes": "9 mins",
      "poi_business_phone": "+1 479-633-0772",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167553/019f38c5-cda7-70c8-8045-027f476bb53a.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019f38c5-cda7-70c8-8045-027f476bb53a",
        "storage_key": "property/6767906449167553/019f38c5-cda7-70c8-8045-027f476bb53a.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJ4bbxu-UWyYcRHy2OgT7PKu0",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "grocery_store"
    },
    {
      "id": "custom_f5b82387-f15f-4a74-b5d2-28c845b0a055",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167553",
      "source": "custom",
      "poi_name": "Walgreens",
      "poi_type": "Health and Wellness",
      "poi_address": "2503 W Pleasant Grove Rd, Rogers, AR 72758, USA",
      "poi_short_description": "Drugstore chain with health & beauty aids, prescriptions & photo services, plus mini-mart basics.",
      "poi_long_description": "Drugstore chain with health & beauty aids, prescriptions & photo services, plus mini-mart basics.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167553/019f38c5-9245-7468-bd94-81fa5822c6cd.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f38c5-9245-7468-bd94-81fa5822c6cd",
        "storage_key": "property/6767906449167553/019f38c5-9245-7468-bd94-81fa5822c6cd.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://www.walgreens.com/locator/walgreens-2503+w+pleasant+grove+rd-rogers-ar-72758/id=9813",
      "poi_directions_map_url": "https://maps.google.com/?cid=14423828213554263818&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "walgreens",
      "poi_latitude": "36.283795",
      "poi_longitude": "-94.15125",
      "poi_miles_from_property": "0.5",
      "poi_walking_minutes": "12 mins",
      "poi_biking_minutes": "3 mins",
      "poi_driving_minutes": "3 mins",
      "poi_business_phone": "+1 479-936-8079",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167553/019f38c3-4bc5-7718-bc97-cba8ecefb0bb.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019f38c3-4bc5-7718-bc97-cba8ecefb0bb",
        "storage_key": "property/6767906449167553/019f38c3-4bc5-7718-bc97-cba8ecefb0bb.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJ38ehrqwWyYcRCrco6la7K8g",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "drugstore"
    },
    {
      "id": "custom_cc1f06d4-0284-4fb9-b0b0-ff43c9307d66",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167553",
      "source": "custom",
      "poi_name": "Debbie's Family Pharmacy",
      "poi_type": "Health and Wellness",
      "poi_address": "5403 W Pinnacle Pointe Dr, Rogers, AR 72758, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167553/019f38c5-97e3-70da-acf1-1974cb9eba2c.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f38c5-97e3-70da-acf1-1974cb9eba2c",
        "storage_key": "property/6767906449167553/019f38c5-97e3-70da-acf1-1974cb9eba2c.webp",
        "width": 1280,
        "height": 949
      },
      "poi_business_url": "http://www.debbiesfamilypharmacy.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=10400612474775195199&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "debbies-family-pharmacy",
      "poi_latitude": "36.3123322",
      "poi_longitude": "-94.1868096",
      "poi_miles_from_property": "3.3",
      "poi_walking_minutes": "1 hour 12 mins",
      "poi_biking_minutes": "20 mins",
      "poi_driving_minutes": "8 mins",
      "poi_business_phone": "+1 479-271-6300",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167553/019f38c5-cd62-768e-8319-9aaa96f703dc.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019f38c5-cd62-768e-8319-9aaa96f703dc",
        "storage_key": "property/6767906449167553/019f38c5-cd62-768e-8319-9aaa96f703dc.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJG0DjgwYRyYcRP8545fBlVpA",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "pharmacy"
    },
    {
      "id": "custom_63a194b4-dd4d-4de4-8ad9-347c59e49692",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167553",
      "source": "custom",
      "poi_name": "Casey's",
      "poi_type": "Shopping & Retail",
      "poi_address": "3075 W Pleasant Grove Rd, Rogers, AR 72758, USA",
      "poi_short_description": "Convenience-store chain offering fuel, drinks & food, including pizza, sandwiches & baked goods.",
      "poi_long_description": "Convenience-store chain offering fuel, drinks & food, including pizza, sandwiches & baked goods.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167553/019f38c5-9643-756c-806c-7c91da6bbcf4.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f38c5-9643-756c-806c-7c91da6bbcf4",
        "storage_key": "property/6767906449167553/019f38c5-9643-756c-806c-7c91da6bbcf4.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://www.caseys.com/general-store/ar-rogers/3075-w-pleasant-grove-rd/3207?utm_medium=organic&utm_source=google&utm_campaign=DAC",
      "poi_directions_map_url": "https://maps.google.com/?cid=2506663101756128058&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "caseys",
      "poi_latitude": "36.2842079",
      "poi_longitude": "-94.1624544",
      "poi_miles_from_property": "1.2",
      "poi_walking_minutes": "27 mins",
      "poi_biking_minutes": "6 mins",
      "poi_driving_minutes": "5 mins",
      "poi_business_phone": "+1 479-936-8803",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167553/019f38c5-cd6f-7155-8e5d-9b14592ef374.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019f38c5-cd6f-7155-8e5d-9b14592ef374",
        "storage_key": "property/6767906449167553/019f38c5-cd6f-7155-8e5d-9b14592ef374.webp",
        "width": 192,
        "height": 161
      },
      "poi_google_place_id": "ChIJk1KybVoRyYcROrvAZ890ySI",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "convenience_store"
    },
    {
      "id": "custom_2078ce9b-3d9b-4239-a8e4-eb7a05a2053b",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167553",
      "source": "custom",
      "poi_name": "Sunoco",
      "poi_type": "Transportation & Transit",
      "poi_address": "219 S Arkansas St, Rogers, AR 72756, USA",
      "poi_short_description": "Deli in a convenience store offering sandwiches, burritos and other eats alongside gasoline and fuel, plus auto washing services.",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167553/019f38c5-964f-770f-a46e-fe833b29eb51.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f38c5-964f-770f-a46e-fe833b29eb51",
        "storage_key": "property/6767906449167553/019f38c5-964f-770f-a46e-fe833b29eb51.webp",
        "width": 1024,
        "height": 575
      },
      "poi_business_url": "https://www.sunoco.com/locations/store/219-s-arkansas-rogers-ar-0621516400",
      "poi_directions_map_url": "https://maps.google.com/?cid=12016332113014132932&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "sunoco",
      "poi_latitude": "36.3312374",
      "poi_longitude": "-94.1152449",
      "poi_miles_from_property": "4.9",
      "poi_walking_minutes": "1 hour 48 mins",
      "poi_biking_minutes": "26 mins",
      "poi_driving_minutes": "12 mins",
      "poi_business_phone": "+1 479-636-8944",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167553/019f38c5-cdb4-71b9-bd10-5fefb1174781.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019f38c5-cdb4-71b9-bd10-5fefb1174781",
        "storage_key": "property/6767906449167553/019f38c5-cdb4-71b9-bd10-5fefb1174781.webp",
        "width": 172,
        "height": 192
      },
      "poi_google_place_id": "ChIJ-dUregYXyYcRxJBTO2SWwqY",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "gas_station"
    },
    {
      "id": "custom_200e9c99-1dd5-406f-86b4-9d8940f55f2e",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167553",
      "source": "custom",
      "poi_name": "Pinnacle Hills Promenade",
      "poi_type": "Shopping & Retail",
      "poi_address": "2203 S Promenade Blvd #3200, Rogers, AR 72758, USA",
      "poi_short_description": "Stylish shopping village, a movie theater & restaurants on 152 landscaped acres with fountains.",
      "poi_long_description": "Stylish shopping village, a movie theater & restaurants on 152 landscaped acres with fountains.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167553/019f38c3-14cb-70ca-91b2-b83e42d131ce.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f38c3-14cb-70ca-91b2-b83e42d131ce",
        "storage_key": "property/6767906449167553/019f38c3-14cb-70ca-91b2-b83e42d131ce.webp",
        "width": 600,
        "height": 522
      },
      "poi_business_url": "https://www.pinnaclehillspromenade.com/en.html",
      "poi_directions_map_url": "https://maps.google.com/?cid=8091942612770266228&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "pinnacle-hills-promenade",
      "poi_latitude": "36.3057822",
      "poi_longitude": "-94.1762548",
      "poi_miles_from_property": "2.2",
      "poi_walking_minutes": "48 mins",
      "poi_biking_minutes": "11 mins",
      "poi_driving_minutes": "7 mins",
      "poi_business_phone": "+1 479-936-2160",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167553/019f38c3-4bc3-777d-9c52-2b0243e394d3.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019f38c3-4bc3-777d-9c52-2b0243e394d3",
        "storage_key": "property/6767906449167553/019f38c3-4bc3-777d-9c52-2b0243e394d3.webp",
        "width": 192,
        "height": 177
      },
      "poi_google_place_id": "ChIJ4XLQnhYRyYcRdJwE8e5aTHA",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "shopping_mall"
    },
    {
      "id": "custom_19df7a34-7b23-4904-9019-e31664348a39",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167553",
      "source": "custom",
      "poi_name": "Target",
      "poi_type": "Shopping & Retail",
      "poi_address": "2404 S Promenade Blvd, Rogers, AR 72758, USA",
      "poi_short_description": "Retail chain offering home goods, clothing, electronics & more, plus exclusive designer collections.",
      "poi_long_description": "Retail chain offering home goods, clothing, electronics & more, plus exclusive designer collections.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167553/019f38c5-9720-7148-a83f-08ce7cfab422.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f38c5-9720-7148-a83f-08ce7cfab422",
        "storage_key": "property/6767906449167553/019f38c5-9720-7148-a83f-08ce7cfab422.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://www.target.com/sl/rogers/2498",
      "poi_directions_map_url": "https://maps.google.com/?cid=1747886171968198224&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "target",
      "poi_latitude": "36.2993587",
      "poi_longitude": "-94.1727497",
      "poi_miles_from_property": "1.8",
      "poi_walking_minutes": "38 mins",
      "poi_biking_minutes": "10 mins",
      "poi_driving_minutes": "5 mins",
      "poi_business_phone": "+1 479-986-1100",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167553/019f38c3-4bc3-777d-9c52-2b0243e394d3.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019f38c3-4bc3-777d-9c52-2b0243e394d3",
        "storage_key": "property/6767906449167553/019f38c3-4bc3-777d-9c52-2b0243e394d3.webp",
        "width": 192,
        "height": 177
      },
      "poi_google_place_id": "ChIJycBueRwRyYcRUFb7cza9QRg",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "department_store"
    },
    {
      "id": "custom_94483262-b546-417a-af26-c6128825689e",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167553",
      "source": "custom",
      "poi_name": "ALDI",
      "poi_type": "Shopping & Retail",
      "poi_address": "1316 W Walnut St, Rogers, AR 72756, USA",
      "poi_short_description": "Retail chain selling a range of grocery items, meat & dairy.",
      "poi_long_description": "Retail chain selling a range of grocery items, meat & dairy.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167553/019f38c5-9827-7445-82bd-ec2ca9cca5f2.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f38c5-9827-7445-82bd-ec2ca9cca5f2",
        "storage_key": "property/6767906449167553/019f38c5-9827-7445-82bd-ec2ca9cca5f2.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://info.aldi.us/stores/l/ar/rogers/1316-west-walnut/f323",
      "poi_directions_map_url": "https://maps.google.com/?cid=536439442702813351&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "aldi",
      "poi_latitude": "36.33343199999999",
      "poi_longitude": "-94.135976",
      "poi_miles_from_property": "4.1",
      "poi_walking_minutes": "1 hour 30 mins",
      "poi_biking_minutes": "25 mins",
      "poi_driving_minutes": "10 mins",
      "poi_business_phone": "+1 855-955-2534",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167553/019f38c5-cda7-70c8-8045-027f476bb53a.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019f38c5-cda7-70c8-8045-027f476bb53a",
        "storage_key": "property/6767906449167553/019f38c5-cda7-70c8-8045-027f476bb53a.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJa1V5VzsXyYcRp0jPudTQcQc",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "supermarket"
    },
    {
      "id": "custom_de2b89d4-c951-4a4c-a06e-3f8078081172",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167553",
      "source": "custom",
      "poi_name": "Harps Food Stores",
      "poi_type": "Shopping & Retail",
      "poi_address": "715 N 2nd St, Rogers, AR 72756, USA",
      "poi_short_description": "Chain grocery store offering organic products and prepared foods, plus a pharmacy.",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167553/019f38c5-9a51-727a-8a97-434546c59044.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f38c5-9a51-727a-8a97-434546c59044",
        "storage_key": "property/6767906449167553/019f38c5-9a51-727a-8a97-434546c59044.webp",
        "width": 1280,
        "height": 720
      },
      "poi_business_url": "https://www.harpsfood.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=9201844227322842649&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "harps-food-stores",
      "poi_latitude": "36.3393342",
      "poi_longitude": "-94.11583360000002",
      "poi_miles_from_property": "5.5",
      "poi_walking_minutes": "2 hours 1 min",
      "poi_biking_minutes": "30 mins",
      "poi_driving_minutes": "14 mins",
      "poi_business_phone": "+1 479-631-7001",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167553/019f38c5-cda7-70c8-8045-027f476bb53a.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019f38c5-cda7-70c8-8045-027f476bb53a",
        "storage_key": "property/6767906449167553/019f38c5-cda7-70c8-8045-027f476bb53a.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJZ0EuqA4XyYcRGY4OQJKEs38",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "grocery_store"
    },
    {
      "id": "custom_35362478-24e3-4b56-a143-ef0073a9dde4",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167553",
      "source": "custom",
      "poi_name": "Russell D. Jones Elementary School",
      "poi_type": "Education",
      "poi_address": "2926 S 1st St, Rogers, AR 72758, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167553/019f38c5-9b16-759c-9bec-c69e6a8277de.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f38c5-9b16-759c-9bec-c69e6a8277de",
        "storage_key": "property/6767906449167553/019f38c5-9b16-759c-9bec-c69e6a8277de.webp",
        "width": 1280,
        "height": 640
      },
      "poi_business_url": "http://jones.rogersschools.net/",
      "poi_directions_map_url": "https://maps.google.com/?cid=1939529088100683399&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "russell-d-jones-elementary-school",
      "poi_latitude": "36.299769",
      "poi_longitude": "-94.1190001",
      "poi_miles_from_property": "2.7",
      "poi_walking_minutes": "59 mins",
      "poi_biking_minutes": "14 mins",
      "poi_driving_minutes": "7 mins",
      "poi_business_phone": "+1 479-631-3535",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167553/019f38c3-4be6-722c-bc83-8ac39aa40c5e.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019f38c3-4be6-722c-bc83-8ac39aa40c5e",
        "storage_key": "property/6767906449167553/019f38c3-4be6-722c-bc83-8ac39aa40c5e.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJP4Uo0YwWyYcRh07H922X6ho",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "primary_school"
    },
    {
      "id": "custom_df808d28-5716-487f-b3df-7719ad6ea1a9",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167553",
      "source": "custom",
      "poi_name": "Oakdale Middle School",
      "poi_type": "Education",
      "poi_address": "511 N Dixieland Rd, Rogers, AR 72756, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167553/019f38c5-9dfd-74d3-a483-c0f7ff4d8236.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f38c5-9dfd-74d3-a483-c0f7ff4d8236",
        "storage_key": "property/6767906449167553/019f38c5-9dfd-74d3-a483-c0f7ff4d8236.webp",
        "width": 1280,
        "height": 834
      },
      "poi_business_url": "http://oakdale.rogersschools.net/",
      "poi_directions_map_url": "https://maps.google.com/?cid=13440433156721261042&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "oakdale-middle-school",
      "poi_latitude": "36.338909",
      "poi_longitude": "-94.1428257",
      "poi_miles_from_property": "4.1",
      "poi_walking_minutes": "1 hour 29 mins",
      "poi_biking_minutes": "21 mins",
      "poi_driving_minutes": "11 mins",
      "poi_business_phone": "+1 479-631-3615",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167553/019f38c3-4be6-722c-bc83-8ac39aa40c5e.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019f38c3-4be6-722c-bc83-8ac39aa40c5e",
        "storage_key": "property/6767906449167553/019f38c3-4be6-722c-bc83-8ac39aa40c5e.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJ_zxMazcXyYcR8rnA3b4Chro",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "school"
    },
    {
      "id": "custom_bad7d818-2ca7-444f-86fb-d20ff61386d9",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167553",
      "source": "custom",
      "poi_name": "Rogers High School",
      "poi_type": "Education",
      "poi_address": "2300 S Dixieland Rd, Rogers, AR 72758, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167553/019f38c5-9b71-7245-945c-4c0cb555280a.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f38c5-9b71-7245-945c-4c0cb555280a",
        "storage_key": "property/6767906449167553/019f38c5-9b71-7245-945c-4c0cb555280a.webp",
        "width": 1280,
        "height": 640
      },
      "poi_business_url": "http://rhs.rogersschools.net/",
      "poi_directions_map_url": "https://maps.google.com/?cid=1970902612259229441&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "rogers-high-school",
      "poi_latitude": "36.299969",
      "poi_longitude": "-94.1467358",
      "poi_miles_from_property": "1.6",
      "poi_walking_minutes": "34 mins",
      "poi_biking_minutes": "8 mins",
      "poi_driving_minutes": "4 mins",
      "poi_business_phone": "+1 479-636-2202",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167553/019f38c3-4be6-722c-bc83-8ac39aa40c5e.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019f38c3-4be6-722c-bc83-8ac39aa40c5e",
        "storage_key": "property/6767906449167553/019f38c3-4be6-722c-bc83-8ac39aa40c5e.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJvW9w-LUWyYcRAc-ZynsNWhs",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "secondary_school"
    },
    {
      "id": "custom_a0f8e1d7-2c4a-485a-8d18-0faaf575e070",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167553",
      "source": "custom",
      "poi_name": "Rogers Heritage High School",
      "poi_type": "Education",
      "poi_address": "1114 S 5th St, Rogers, AR 72756, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167553/019f38c5-9c1c-77ac-9f05-88266dabd061.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f38c5-9c1c-77ac-9f05-88266dabd061",
        "storage_key": "property/6767906449167553/019f38c5-9c1c-77ac-9f05-88266dabd061.webp",
        "width": 1280,
        "height": 640
      },
      "poi_business_url": "http://heritage.rogersschools.net/",
      "poi_directions_map_url": "https://maps.google.com/?cid=13067007191522395598&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "rogers-heritage-high-school",
      "poi_latitude": "36.3237956",
      "poi_longitude": "-94.1230579",
      "poi_miles_from_property": "4.1",
      "poi_walking_minutes": "1 hour 32 mins",
      "poi_biking_minutes": "25 mins",
      "poi_driving_minutes": "10 mins",
      "poi_business_phone": "+1 479-631-3579",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167553/019f38c3-4be6-722c-bc83-8ac39aa40c5e.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019f38c3-4be6-722c-bc83-8ac39aa40c5e",
        "storage_key": "property/6767906449167553/019f38c3-4be6-722c-bc83-8ac39aa40c5e.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJnSv_Ch0XyYcRzsUqCM9VV7U",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "secondary_school"
    },
    {
      "id": "custom_55aa6792-2e86-4ef2-854b-59bce730fd88",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167553",
      "source": "custom",
      "poi_name": "Arkansas Arts Academy Elementary/Middle School",
      "poi_type": "Education",
      "poi_address": "2005 S 12th St, Rogers, AR 72758, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167553/019f38c5-9cef-73c3-8e33-5921dfca29bb.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f38c5-9cef-73c3-8e33-5921dfca29bb",
        "storage_key": "property/6767906449167553/019f38c5-9cef-73c3-8e33-5921dfca29bb.webp",
        "width": 960,
        "height": 1280
      },
      "poi_business_url": "https://www.artsk12.org/o/elementary",
      "poi_directions_map_url": "https://maps.google.com/?cid=8833200863321866193&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "arkansas-arts-academy-elementarymiddle-school",
      "poi_latitude": "36.3076956",
      "poi_longitude": "-94.1327342",
      "poi_miles_from_property": "2.4",
      "poi_walking_minutes": "54 mins",
      "poi_biking_minutes": "12 mins",
      "poi_driving_minutes": "8 mins",
      "poi_business_phone": "+1 479-636-2272",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167553/019f38c3-4be6-722c-bc83-8ac39aa40c5e.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019f38c3-4be6-722c-bc83-8ac39aa40c5e",
        "storage_key": "property/6767906449167553/019f38c3-4be6-722c-bc83-8ac39aa40c5e.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJjUymRcIWyYcR0T_5h2LVlXo",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "primary_school"
    },
    {
      "id": "custom_1b658e17-9c45-4a23-acb8-6996829a1724",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167553",
      "source": "custom",
      "poi_name": "Fairview Elementary School",
      "poi_type": "Education",
      "poi_address": "3131 W Garrett Rd, Rogers, AR 72758, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167553/019f38c5-9ef1-77a3-9cd5-9d06a9f14fd1.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f38c5-9ef1-77a3-9cd5-9d06a9f14fd1",
        "storage_key": "property/6767906449167553/019f38c5-9ef1-77a3-9cd5-9d06a9f14fd1.webp",
        "width": 1280,
        "height": 877
      },
      "poi_business_url": "http://fairview.rogersschools.net/",
      "poi_directions_map_url": "https://maps.google.com/?cid=5187996408634344825&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "fairview-elementary-school",
      "poi_latitude": "36.26981019999999",
      "poi_longitude": "-94.1642684",
      "poi_miles_from_property": "3",
      "poi_walking_minutes": "1 hour 6 mins",
      "poi_biking_minutes": "17 mins",
      "poi_driving_minutes": "9 mins",
      "poi_business_phone": "+1 479-631-3524",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167553/019f38c3-4be6-722c-bc83-8ac39aa40c5e.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019f38c3-4be6-722c-bc83-8ac39aa40c5e",
        "storage_key": "property/6767906449167553/019f38c3-4be6-722c-bc83-8ac39aa40c5e.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJuy3ty7ATyYcReQWnGD93_0c",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "primary_school"
    },
    {
      "id": "custom_e7dc19d1-efae-43bd-85e9-674458887dea",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167553",
      "source": "custom",
      "poi_name": "Janie Darr Elementary School",
      "poi_type": "Education",
      "poi_address": "6505 Mount Hebron Rd, Rogers, AR 72758, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167553/019f38c5-a0dc-734e-b400-4d0207753bb9.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f38c5-a0dc-734e-b400-4d0207753bb9",
        "storage_key": "property/6767906449167553/019f38c5-a0dc-734e-b400-4d0207753bb9.webp",
        "width": 1280,
        "height": 841
      },
      "poi_business_url": "http://darr.rogersschools.net/",
      "poi_directions_map_url": "https://maps.google.com/?cid=1853455279852141528&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "janie-darr-elementary-school",
      "poi_latitude": "36.2668133",
      "poi_longitude": "-94.1938487",
      "poi_miles_from_property": "4.2",
      "poi_walking_minutes": "1 hour 31 mins",
      "poi_biking_minutes": "22 mins",
      "poi_driving_minutes": "11 mins",
      "poi_business_phone": "+1 479-631-3553",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167553/019f38c3-4be6-722c-bc83-8ac39aa40c5e.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019f38c3-4be6-722c-bc83-8ac39aa40c5e",
        "storage_key": "property/6767906449167553/019f38c3-4be6-722c-bc83-8ac39aa40c5e.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJC-usbC0SyYcR2LuoysHLuBk",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "primary_school"
    },
    {
      "id": "custom_da4590b3-a2cb-484c-868f-823365680f0a",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167553",
      "source": "custom",
      "poi_name": "Primrose School of Rogers at Pinnacle Hills",
      "poi_type": "Education",
      "poi_address": "3724 S Pinnacle Hills Pkwy, Rogers, AR 72758, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167553/019f38c5-a0e6-71ba-bd95-1191e88c68b1.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f38c5-a0e6-71ba-bd95-1191e88c68b1",
        "storage_key": "property/6767906449167553/019f38c5-a0e6-71ba-bd95-1191e88c68b1.webp",
        "width": 1024,
        "height": 575
      },
      "poi_business_url": "https://www.primroseschools.com/schools/rogers-at-pinnacle-hills/?utm_source=gbp&utm_medium=maplistings",
      "poi_directions_map_url": "https://maps.google.com/?cid=9357048880419011914&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "primrose-school-of-rogers-at-pinnacle-hills",
      "poi_latitude": "36.3020293",
      "poi_longitude": "-94.1910297",
      "poi_miles_from_property": "2.9",
      "poi_walking_minutes": "1 hour 3 mins",
      "poi_biking_minutes": "17 mins",
      "poi_driving_minutes": "10 mins",
      "poi_business_phone": "+1 479-309-9245",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167553/019f38c3-4be6-722c-bc83-8ac39aa40c5e.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019f38c3-4be6-722c-bc83-8ac39aa40c5e",
        "storage_key": "property/6767906449167553/019f38c3-4be6-722c-bc83-8ac39aa40c5e.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJC7jJzgsRyYcRSn1Xh2Hq2oE",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "preschool"
    },
    {
      "id": "custom_c2f2e172-9ffa-4a53-84f9-8028b9c8ddbf",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167553",
      "source": "custom",
      "poi_name": "Kindergrove Preschool and Children's Center",
      "poi_type": "Education",
      "poi_address": "696 S 28th St, Rogers, AR 72758, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167553/019f38c5-a0d5-728b-8f35-6b6caaa11d65.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f38c5-a0d5-728b-8f35-6b6caaa11d65",
        "storage_key": "property/6767906449167553/019f38c5-a0d5-728b-8f35-6b6caaa11d65.webp",
        "width": 500,
        "height": 302
      },
      "poi_business_url": "http://www.kindergrove.org/",
      "poi_directions_map_url": "https://maps.google.com/?cid=13117898233211582303&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "kindergrove-preschool-and-childrens-center",
      "poi_latitude": "36.3315433",
      "poi_longitude": "-94.1621454",
      "poi_miles_from_property": "3.4",
      "poi_walking_minutes": "1 hour 14 mins",
      "poi_biking_minutes": "17 mins",
      "poi_driving_minutes": "8 mins",
      "poi_business_phone": "+1 479-633-8585",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167553/019f38c3-4be6-722c-bc83-8ac39aa40c5e.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019f38c3-4be6-722c-bc83-8ac39aa40c5e",
        "storage_key": "property/6767906449167553/019f38c3-4be6-722c-bc83-8ac39aa40c5e.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJ1Z4UAM8QyYcRX_dMBvEiDLY",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "child_care_agency"
    },
    {
      "id": "custom_0db90242-d068-49fb-9df1-65d0e7ac7a01",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167553",
      "source": "custom",
      "poi_name": "NorthWest Arkansas Community College",
      "poi_type": "Education",
      "poi_address": "1 College Dr, Bentonville, AR 72712, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167553/019f38c3-1f5f-7489-8adc-e0e21a423bd1.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f38c3-1f5f-7489-8adc-e0e21a423bd1",
        "storage_key": "property/6767906449167553/019f38c3-1f5f-7489-8adc-e0e21a423bd1.webp",
        "width": 1280,
        "height": 850
      },
      "poi_business_url": "https://www.nwacc.edu/",
      "poi_directions_map_url": "https://maps.google.com/?cid=8062833287412958226&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "northwest-arkansas-community-college",
      "poi_latitude": "36.358598",
      "poi_longitude": "-94.172471",
      "poi_miles_from_property": "5.9",
      "poi_walking_minutes": "2 hours 10 mins",
      "poi_biking_minutes": "46 mins",
      "poi_driving_minutes": "10 mins",
      "poi_business_phone": "+1 479-986-4000",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167553/019f38c3-4be6-722c-bc83-8ac39aa40c5e.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019f38c3-4be6-722c-bc83-8ac39aa40c5e",
        "storage_key": "property/6767906449167553/019f38c3-4be6-722c-bc83-8ac39aa40c5e.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJa3NSpZgQyYcREsRx-yfw5G8",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "university"
    },
    {
      "id": "custom_c99e6ab3-a427-4db9-9015-f03aa9c04bde",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167553",
      "source": "custom",
      "poi_name": "Crystal Bridges Museum of American Art",
      "poi_type": "Entertainment",
      "poi_address": "600 Museum Way, Bentonville, AR 72712, USA",
      "poi_short_description": "Renowned collection ranging from Rockwell to Warhol in a striking structure set on 120 lush acres.",
      "poi_long_description": "Renowned collection ranging from Rockwell to Warhol in a striking structure set on 120 lush acres.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167553/019f38c5-a20c-749c-8104-041490367754.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f38c5-a20c-749c-8104-041490367754",
        "storage_key": "property/6767906449167553/019f38c5-a20c-749c-8104-041490367754.webp",
        "width": 1280,
        "height": 852
      },
      "poi_business_url": "https://crystalbridges.org/",
      "poi_directions_map_url": "https://maps.google.com/?cid=12476663502294684731&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "crystal-bridges-museum-of-american-art",
      "poi_latitude": "36.3818542",
      "poi_longitude": "-94.2026525",
      "poi_miles_from_property": "8.6",
      "poi_walking_minutes": "3 hours 8 mins",
      "poi_biking_minutes": "51 mins",
      "poi_driving_minutes": "15 mins",
      "poi_business_phone": "+1 479-418-5700",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167553/019f38c3-4bc3-777d-9c52-2f6b82937236.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019f38c3-4bc3-777d-9c52-2f6b82937236",
        "storage_key": "property/6767906449167553/019f38c3-4bc3-777d-9c52-2f6b82937236.webp",
        "width": 176,
        "height": 192
      },
      "poi_google_place_id": "ChIJW5IzxBQayYcROxRb5FkDJq0",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "art_museum"
    },
    {
      "id": "custom_6f833555-087e-4f89-ad9d-4599770ae65b",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167553",
      "source": "custom",
      "poi_name": "Scott Family Amazeum",
      "poi_type": "Entertainment",
      "poi_address": "1009 Museum Way, Bentonville, AR 72712, USA",
      "poi_short_description": "Modern children's museum offering dynamic, hands-on displays & activities & an outdoor \"playscape.\"",
      "poi_long_description": "Modern children's museum offering dynamic, hands-on displays & activities & an outdoor \"playscape.\"",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167553/019f38c5-a580-77fb-9208-594f897a6108.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f38c5-a580-77fb-9208-594f897a6108",
        "storage_key": "property/6767906449167553/019f38c5-a580-77fb-9208-594f897a6108.webp",
        "width": 1280,
        "height": 853
      },
      "poi_business_url": "https://www.amazeum.org/",
      "poi_directions_map_url": "https://maps.google.com/?cid=3620504812667872326&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "scott-family-amazeum",
      "poi_latitude": "36.3792428",
      "poi_longitude": "-94.1972494",
      "poi_miles_from_property": "8.2",
      "poi_walking_minutes": "3 hours 2 mins",
      "poi_biking_minutes": "51 mins",
      "poi_driving_minutes": "14 mins",
      "poi_business_phone": "+1 479-696-9280",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167553/019f38c3-4bc3-777d-9c52-2f6b82937236.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019f38c3-4bc3-777d-9c52-2f6b82937236",
        "storage_key": "property/6767906449167553/019f38c3-4bc3-777d-9c52-2f6b82937236.webp",
        "width": 176,
        "height": 192
      },
      "poi_google_place_id": "ChIJUcoHrI4ayYcRRiSp4vGdPjI",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "museum"
    },
    {
      "id": "custom_ac1dd261-4bf3-4c30-9617-200418d56358",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167553",
      "source": "custom",
      "poi_name": "The Momentary",
      "poi_type": "Entertainment",
      "poi_address": "507 SE E St, Bentonville, AR 72712, USA",
      "poi_short_description": "Free-admission extension of the Crystal Bridges Museum focusing on contemporary art and live music.",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167553/019f38c5-a2c7-7776-bf3a-12fe8e0f5177.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f38c5-a2c7-7776-bf3a-12fe8e0f5177",
        "storage_key": "property/6767906449167553/019f38c5-a2c7-7776-bf3a-12fe8e0f5177.webp",
        "width": 836,
        "height": 627
      },
      "poi_business_url": "https://themomentary.org/",
      "poi_directions_map_url": "https://maps.google.com/?cid=2949730782627288492&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "the-momentary",
      "poi_latitude": "36.3665519",
      "poi_longitude": "-94.2026659",
      "poi_miles_from_property": "7.6",
      "poi_walking_minutes": "2 hours 48 mins",
      "poi_biking_minutes": "46 mins",
      "poi_driving_minutes": "14 mins",
      "poi_business_phone": "+1 479-367-7500",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167553/019f38c3-4bc5-7718-bc97-cba8ecefb0bb.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019f38c3-4bc5-7718-bc97-cba8ecefb0bb",
        "storage_key": "property/6767906449167553/019f38c3-4bc5-7718-bc97-cba8ecefb0bb.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJhx-8ypwayYcRrNWIuYSM7yg",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "live_music_venue"
    },
    {
      "id": "custom_7f7c6e02-4d5f-4e7d-a193-7fc02ac0ab3b",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167553",
      "source": "custom",
      "poi_name": "The Walmart AMP",
      "poi_type": "Entertainment",
      "poi_address": "5079 W Northgate Rd, Rogers, AR 72758, USA",
      "poi_short_description": "This sizable music venue with a range of outdoor seating options hosts many touring artists.",
      "poi_long_description": "This sizable music venue with a range of outdoor seating options hosts many touring artists.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167553/019f38c5-a769-7087-b451-404fef1e890a.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f38c5-a769-7087-b451-404fef1e890a",
        "storage_key": "property/6767906449167553/019f38c5-a769-7087-b451-404fef1e890a.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://walmartamp.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=4073090213928832597&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "the-walmart-amp",
      "poi_latitude": "36.302676",
      "poi_longitude": "-94.183726",
      "poi_miles_from_property": "2.7",
      "poi_walking_minutes": "59 mins",
      "poi_biking_minutes": "15 mins",
      "poi_driving_minutes": "8 mins",
      "poi_business_phone": "+1 479-443-5600",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167553/019f38c3-4bc5-7718-bc97-cba8ecefb0bb.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019f38c3-4bc5-7718-bc97-cba8ecefb0bb",
        "storage_key": "property/6767906449167553/019f38c3-4bc5-7718-bc97-cba8ecefb0bb.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJOYU0xw0RyYcRVQ5ZK_iFhjg",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "amphitheatre"
    },
    {
      "id": "custom_b3a397b5-d597-478e-8306-5e49768a0259",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167553",
      "source": "custom",
      "poi_name": "Topgolf Rogers",
      "poi_type": "Restaurants",
      "poi_address": "3919 S JB Hunt Dr, Rogers, AR 72758, USA",
      "poi_short_description": "Sprawling entertainment venue with a high-tech driving range & swanky lounge with drinks & games.",
      "poi_long_description": "Sprawling entertainment venue with a high-tech driving range & swanky lounge with drinks & games.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167553/019f38c3-14ca-7581-91bf-f650a313f318.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f38c3-14ca-7581-91bf-f650a313f318",
        "storage_key": "property/6767906449167553/019f38c3-14ca-7581-91bf-f650a313f318.webp",
        "width": 1280,
        "height": 853
      },
      "poi_business_url": "https://topgolf.com/us/rogers-arkansas/",
      "poi_directions_map_url": "https://maps.google.com/?cid=392275813714338184&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "topgolf-rogers",
      "poi_latitude": "36.3001791",
      "poi_longitude": "-94.1827326",
      "poi_miles_from_property": "2.5",
      "poi_walking_minutes": "54 mins",
      "poi_biking_minutes": "14 mins",
      "poi_driving_minutes": "7 mins",
      "poi_business_phone": "+1 479-257-9330",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167553/019f38c3-4bc4-743d-8697-11f6d945350c.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019f38c3-4bc4-743d-8697-11f6d945350c",
        "storage_key": "property/6767906449167553/019f38c3-4bc4-743d-8697-11f6d945350c.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJZWAGE4cRyYcRiKFrMsakcQU",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "restaurant"
    },
    {
      "id": "custom_87b6ffe2-01d8-4d86-84f6-23e1b3a31805",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167553",
      "source": "custom",
      "poi_name": "Malco Pinnacle Hills Cinema",
      "poi_type": "Entertainment",
      "poi_address": "2100 S Bellview Rd, Rogers, AR 72758, USA",
      "poi_short_description": "Cinema chain offering multiple screens of mainstream films with standard amenities & refreshments.",
      "poi_long_description": "Cinema chain offering multiple screens of mainstream films with standard amenities & refreshments.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167553/019f38c5-a829-74b3-9853-4c22103b30d9.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f38c5-a829-74b3-9853-4c22103b30d9",
        "storage_key": "property/6767906449167553/019f38c5-a829-74b3-9853-4c22103b30d9.webp",
        "width": 1167,
        "height": 1280
      },
      "poi_business_url": "https://malco.com/cinemas/pinnacle-hills-cinema/",
      "poi_directions_map_url": "https://maps.google.com/?cid=1143265162103332574&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "malco-pinnacle-hills-cinema",
      "poi_latitude": "36.3060707",
      "poi_longitude": "-94.1737368",
      "poi_miles_from_property": "2.2",
      "poi_walking_minutes": "47 mins",
      "poi_biking_minutes": "11 mins",
      "poi_driving_minutes": "6 mins",
      "poi_business_phone": "+1 479-936-8494",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167553/019f38c5-cd6f-7155-8e5d-95b27b70405b.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019f38c5-cd6f-7155-8e5d-95b27b70405b",
        "storage_key": "property/6767906449167553/019f38c5-cd6f-7155-8e5d-95b27b70405b.webp",
        "width": 172,
        "height": 192
      },
      "poi_google_place_id": "ChIJA4wPBEARyYcR3p4_j5ux3Q8",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "movie_theater"
    },
    {
      "id": "custom_49007f94-0f21-4104-8b42-5dcfb9860248",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167553",
      "source": "custom",
      "poi_name": "Railyard Live at Butterfield Stage",
      "poi_type": "Entertainment",
      "poi_address": "101 E Cherry St, Rogers, AR 72756, USA",
      "poi_short_description": "Open-air venue for local and touring bands, with occasional gigs and lawn seating.",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167553/019f38c5-a65c-77f3-aa16-450cc88f919b.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f38c5-a65c-77f3-aa16-450cc88f919b",
        "storage_key": "property/6767906449167553/019f38c5-a65c-77f3-aa16-450cc88f919b.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "http://www.railyardlive.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=11856565126968184658&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "railyard-live-at-butterfield-stage",
      "poi_latitude": "36.3305721",
      "poi_longitude": "-94.1157446",
      "poi_miles_from_property": "4.8",
      "poi_walking_minutes": "1 hour 47 mins",
      "poi_biking_minutes": "26 mins",
      "poi_driving_minutes": "11 mins",
      "poi_business_phone": "+1 479-621-1186",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167553/019f38c3-4bc5-7718-bc97-cba8ecefb0bb.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019f38c3-4bc5-7718-bc97-cba8ecefb0bb",
        "storage_key": "property/6767906449167553/019f38c3-4bc5-7718-bc97-cba8ecefb0bb.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJW9q5TdYXyYcRUg85CSr7iqQ",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "live_music_venue"
    },
    {
      "id": "custom_f5e437ce-81a6-40ba-86d9-689089c97c15",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167553",
      "source": "custom",
      "poi_name": "The Music Depot",
      "poi_type": "Entertainment",
      "poi_address": "206 W Walnut St, Rogers, AR 72756, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167553/019f38c5-a836-7536-8247-6afa4e05e496.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f38c5-a836-7536-8247-6afa4e05e496",
        "storage_key": "property/6767906449167553/019f38c5-a836-7536-8247-6afa4e05e496.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://musicdepotnwa.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=9099094290576305782&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "the-music-depot",
      "poi_latitude": "36.3328893",
      "poi_longitude": "-94.1178174",
      "poi_miles_from_property": "5",
      "poi_walking_minutes": "1 hour 51 mins",
      "poi_biking_minutes": "28 mins",
      "poi_driving_minutes": "12 mins",
      "poi_business_phone": "",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167553/019f38c3-4bc5-7718-bc97-cba8ecefb0bb.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019f38c3-4bc5-7718-bc97-cba8ecefb0bb",
        "storage_key": "property/6767906449167553/019f38c3-4bc5-7718-bc97-cba8ecefb0bb.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJ_bdkdf4XyYcRdu6VVwx6Rn4",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "live_music_venue"
    },
    {
      "id": "custom_41a6f6b5-ef86-4cfb-a0bb-cbc0ab97b148",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167553",
      "source": "custom",
      "poi_name": "Daisy Airgun Museum",
      "poi_type": "Entertainment",
      "poi_address": "202 W Walnut St, Rogers, AR 72756, USA",
      "poi_short_description": "Small museum featuring vintage products & artifacts of the Daisy company, plus a gift shop.",
      "poi_long_description": "Small museum featuring vintage products & artifacts of the Daisy company, plus a gift shop.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167553/019f38c3-2838-722b-81b5-84ff7b80a753.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f38c3-2838-722b-81b5-84ff7b80a753",
        "storage_key": "property/6767906449167553/019f38c3-2838-722b-81b5-84ff7b80a753.webp",
        "width": 960,
        "height": 1280
      },
      "poi_business_url": "http://www.daisymuseum.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=12197815580220262514&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "daisy-airgun-museum",
      "poi_latitude": "36.3329937",
      "poi_longitude": "-94.1176025",
      "poi_miles_from_property": "5",
      "poi_walking_minutes": "1 hour 52 mins",
      "poi_biking_minutes": "28 mins",
      "poi_driving_minutes": "12 mins",
      "poi_business_phone": "+1 479-986-6873",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167553/019f38c3-4bc3-777d-9c52-2f6b82937236.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019f38c3-4bc3-777d-9c52-2f6b82937236",
        "storage_key": "property/6767906449167553/019f38c3-4bc3-777d-9c52-2f6b82937236.webp",
        "width": 176,
        "height": 192
      },
      "poi_google_place_id": "ChIJ0193hgUXyYcRcgjBtqRYR6k",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "history_museum"
    },
    {
      "id": "custom_fb109221-4c0a-410a-b221-edd8f14edd74",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167553",
      "source": "custom",
      "poi_name": "Rogers Historical Museum",
      "poi_type": "Entertainment",
      "poi_address": "313 S 2nd St, Rogers, AR 72756, USA",
      "poi_short_description": "Educational stop for interactive displays & re-created historical scenes from early Rogers.",
      "poi_long_description": "Educational stop for interactive displays & re-created historical scenes from early Rogers.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167553/019f38c3-1dde-7769-ad1b-5657559e2ea7.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f38c3-1dde-7769-ad1b-5657559e2ea7",
        "storage_key": "property/6767906449167553/019f38c3-1dde-7769-ad1b-5657559e2ea7.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "http://www.rogershistoricalmuseum.org/",
      "poi_directions_map_url": "https://maps.google.com/?cid=10600807418357158271&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "rogers-historical-museum",
      "poi_latitude": "36.3304443",
      "poi_longitude": "-94.1174477",
      "poi_miles_from_property": "4.8",
      "poi_walking_minutes": "1 hour 48 mins",
      "poi_biking_minutes": "27 mins",
      "poi_driving_minutes": "12 mins",
      "poi_business_phone": "+1 479-621-1154",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167553/019f38c3-4bc3-777d-9c52-2f6b82937236.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019f38c3-4bc3-777d-9c52-2f6b82937236",
        "storage_key": "property/6767906449167553/019f38c3-4bc3-777d-9c52-2f6b82937236.webp",
        "width": 176,
        "height": 192
      },
      "poi_google_place_id": "ChIJQUCtrAUXyYcRfxGBdy6iHZM",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "museum"
    },
    {
      "id": "custom_0127aae4-e751-4586-8375-6c8e50e2bd3b",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167553",
      "source": "custom",
      "poi_name": "Mercy Hospital Northwest Arkansas",
      "poi_type": "Health and Wellness",
      "poi_address": "2710 S Rife Medical Ln, Rogers, AR 72758, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167553/019f38c3-3301-75c9-958d-0c19ef8e84a2.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f38c3-3301-75c9-958d-0c19ef8e84a2",
        "storage_key": "property/6767906449167553/019f38c3-3301-75c9-958d-0c19ef8e84a2.webp",
        "width": 960,
        "height": 1280
      },
      "poi_business_url": "https://www.mercy.net/practice/mercy-hospital-northwest-arkansas?utm_source=google&utm_medium=organic_search&utm_campaign=yext&utm_term=Central&utm_content=website&y_source=1_MTI5OTY0NzItNzE1LWxvY2F0aW9uLndlYnNpdGU=",
      "poi_directions_map_url": "https://maps.google.com/?cid=6342883712185739120&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "mercy-hospital-northwest-arkansas",
      "poi_latitude": "36.3092179",
      "poi_longitude": "-94.1829407",
      "poi_miles_from_property": "2.8",
      "poi_walking_minutes": "1 hour 0 mins",
      "poi_biking_minutes": "17 mins",
      "poi_driving_minutes": "9 mins",
      "poi_business_phone": "+1 479-338-8000",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167553/019f38c3-4be7-73dc-9fc1-7340dfd55887.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019f38c3-4be7-73dc-9fc1-7340dfd55887",
        "storage_key": "property/6767906449167553/019f38c3-4be7-73dc-9fc1-7340dfd55887.webp",
        "width": 134,
        "height": 192
      },
      "poi_google_place_id": "ChIJ60dIRQURyYcRcCdxVCFzBlg",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "general_hospital"
    },
    {
      "id": "custom_402ce85e-ba7c-480a-b2a1-80bd898bd4d1",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167553",
      "source": "custom",
      "poi_name": "Washington Regional Urgent Care - Rogers",
      "poi_type": "Health and Wellness",
      "poi_address": "2301 W Pleasant Grove Rd #101, Rogers, AR 72758, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167553/019f38c5-ab45-73af-af60-833f6f117905.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f38c5-ab45-73af-af60-833f6f117905",
        "storage_key": "property/6767906449167553/019f38c5-ab45-73af-af60-833f6f117905.webp",
        "width": 720,
        "height": 720
      },
      "poi_business_url": "https://www.urgentteam.com/locations/washington-regional-urgent-care-rogers-ar/",
      "poi_directions_map_url": "https://maps.google.com/?cid=12212105799186826024&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "washington-regional-urgent-care---rogers",
      "poi_latitude": "36.28350289999999",
      "poi_longitude": "-94.1482595",
      "poi_miles_from_property": "0.7",
      "poi_walking_minutes": "16 mins",
      "poi_biking_minutes": "4 mins",
      "poi_driving_minutes": "4 mins",
      "poi_business_phone": "+1 479-326-8525",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167553/019f38c3-4bc5-7718-bc97-cba8ecefb0bb.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019f38c3-4bc5-7718-bc97-cba8ecefb0bb",
        "storage_key": "property/6767906449167553/019f38c3-4bc5-7718-bc97-cba8ecefb0bb.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJZUbTN4cXyYcRKMMEmIUdeqk",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "medical_clinic"
    },
    {
      "id": "custom_52f9c42c-48a7-4cff-a217-5e558219ce88",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167553",
      "source": "custom",
      "poi_name": "CVS",
      "poi_type": "Health and Wellness",
      "poi_address": "1749 W Walnut St, Rogers, AR 72756, USA",
      "poi_short_description": "Drugstore chain selling a variety of beauty & health products, plus some grocery & household items.",
      "poi_long_description": "Drugstore chain selling a variety of beauty & health products, plus some grocery & household items.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167553/019f38c5-ab00-709e-80ea-1668db501218.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f38c5-ab00-709e-80ea-1668db501218",
        "storage_key": "property/6767906449167553/019f38c5-ab00-709e-80ea-1668db501218.webp",
        "width": 960,
        "height": 1280
      },
      "poi_business_url": "https://www.cvs.com/store-locator/rogers-ar-pharmacies/1749-w-walnut-st-rogers-ar-72756/storeid=10816?WT.mc_id=LS_GOOGLE_FS_10816",
      "poi_directions_map_url": "https://maps.google.com/?cid=9730529202186429210&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "cvs",
      "poi_latitude": "36.3346439",
      "poi_longitude": "-94.1431837",
      "poi_miles_from_property": "3.7",
      "poi_walking_minutes": "1 hour 22 mins",
      "poi_biking_minutes": "20 mins",
      "poi_driving_minutes": "10 mins",
      "poi_business_phone": "+1 479-246-0871",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167553/019f38c3-4bc5-7718-bc97-cba8ecefb0bb.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019f38c3-4bc5-7718-bc97-cba8ecefb0bb",
        "storage_key": "property/6767906449167553/019f38c3-4bc5-7718-bc97-cba8ecefb0bb.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJDWvETzAXyYcRGiPjPMHICYc",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "drugstore"
    },
    {
      "id": "custom_5d003988-6597-4314-95ef-150384c28827",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167553",
      "source": "custom",
      "poi_name": "Walmart Pharmacy",
      "poi_type": "Health and Wellness",
      "poi_address": "4208 S Pleasant Crossing Blvd, Rogers, AR 72758, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167553/019f38c5-a9b9-764e-a178-bbf2d473ba15.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f38c5-a9b9-764e-a178-bbf2d473ba15",
        "storage_key": "property/6767906449167553/019f38c5-a9b9-764e-a178-bbf2d473ba15.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://www.walmart.com/store/5260-rogers-ar/pharmacy/?veh=seo_loc",
      "poi_directions_map_url": "https://maps.google.com/?cid=12529503391467757234&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "walmart-pharmacy",
      "poi_latitude": "36.2788311",
      "poi_longitude": "-94.1512165",
      "poi_miles_from_property": "0.9",
      "poi_walking_minutes": "19 mins",
      "poi_biking_minutes": "5 mins",
      "poi_driving_minutes": "5 mins",
      "poi_business_phone": "+1 479-621-0629",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167553/019f38c5-cd62-768e-8319-9aaa96f703dc.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019f38c5-cd62-768e-8319-9aaa96f703dc",
        "storage_key": "property/6767906449167553/019f38c5-cd62-768e-8319-9aaa96f703dc.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJKadbD28RyYcRst58TPO84a0",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "pharmacy"
    },
    {
      "id": "custom_54dd57db-c3cc-4812-9bed-e8d0a98f83e4",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167553",
      "source": "custom",
      "poi_name": "HOTWORX - Rogers, AR",
      "poi_type": "Health and Wellness",
      "poi_address": "4305 S Pleasant Crossing Blvd Suite 105, Rogers, AR 72758, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167553/019f38c5-a96f-77b8-b134-0b8e5f9bba5a.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f38c5-a96f-77b8-b134-0b8e5f9bba5a",
        "storage_key": "property/6767906449167553/019f38c5-a96f-77b8-b134-0b8e5f9bba5a.webp",
        "width": 554,
        "height": 312
      },
      "poi_business_url": "https://www.hotworx.net/studio/rogers?utm_source=google&utm_medium=organic&utm_campaign=gbp",
      "poi_directions_map_url": "https://maps.google.com/?cid=13328514820751239473&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "hotworx---rogers-ar",
      "poi_latitude": "36.2791325",
      "poi_longitude": "-94.1486174",
      "poi_miles_from_property": "0.9",
      "poi_walking_minutes": "21 mins",
      "poi_biking_minutes": "5 mins",
      "poi_driving_minutes": "5 mins",
      "poi_business_phone": "+1 479-278-2865",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167553/019f38c3-4be6-722c-bc83-8ac39aa40c5e.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019f38c3-4be6-722c-bc83-8ac39aa40c5e",
        "storage_key": "property/6767906449167553/019f38c3-4be6-722c-bc83-8ac39aa40c5e.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJx4chIIgXyYcRMSloqpxl-Lg",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "yoga_studio"
    },
    {
      "id": "custom_9afa02e9-5bc5-481f-b0c4-c31136c41c63",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167553",
      "source": "custom",
      "poi_name": "NWA Whole Body Fitness (Home of CrossFit Reverence)",
      "poi_type": "Health and Wellness",
      "poi_address": "6028 W Stoney Brook Rd, Rogers, AR 72758, USA",
      "poi_short_description": "Friendly, welcoming gym with programming for all fitness levels.",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167553/019f38c5-ae16-76ae-9507-020d66ab218d.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f38c5-ae16-76ae-9507-020d66ab218d",
        "storage_key": "property/6767906449167553/019f38c5-ae16-76ae-9507-020d66ab218d.webp",
        "width": 1280,
        "height": 853
      },
      "poi_business_url": "https://nwawholebodyfitness.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=6623162954444641537&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "nwa-whole-body-fitness-home-of-crossfit-reverence",
      "poi_latitude": "36.3164455",
      "poi_longitude": "-94.1978931",
      "poi_miles_from_property": "4.1",
      "poi_walking_minutes": "1 hour 28 mins",
      "poi_biking_minutes": "25 mins",
      "poi_driving_minutes": "9 mins",
      "poi_business_phone": "+1 479-391-3803",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167553/019f38c3-4bc5-7718-bc97-cba8ecefb0bb.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019f38c3-4bc5-7718-bc97-cba8ecefb0bb",
        "storage_key": "property/6767906449167553/019f38c3-4bc5-7718-bc97-cba8ecefb0bb.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJFaute6wRyYcRARUztZ0z6ls",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "gym"
    },
    {
      "id": "custom_00b9c967-fe99-4cf8-8043-fbffdac92608",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167553",
      "source": "custom",
      "poi_name": "IronStreetGym",
      "poi_type": "Health and Wellness",
      "poi_address": "1902 S 8th St Ste 9, Rogers, AR 72758, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167553/019f38c5-b1a1-705e-b2f0-d6d204e47c2e.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f38c5-b1a1-705e-b2f0-d6d204e47c2e",
        "storage_key": "property/6767906449167553/019f38c5-b1a1-705e-b2f0-d6d204e47c2e.webp",
        "width": 1024,
        "height": 1280
      },
      "poi_business_url": "https://www.theironstreetgym.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=9318048781649220683&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "ironstreetgym",
      "poi_latitude": "36.311104",
      "poi_longitude": "-94.1278",
      "poi_miles_from_property": "3.1",
      "poi_walking_minutes": "1 hour 7 mins",
      "poi_biking_minutes": "15 mins",
      "poi_driving_minutes": "7 mins",
      "poi_business_phone": "+1 479-644-6602",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167553/019f38c3-4bc5-7718-bc97-cba8ecefb0bb.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019f38c3-4bc5-7718-bc97-cba8ecefb0bb",
        "storage_key": "property/6767906449167553/019f38c3-4bc5-7718-bc97-cba8ecefb0bb.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJ4941UwgXyYcRS5T2bf9bUIE",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "gym"
    },
    {
      "id": "custom_5b6f1a44-13b3-4ff6-8a0a-0321cc81f43a",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167553",
      "source": "custom",
      "poi_name": "D1 Training Rogers",
      "poi_type": "Health and Wellness",
      "poi_address": "4667 S Dixieland Rd Unit 101, Rogers, AR 72758, USA",
      "poi_short_description": "Age-appropriate fitness courses in a gym setting featuring friendly staff, strength training, cardio and weight lifting.",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167553/019f38c5-af41-7022-bf7e-2c9af3b3d14e.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f38c5-af41-7022-bf7e-2c9af3b3d14e",
        "storage_key": "property/6767906449167553/019f38c5-af41-7022-bf7e-2c9af3b3d14e.webp",
        "width": 1080,
        "height": 608
      },
      "poi_business_url": "https://www.d1training.com/rogers/",
      "poi_directions_map_url": "https://maps.google.com/?cid=2939565626272940151&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "d1-training-rogers",
      "poi_latitude": "36.275032",
      "poi_longitude": "-94.1434249",
      "poi_miles_from_property": "1.5",
      "poi_walking_minutes": "33 mins",
      "poi_biking_minutes": "8 mins",
      "poi_driving_minutes": "6 mins",
      "poi_business_phone": "+1 501-382-8906",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167553/019f38c3-4bc5-7718-bc97-cba8ecefb0bb.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019f38c3-4bc5-7718-bc97-cba8ecefb0bb",
        "storage_key": "property/6767906449167553/019f38c3-4bc5-7718-bc97-cba8ecefb0bb.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJcRuE3PMXyYcRd4Dy01xvyyg",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "gym"
    },
    {
      "id": "custom_7ae25f58-9764-44be-8e66-b838d90cb609",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167553",
      "source": "custom",
      "poi_name": "Lake Atalanta Park & Trails",
      "poi_type": "Nature & Outdoor Attractions",
      "poi_address": "500 E Walnut St, Rogers, AR 72758, USA",
      "poi_short_description": "Waterfront haunt with a nature-inspired playground, paved walking path & fireplace pavilion.",
      "poi_long_description": "Waterfront haunt with a nature-inspired playground, paved walking path & fireplace pavilion.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167553/019f38c3-3746-7621-9304-57b1c50d787a.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f38c3-3746-7621-9304-57b1c50d787a",
        "storage_key": "property/6767906449167553/019f38c3-3746-7621-9304-57b1c50d787a.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "http://www.rogersar.gov/215/Lake-Atalanta",
      "poi_directions_map_url": "https://maps.google.com/?cid=13450540982588082708&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "lake-atalanta-park--trails",
      "poi_latitude": "36.3321145",
      "poi_longitude": "-94.1038864",
      "poi_miles_from_property": "5.6",
      "poi_walking_minutes": "2 hours 3 mins",
      "poi_biking_minutes": "29 mins",
      "poi_driving_minutes": "14 mins",
      "poi_business_phone": "+1 479-636-1240",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167553/019f38c3-4c01-7483-a168-dbe4bea08671.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019f38c3-4c01-7483-a168-dbe4bea08671",
        "storage_key": "property/6767906449167553/019f38c3-4c01-7483-a168-dbe4bea08671.webp",
        "width": 162,
        "height": 192
      },
      "poi_google_place_id": "ChIJYxQ1FK8XyYcRFAr_d8Lrqbo",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "park"
    },
    {
      "id": "custom_cd1343f9-e35e-402e-986c-a4a2c1451df6",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167553",
      "source": "custom",
      "poi_name": "Lake Atlanta Dog Park",
      "poi_type": "Nature & Outdoor Attractions",
      "poi_address": "1615 S Pleasant Ridge Rd, Rogers, AR 72756, USA",
      "poi_short_description": "Fenced park for pets with toys to play with, some training aids and a lake.",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167553/019f38c5-b1a1-705e-b2f0-d06719e6c991.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f38c5-b1a1-705e-b2f0-d06719e6c991",
        "storage_key": "property/6767906449167553/019f38c5-b1a1-705e-b2f0-d06719e6c991.webp",
        "width": 960,
        "height": 1280
      },
      "poi_business_url": "http://atalanta-park.edan.io/",
      "poi_directions_map_url": "https://maps.google.com/?cid=14549037204581470597&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "lake-atlanta-dog-park",
      "poi_latitude": "36.3240403",
      "poi_longitude": "-94.1005005",
      "poi_miles_from_property": "5.4",
      "poi_walking_minutes": "1 hour 58 mins",
      "poi_biking_minutes": "29 mins",
      "poi_driving_minutes": "13 mins",
      "poi_business_phone": "",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167553/019f38c3-4c01-7483-a168-dbe4bea08671.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019f38c3-4c01-7483-a168-dbe4bea08671",
        "storage_key": "property/6767906449167553/019f38c3-4c01-7483-a168-dbe4bea08671.webp",
        "width": 162,
        "height": 192
      },
      "poi_google_place_id": "ChIJDUatXq0XyYcRhVEF40CQ6Mk",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "dog_park"
    },
    {
      "id": "custom_722c5f49-36ff-4bf1-8d49-62dd70cffaa6",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167553",
      "source": "custom",
      "poi_name": "The Railyard Bike Park",
      "poi_type": "Nature & Outdoor Attractions",
      "poi_address": "299 E Cherry St, Rogers, AR 72756, USA",
      "poi_short_description": "Bike park offering trails and courses for all skill levels, picnic tables (some shaded) and WiFi.",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167553/019f38c5-b07d-7055-99b8-2f02c9c2d655.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f38c5-b07d-7055-99b8-2f02c9c2d655",
        "storage_key": "property/6767906449167553/019f38c5-b07d-7055-99b8-2f02c9c2d655.webp",
        "width": 1280,
        "height": 720
      },
      "poi_business_url": "http://rogersar.gov/Facilities/Facility/Details/The-Railyard-57",
      "poi_directions_map_url": "https://maps.google.com/?cid=11576995808912808357&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "the-railyard-bike-park",
      "poi_latitude": "36.3291019",
      "poi_longitude": "-94.1133845",
      "poi_miles_from_property": "5",
      "poi_walking_minutes": "1 hour 50 mins",
      "poi_biking_minutes": "27 mins",
      "poi_driving_minutes": "12 mins",
      "poi_business_phone": "+1 479-631-3350",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167553/019f38c3-4c01-7483-a168-dbe4bea08671.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019f38c3-4c01-7483-a168-dbe4bea08671",
        "storage_key": "property/6767906449167553/019f38c3-4c01-7483-a168-dbe4bea08671.webp",
        "width": 162,
        "height": 192
      },
      "poi_google_place_id": "ChIJ-7DLwAYXyYcRpRlvxFnAqaA",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "park"
    },
    {
      "id": "custom_cb1802b8-9c4e-4d9e-b962-c8e87fb0b61f",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167553",
      "source": "custom",
      "poi_name": "Veterans Park",
      "poi_type": "Nature & Outdoor Attractions",
      "poi_address": "500 E Veterans Pkwy, Rogers, AR 72756, USA",
      "poi_short_description": "23-acre park with soccer, baseball, football & volleyball facilities & a pond dedicated to veterans.",
      "poi_long_description": "23-acre park with soccer, baseball, football & volleyball facilities & a pond dedicated to veterans.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167553/019f38c5-b215-7450-8ea3-7b77b47f86b0.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f38c5-b215-7450-8ea3-7b77b47f86b0",
        "storage_key": "property/6767906449167553/019f38c5-b215-7450-8ea3-7b77b47f86b0.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://rogersar.gov/Facilities/Facility/Details/Veterans-Memorial-Park-25",
      "poi_directions_map_url": "https://maps.google.com/?cid=10209859539185412978&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "veterans-park",
      "poi_latitude": "36.31810919999999",
      "poi_longitude": "-94.1114328",
      "poi_miles_from_property": "4.3",
      "poi_walking_minutes": "1 hour 34 mins",
      "poi_biking_minutes": "23 mins",
      "poi_driving_minutes": "11 mins",
      "poi_business_phone": "+1 479-631-2622",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167553/019f38c3-4c01-7483-a168-dbe4bea08671.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019f38c3-4c01-7483-a168-dbe4bea08671",
        "storage_key": "property/6767906449167553/019f38c3-4c01-7483-a168-dbe4bea08671.webp",
        "width": 162,
        "height": 192
      },
      "poi_google_place_id": "ChIJG5QBsVUWyYcRcqvHHyi1sI0",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "park"
    },
    {
      "id": "custom_2db47b92-e858-464a-b281-f8526688f8dd",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167553",
      "source": "custom",
      "poi_name": "Mt Hebron Park",
      "poi_type": "Nature & Outdoor Attractions",
      "poi_address": "6174 Mount Hebron Rd, Rogers, AR 72758, USA",
      "poi_short_description": "Popular space offering playground areas, soccer fields, dog parks and walking trails.",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167553/019f38c3-3666-70ae-aa1a-3254afa888e7.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f38c3-3666-70ae-aa1a-3254afa888e7",
        "storage_key": "property/6767906449167553/019f38c3-3666-70ae-aa1a-3254afa888e7.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://www.rogersar.gov/Facilities/Facility/Details/Mt-Hebron-Park-70",
      "poi_directions_map_url": "https://maps.google.com/?cid=16778887041516633069&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "mt-hebron-park",
      "poi_latitude": "36.2751894",
      "poi_longitude": "-94.198216",
      "poi_miles_from_property": "4",
      "poi_walking_minutes": "1 hour 27 mins",
      "poi_biking_minutes": "22 mins",
      "poi_driving_minutes": "11 mins",
      "poi_business_phone": "+1 479-631-3350",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167553/019f38c3-4c01-7483-a168-dbe4bea08671.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019f38c3-4c01-7483-a168-dbe4bea08671",
        "storage_key": "property/6767906449167553/019f38c3-4c01-7483-a168-dbe4bea08671.webp",
        "width": 162,
        "height": 192
      },
      "poi_google_place_id": "ChIJLR15b4cTyYcR7fsArN2U2ug",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "park"
    },
    {
      "id": "custom_02b49d95-a02d-4aca-abc4-0856649356bf",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167553",
      "source": "custom",
      "poi_name": "Blossom Way Trailhead",
      "poi_type": "Nature & Outdoor Attractions",
      "poi_address": "3414 S Dixieland Rd, Rogers, AR 72758, USA",
      "poi_short_description": "Walking path, picnic area, and creek with a disc golf course.",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167553/019f38c5-b7c5-764a-9341-c15cc1f3eac1.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f38c5-b7c5-764a-9341-c15cc1f3eac1",
        "storage_key": "property/6767906449167553/019f38c5-b7c5-764a-9341-c15cc1f3eac1.webp",
        "width": 960,
        "height": 1280
      },
      "poi_business_url": "http://www.rogersar.gov/Facilities/Facility/Details/Blossom-Way-1",
      "poi_directions_map_url": "https://maps.google.com/?cid=16307554709785714854&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "blossom-way-trailhead",
      "poi_latitude": "36.29691529999999",
      "poi_longitude": "-94.1448992",
      "poi_miles_from_property": "1.1",
      "poi_walking_minutes": "23 mins",
      "poi_biking_minutes": "6 mins",
      "poi_driving_minutes": "3 mins",
      "poi_business_phone": "",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167553/019f38c5-cd72-7793-86c2-e3ea0584ce13.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019f38c5-cd72-7793-86c2-e3ea0584ce13",
        "storage_key": "property/6767906449167553/019f38c5-cd72-7793-86c2-e3ea0584ce13.webp",
        "width": 132,
        "height": 192
      },
      "poi_google_place_id": "ChIJnVx89rYWyYcRpqAGgJsSUOI",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "hiking_area"
    },
    {
      "id": "custom_b7d005f2-e7b8-4347-937a-4e0050ab424c",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167553",
      "source": "custom",
      "poi_name": "Rogers Public Library",
      "poi_type": "Education",
      "poi_address": "711 S Dixieland Rd, Rogers, AR 72758, USA",
      "poi_short_description": "Public library providing books, audio books, movies, and computers, plus kids' activities.",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167553/019f38c5-b3de-74eb-97b3-5f632ce23dc0.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f38c5-b3de-74eb-97b3-5f632ce23dc0",
        "storage_key": "property/6767906449167553/019f38c5-b3de-74eb-97b3-5f632ce23dc0.webp",
        "width": 960,
        "height": 637
      },
      "poi_business_url": "http://www.rogerspubliclibrary.org/",
      "poi_directions_map_url": "https://maps.google.com/?cid=15834976279484787923&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "rogers-public-library",
      "poi_latitude": "36.3280118",
      "poi_longitude": "-94.14266",
      "poi_miles_from_property": "3.3",
      "poi_walking_minutes": "1 hour 12 mins",
      "poi_biking_minutes": "17 mins",
      "poi_driving_minutes": "9 mins",
      "poi_business_phone": "+1 479-621-1152",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167553/019f38c3-4bf2-76e7-9858-86fdbf61466c.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019f38c3-4bf2-76e7-9858-86fdbf61466c",
        "storage_key": "property/6767906449167553/019f38c3-4bf2-76e7-9858-86fdbf61466c.webp",
        "width": 192,
        "height": 174
      },
      "poi_google_place_id": "ChIJU-qnIy8XyYcR02xtZQcjwds",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "library"
    },
    {
      "id": "custom_cfe4fc1f-4180-420a-9b0d-35ff4928d90c",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167553",
      "source": "custom",
      "poi_name": "Rogers Aquatics Center",
      "poi_type": "Entertainment",
      "poi_address": "1707 S 26th St, Rogers, AR 72758, USA",
      "poi_short_description": "3-acre outdoor public water park with multiple pools & slides, a lazy river & concessions.",
      "poi_long_description": "3-acre outdoor public water park with multiple pools & slides, a lazy river & concessions.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167553/019f38c3-1c97-701b-af31-c353726042ba.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f38c3-1c97-701b-af31-c353726042ba",
        "storage_key": "property/6767906449167553/019f38c3-1c97-701b-af31-c353726042ba.webp",
        "width": 851,
        "height": 315
      },
      "poi_business_url": "http://www.rogersaquaticscenter.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=11875015164423130408&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "rogers-aquatics-center",
      "poi_latitude": "36.316846",
      "poi_longitude": "-94.155875",
      "poi_miles_from_property": "2.2",
      "poi_walking_minutes": "49 mins",
      "poi_biking_minutes": "12 mins",
      "poi_driving_minutes": "5 mins",
      "poi_business_phone": "+1 479-936-5482",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167553/019f38c3-4bc5-7718-bc97-cba8ecefb0bb.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019f38c3-4bc5-7718-bc97-cba8ecefb0bb",
        "storage_key": "property/6767906449167553/019f38c3-4bc5-7718-bc97-cba8ecefb0bb.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJkeYh37oXyYcRKE3RIWCHzKQ",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "water_park"
    },
    {
      "id": "custom_76980d4d-1cc9-4670-a5ba-f7c68245be0c",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167553",
      "source": "custom",
      "poi_name": "Cambridge Park",
      "poi_type": "Nature & Outdoor Attractions",
      "poi_address": "3711 W Easy St, Rogers, AR 72756, USA",
      "poi_short_description": "Neighborhood park with play structures, trails, and a pond.",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167553/019f38c5-b8f7-75ef-93b5-842a63547796.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f38c5-b8f7-75ef-93b5-842a63547796",
        "storage_key": "property/6767906449167553/019f38c5-b8f7-75ef-93b5-842a63547796.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://www.rogersar.gov/1101/Parks-and-Recreation",
      "poi_directions_map_url": "https://maps.google.com/?cid=14430913884429153048&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "cambridge-park",
      "poi_latitude": "36.3484334",
      "poi_longitude": "-94.1697417",
      "poi_miles_from_property": "5",
      "poi_walking_minutes": "1 hour 50 mins",
      "poi_biking_minutes": "41 mins",
      "poi_driving_minutes": "14 mins",
      "poi_business_phone": "",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167553/019f38c3-4c01-7483-a168-dbe4bea08671.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019f38c3-4c01-7483-a168-dbe4bea08671",
        "storage_key": "property/6767906449167553/019f38c3-4c01-7483-a168-dbe4bea08671.webp",
        "width": 162,
        "height": 192
      },
      "poi_google_place_id": "ChIJj7c3zr0QyYcRGPOmObjnRMg",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "park"
    },
    {
      "id": "custom_86be852d-c298-4e74-ac02-6a0e2d6a39cb",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167553",
      "source": "custom",
      "poi_name": "Hobbs State Park-Conservation Area Visitor Center",
      "poi_type": "Entertainment",
      "poi_address": "20201 AR-12, Rogers, AR 72756, USA",
      "poi_short_description": "Visitor center and park with exhibits, trails and wildlife sightings.",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167553/019f38c5-b894-71ba-aa7b-f5242214ccaf.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f38c5-b894-71ba-aa7b-f5242214ccaf",
        "storage_key": "property/6767906449167553/019f38c5-b894-71ba-aa7b-f5242214ccaf.webp",
        "width": 1280,
        "height": 1280
      },
      "poi_business_url": "https://www.arkansasstateparks.com/parks/hobbs-state-park-conservation-area",
      "poi_directions_map_url": "https://maps.google.com/?cid=18389029455639529245&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "hobbs-state-park-conservation-area-visitor-center",
      "poi_latitude": "36.2848943",
      "poi_longitude": "-93.9386871",
      "poi_miles_from_property": "29.3",
      "poi_walking_minutes": "10 hours 52 mins",
      "poi_biking_minutes": "1 hour 41 mins",
      "poi_driving_minutes": "32 mins",
      "poi_business_phone": "+1 479-789-5000",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167553/019f38c3-4bc5-7718-bc97-cba8ecefb0bb.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019f38c3-4bc5-7718-bc97-cba8ecefb0bb",
        "storage_key": "property/6767906449167553/019f38c3-4bc5-7718-bc97-cba8ecefb0bb.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJRcCyh4c5yYcRHceWU9z0Mv8",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "visitor_center"
    },
    {
      "id": "custom_dd098878-ca8f-4df1-805b-2d939e1331e3",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167553",
      "source": "custom",
      "poi_name": "Northwest Arkansas National Airport",
      "poi_type": "Transportation & Transit",
      "poi_address": "1 Airport Blvd, Bentonville, AR 72713, USA",
      "poi_short_description": "Domestic airport featuring a yoga room, free WiFi, an arcade & games such as chess & checkers.",
      "poi_long_description": "Domestic airport featuring a yoga room, free WiFi, an arcade & games such as chess & checkers.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167553/019f38c5-b7e8-7779-b6e9-24c505314255.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f38c5-b7e8-7779-b6e9-24c505314255",
        "storage_key": "property/6767906449167553/019f38c5-b7e8-7779-b6e9-24c505314255.webp",
        "width": 640,
        "height": 960
      },
      "poi_business_url": "https://www.flyxna.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=3592327295282605376&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "northwest-arkansas-national-airport",
      "poi_latitude": "36.2805838",
      "poi_longitude": "-94.3045816",
      "poi_miles_from_property": "13.1",
      "poi_walking_minutes": "4 hours 47 mins",
      "poi_biking_minutes": "1 hour 14 mins",
      "poi_driving_minutes": "23 mins",
      "poi_business_phone": "+1 479-205-1000",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167553/019f38c3-4c03-718b-b0b3-de38863641da.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019f38c3-4c03-718b-b0b3-de38863641da",
        "storage_key": "property/6767906449167553/019f38c3-4c03-718b-b0b3-de38863641da.webp",
        "width": 182,
        "height": 192
      },
      "poi_google_place_id": "ChIJBXPzbKUOyYcRQG1CYKSC2jE",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "airport"
    },
    {
      "id": "custom_8fce0856-57c9-42e5-a8da-a2368d87950d",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167553",
      "source": "custom",
      "poi_name": "Ozark Regional Transit",
      "poi_type": "Transportation & Transit",
      "poi_address": "2423 E Robinson Ave, Springdale, AR 72764, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": null,
      "poi_featured_image_media": null,
      "poi_business_url": "https://www.ozark.org/",
      "poi_directions_map_url": "https://maps.google.com/?cid=403391728593572087&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "ozark-regional-transit",
      "poi_latitude": "36.1662982",
      "poi_longitude": "-94.1041876",
      "poi_miles_from_property": "10.9",
      "poi_walking_minutes": "3 hours 59 mins",
      "poi_biking_minutes": "1 hour 18 mins",
      "poi_driving_minutes": "22 mins",
      "poi_business_phone": "+1 479-756-5901",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167553/019f38c3-4bc5-7718-bc97-cba8ecefb0bb.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019f38c3-4bc5-7718-bc97-cba8ecefb0bb",
        "storage_key": "property/6767906449167553/019f38c3-4bc5-7718-bc97-cba8ecefb0bb.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJyfVTTwBryYcR95Am0KMimQU",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "transportation_service"
    },
    {
      "id": "custom_69ef4149-ae5a-40a3-af64-443ff95babc6",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167553",
      "source": "custom",
      "poi_name": "Rogers Executive Airport",
      "poi_type": "Transportation & Transit",
      "poi_address": "3 W Airport Dr, Rogers, AR 72756, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167553/019f38c5-bd41-7058-a62f-27be9236d251.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f38c5-bd41-7058-a62f-27be9236d251",
        "storage_key": "property/6767906449167553/019f38c5-bd41-7058-a62f-27be9236d251.webp",
        "width": 721,
        "height": 1280
      },
      "poi_business_url": "http://rogersar.gov/190/Airport",
      "poi_directions_map_url": "https://maps.google.com/?cid=11963880829033104478&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "rogers-executive-airport",
      "poi_latitude": "36.372223",
      "poi_longitude": "-94.106941",
      "poi_miles_from_property": "8",
      "poi_walking_minutes": "2 hours 55 mins",
      "poi_biking_minutes": "42 mins",
      "poi_driving_minutes": "18 mins",
      "poi_business_phone": "+1 479-631-1400",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167553/019f38c3-4c03-718b-b0b3-de38863641da.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019f38c3-4c03-718b-b0b3-de38863641da",
        "storage_key": "property/6767906449167553/019f38c3-4c03-718b-b0b3-de38863641da.webp",
        "width": 182,
        "height": 192
      },
      "poi_google_place_id": "ChIJzV0jGiwYyYcRXsSfBTo-CKY",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "airport"
    },
    {
      "id": "custom_cb487e17-4851-4bad-89d4-a7f11b8c079f",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167553",
      "source": "custom",
      "poi_name": "Jefferson Lines",
      "poi_type": "Transportation & Transit",
      "poi_address": "1710 W Hudson Rd, Rogers, AR 72756, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": null,
      "poi_featured_image_media": null,
      "poi_business_url": "https://www.jeffersonlines.com/bus-stops/arkansas/?utm_source=GMB",
      "poi_directions_map_url": "https://maps.google.com/?cid=6339997808210727341&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "jefferson-lines",
      "poi_latitude": "36.35521",
      "poi_longitude": "-94.142508",
      "poi_miles_from_property": "5.2",
      "poi_walking_minutes": "1 hour 54 mins",
      "poi_biking_minutes": "34 mins",
      "poi_driving_minutes": "13 mins",
      "poi_business_phone": "+1 858-800-8898",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167553/019f38c3-4bc5-7718-bc97-cba8ecefb0bb.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019f38c3-4bc5-7718-bc97-cba8ecefb0bb",
        "storage_key": "property/6767906449167553/019f38c3-4bc5-7718-bc97-cba8ecefb0bb.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJ_QHyHO4QyYcRrdEnc2oy_Fc",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "transportation_service"
    },
    {
      "id": "custom_5ae52181-e542-4cbc-a920-3b6f5fb8cbb6",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167553",
      "source": "custom",
      "poi_name": "Bentonville Community Center",
      "poi_type": "Entertainment",
      "poi_address": "1101 SW Citizens Cir, Bentonville, AR 72712, USA",
      "poi_short_description": "Clean community center featuring a lap pool, a kids-only pool and an outdoor playground.",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167553/019f38c5-baff-7785-94f2-a8526dc6db73.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f38c5-baff-7785-94f2-a8526dc6db73",
        "storage_key": "property/6767906449167553/019f38c5-baff-7785-94f2-a8526dc6db73.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "http://www.bentonvillear.com/359/Community-Center",
      "poi_directions_map_url": "https://maps.google.com/?cid=17378480803937372516&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "bentonville-community-center",
      "poi_latitude": "36.3309331",
      "poi_longitude": "-94.225257",
      "poi_miles_from_property": "6.5",
      "poi_walking_minutes": "2 hours 22 mins",
      "poi_biking_minutes": "40 mins",
      "poi_driving_minutes": "15 mins",
      "poi_business_phone": "+1 479-696-0200",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167553/019f38c3-4bc5-7718-bc97-cba8ecefb0bb.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019f38c3-4bc5-7718-bc97-cba8ecefb0bb",
        "storage_key": "property/6767906449167553/019f38c3-4bc5-7718-bc97-cba8ecefb0bb.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJ13SsDCUQyYcRZMmhTjfELPE",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "community_center"
    },
    {
      "id": "custom_76281343-bd12-45a8-a1f3-6dd376d6f5b0",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167553",
      "source": "custom",
      "poi_name": "Mercy Rehabilitation Hospital Northwest Arkansas",
      "poi_type": "Major Employers & Offices",
      "poi_address": "4313 S Pleasant Crossing Blvd, Rogers, AR 72758, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167553/019f38c5-bc78-72b7-a00e-04951b1c37d4.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f38c5-bc78-72b7-a00e-04951b1c37d4",
        "storage_key": "property/6767906449167553/019f38c5-bc78-72b7-a00e-04951b1c37d4.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "http://www.rogersrehabhospital.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=15928303771912168142&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "mercy-rehabilitation-hospital-northwest-arkansas",
      "poi_latitude": "36.2785567",
      "poi_longitude": "-94.1461076",
      "poi_miles_from_property": "1.1",
      "poi_walking_minutes": "25 mins",
      "poi_biking_minutes": "6 mins",
      "poi_driving_minutes": "4 mins",
      "poi_business_phone": "+1 479-341-4003",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167553/019f38c3-4bc5-7718-bc97-cba8ecefb0bb.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019f38c3-4bc5-7718-bc97-cba8ecefb0bb",
        "storage_key": "property/6767906449167553/019f38c3-4bc5-7718-bc97-cba8ecefb0bb.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJ1cAR7s4XyYcRzuJWh-OzDN0",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "health"
    },
    {
      "id": "custom_6efc5c52-91dd-4d31-a710-f5bdc3ab1c5c",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167553",
      "source": "custom",
      "poi_name": "Arkansas Children's Northwest Hospital",
      "poi_type": "Health and Wellness",
      "poi_address": "2601 S Gene George Blvd, Springdale, AR 72762, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167553/019f38c5-be1a-743c-842b-e1f405b74926.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f38c5-be1a-743c-842b-e1f405b74926",
        "storage_key": "property/6767906449167553/019f38c5-be1a-743c-842b-e1f405b74926.webp",
        "width": 718,
        "height": 404
      },
      "poi_business_url": "https://www.archildrens.org/",
      "poi_directions_map_url": "https://maps.google.com/?cid=3684343552893161194&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "arkansas-childrens-northwest-hospital",
      "poi_latitude": "36.162254",
      "poi_longitude": "-94.1903619",
      "poi_miles_from_property": "11.5",
      "poi_walking_minutes": "4 hours 14 mins",
      "poi_biking_minutes": "1 hour 19 mins",
      "poi_driving_minutes": "16 mins",
      "poi_business_phone": "+1 479-309-5391",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167553/019f38c3-4be7-73dc-9fc1-7340dfd55887.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019f38c3-4be7-73dc-9fc1-7340dfd55887",
        "storage_key": "property/6767906449167553/019f38c3-4be7-73dc-9fc1-7340dfd55887.webp",
        "width": 134,
        "height": 192
      },
      "poi_google_place_id": "ChIJXS06JeJsyYcR6o6y3PBqITM",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "hospital"
    },
    {
      "id": "custom_7faa4d44-fad2-4c18-9232-5c4ee1d2fc8f",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167553",
      "source": "custom",
      "poi_name": "Tyson Foods World Headquarters",
      "poi_type": "Major Employers & Offices",
      "poi_address": "2200 W Don Tyson Pkwy, Springdale, AR 72762, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167553/019f38c5-bffb-701d-a620-77b92dab6021.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f38c5-bffb-701d-a620-77b92dab6021",
        "storage_key": "property/6767906449167553/019f38c5-bffb-701d-a620-77b92dab6021.webp",
        "width": 1280,
        "height": 576
      },
      "poi_business_url": "http://www.tysonfoods.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=16323102854454874636&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "tyson-foods-world-headquarters",
      "poi_latitude": "36.1546202",
      "poi_longitude": "-94.1541342",
      "poi_miles_from_property": "10.6",
      "poi_walking_minutes": "3 hours 55 mins",
      "poi_biking_minutes": "1 hour 10 mins",
      "poi_driving_minutes": "18 mins",
      "poi_business_phone": "+1 800-643-3410",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167553/019f38c3-4bc5-7718-bc97-cba8ecefb0bb.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019f38c3-4bc5-7718-bc97-cba8ecefb0bb",
        "storage_key": "property/6767906449167553/019f38c3-4bc5-7718-bc97-cba8ecefb0bb.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJ2QqgXhdryYcRDJLyB5BPh-I",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "corporate_office"
    },
    {
      "id": "custom_7b28e9b9-dff4-4cc0-a50a-f80cae1bb33e",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167553",
      "source": "custom",
      "poi_name": "Walmart Layout Center",
      "poi_type": "Major Employers & Offices",
      "poi_address": "2101 SE 8th St, Bentonville, AR 72712, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167553/019f38c5-c1c2-775f-a16a-fc5c47d676a0.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f38c5-c1c2-775f-a16a-fc5c47d676a0",
        "storage_key": "property/6767906449167553/019f38c5-c1c2-775f-a16a-fc5c47d676a0.webp",
        "width": 1280,
        "height": 719
      },
      "poi_business_url": "http://corporate.walmart.com/?veh=seo_loc",
      "poi_directions_map_url": "https://maps.google.com/?cid=13315608816675836776&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "walmart-layout-center",
      "poi_latitude": "36.3652592",
      "poi_longitude": "-94.1862064",
      "poi_miles_from_property": "7",
      "poi_walking_minutes": "2 hours 34 mins",
      "poi_biking_minutes": "44 mins",
      "poi_driving_minutes": "11 mins",
      "poi_business_phone": "+1 479-277-9005",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167553/019f38c3-4bc5-7718-bc97-cba8ecefb0bb.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019f38c3-4bc5-7718-bc97-cba8ecefb0bb",
        "storage_key": "property/6767906449167553/019f38c3-4bc5-7718-bc97-cba8ecefb0bb.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJz6aU-UkbyYcRaNMFbquLyrg",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "corporate_office"
    },
    {
      "id": "custom_743f1d8d-400e-40fb-999b-8d3bb6756fa0",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167553",
      "source": "custom",
      "poi_name": "Sam's Club Headquarters",
      "poi_type": "Major Employers & Offices",
      "poi_address": "2101 SE Simple Savings Dr #2101, Bentonville, AR 72712, USA",
      "poi_short_description": "Membership-only warehouse chain selling a variety of bulk grocery items, electronics & home goods.",
      "poi_long_description": "Membership-only warehouse chain selling a variety of bulk grocery items, electronics & home goods.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167553/019f38c5-c00d-70ce-8cdd-6f2d1a56719d.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f38c5-c00d-70ce-8cdd-6f2d1a56719d",
        "storage_key": "property/6767906449167553/019f38c5-c00d-70ce-8cdd-6f2d1a56719d.webp",
        "width": 1280,
        "height": 720
      },
      "poi_business_url": "https://www.samsclub.com/club/bentonville-ar-sams-club/6214",
      "poi_directions_map_url": "https://maps.google.com/?cid=2386529284113169375&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "sams-club-headquarters",
      "poi_latitude": "36.3459593",
      "poi_longitude": "-94.1867553",
      "poi_miles_from_property": "5.6",
      "poi_walking_minutes": "2 hours 4 mins",
      "poi_biking_minutes": "35 mins",
      "poi_driving_minutes": "11 mins",
      "poi_business_phone": "+1 479-273-4000",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167553/019f38c3-4bc5-7718-bc97-cba8ecefb0bb.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019f38c3-4bc5-7718-bc97-cba8ecefb0bb",
        "storage_key": "property/6767906449167553/019f38c3-4bc5-7718-bc97-cba8ecefb0bb.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJq6qqD4wQyYcR3_uhUb2nHiE",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "corporate_office"
    },
    {
      "id": "custom_b2b7105c-64fc-44c8-a1bf-826454d8d834",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167553",
      "source": "custom",
      "poi_name": "J.B. Hunt Transport Services, Inc.",
      "poi_type": "Transportation & Transit",
      "poi_address": "615 JB Hunt Corporate Dr, Lowell, AR 72745, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167553/019f38c5-c240-70a0-b296-962ea4c56947.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f38c5-c240-70a0-b296-962ea4c56947",
        "storage_key": "property/6767906449167553/019f38c5-c240-70a0-b296-962ea4c56947.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://www.jbhunt.com/?utm_source=GoogleMyBusiness&utm_medium=organic",
      "poi_directions_map_url": "https://maps.google.com/?cid=11570535468398063576&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "jb-hunt-transport-services-inc",
      "poi_latitude": "36.2447313",
      "poi_longitude": "-94.1494438",
      "poi_miles_from_property": "3.6",
      "poi_walking_minutes": "1 hour 19 mins",
      "poi_biking_minutes": "19 mins",
      "poi_driving_minutes": "10 mins",
      "poi_business_phone": "+1 479-820-0000",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167553/019f38c3-4bc5-7718-bc97-cba8ecefb0bb.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019f38c3-4bc5-7718-bc97-cba8ecefb0bb",
        "storage_key": "property/6767906449167553/019f38c3-4bc5-7718-bc97-cba8ecefb0bb.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJ9YjK4HkUyYcR2K_shrTMkqA",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "transportation_service"
    },
    {
      "id": "custom_d58c08ce-8fe3-49f3-8baa-8509706a99d7",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167553",
      "source": "custom",
      "poi_name": "Freeman Health System – Bentonville Medical Center",
      "poi_type": "Health and Wellness",
      "poi_address": "3000 Medical Center Pkwy, Bentonville, AR 72712, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167553/019f38c3-34d9-7458-95d5-e4040339c207.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f38c3-34d9-7458-95d5-e4040339c207",
        "storage_key": "property/6767906449167553/019f38c3-34d9-7458-95d5-e4040339c207.webp",
        "width": 1280,
        "height": 771
      },
      "poi_business_url": "https://www.freemanhealthnw.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=12521861175053738530&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "freeman-health-system--bentonville-medical-center",
      "poi_latitude": "36.3401491",
      "poi_longitude": "-94.1912939",
      "poi_miles_from_property": "5.2",
      "poi_walking_minutes": "1 hour 54 mins",
      "poi_biking_minutes": "34 mins",
      "poi_driving_minutes": "11 mins",
      "poi_business_phone": "+1 479-553-1000",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167553/019f38c3-4be7-73dc-9fc1-7340dfd55887.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019f38c3-4be7-73dc-9fc1-7340dfd55887",
        "storage_key": "property/6767906449167553/019f38c3-4be7-73dc-9fc1-7340dfd55887.webp",
        "width": 134,
        "height": 192
      },
      "poi_google_place_id": "ChIJjdkIQPUQyYcRImLVIWWWxq0",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "medical_center"
    },
    {
      "id": "custom_19a05235-c615-45bd-b909-f32aaaf04ade",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167553",
      "source": "custom",
      "poi_name": "Washington Regional Medical Center",
      "poi_type": "Health and Wellness",
      "poi_address": "3215 N Northhills Blvd, Fayetteville, AR 72703, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167553/019f38c5-c432-7569-999d-9e8e1417c2e5.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f38c5-c432-7569-999d-9e8e1417c2e5",
        "storage_key": "property/6767906449167553/019f38c5-c432-7569-999d-9e8e1417c2e5.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://www.wregional.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=8238757131725164352&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "washington-regional-medical-center",
      "poi_latitude": "36.1096432",
      "poi_longitude": "-94.1593774",
      "poi_miles_from_property": "14.6",
      "poi_walking_minutes": "5 hours 21 mins",
      "poi_biking_minutes": "1 hour 44 mins",
      "poi_driving_minutes": "18 mins",
      "poi_business_phone": "+1 479-463-1000",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167553/019f38c3-4be7-73dc-9fc1-7340dfd55887.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019f38c3-4be7-73dc-9fc1-7340dfd55887",
        "storage_key": "property/6767906449167553/019f38c3-4be7-73dc-9fc1-7340dfd55887.webp",
        "width": 134,
        "height": 192
      },
      "poi_google_place_id": "ChIJa-G3fwRsyYcRQM8x4_XxVXI",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "medical_center"
    },
    {
      "id": "custom_bbf9e0bb-5c18-4983-ae61-4516ade48869",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167553",
      "source": "custom",
      "poi_name": "Benton County Courthouse",
      "poi_type": "Major Employers & Offices",
      "poi_address": "106 SE A St, Bentonville, AR 72712, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167553/019f38c5-c514-77c9-a9e3-32348b830892.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f38c5-c514-77c9-a9e3-32348b830892",
        "storage_key": "property/6767906449167553/019f38c5-c514-77c9-a9e3-32348b830892.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://www.bentonvillear.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=1195795037200414699&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "benton-county-courthouse",
      "poi_latitude": "36.37255469999999",
      "poi_longitude": "-94.2074966",
      "poi_miles_from_property": "8.2",
      "poi_walking_minutes": "3 hours 1 min",
      "poi_biking_minutes": "49 mins",
      "poi_driving_minutes": "15 mins",
      "poi_business_phone": "",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167553/019f38c5-cdac-74fa-a72b-eec46416da16.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019f38c5-cdac-74fa-a72b-eec46416da16",
        "storage_key": "property/6767906449167553/019f38c5-cdac-74fa-a72b-eec46416da16.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJ4dTkkpkayYcR63eBMEBRmBA",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "local_government_office"
    }
  ],
  "office_hours": [
    {
      "id": "ec_8e8779369cb5f5246ea32346",
      "source": "google_places",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167553",
      "day": "MON",
      "open_time": "08:30",
      "close_time": "17:30"
    },
    {
      "id": "ec_59abadc9f2b3afd2c55e0106",
      "source": "google_places",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167553",
      "day": "TUE",
      "open_time": "08:30",
      "close_time": "17:30"
    },
    {
      "id": "ec_0450947afc47761e81bc173b",
      "source": "google_places",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167553",
      "day": "WED",
      "open_time": "08:30",
      "close_time": "17:30"
    },
    {
      "id": "ec_b218c573a0fdeda096483ad0",
      "source": "google_places",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167553",
      "day": "THU",
      "open_time": "08:30",
      "close_time": "17:30"
    },
    {
      "id": "ec_4ac1d05b2150652149a979e5",
      "source": "google_places",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167553",
      "day": "FRI",
      "open_time": "08:30",
      "close_time": "17:30"
    },
    {
      "id": "ec_6eaa531020684bb9f86b73a6",
      "source": "google_places",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167553",
      "day": "SAT",
      "open_time": "10:00",
      "close_time": "14:00"
    }
  ],
  "reviews": [
    {
      "id": "ec_178d5b1e51adc6910ceb766a",
      "source": "apartments",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167553",
      "rating": "5",
      "name": "false",
      "text": "Amazing place with even more amazing office staff!  5 stars doesn’t do them (or this place) justice! ",
      "date": "false",
      "title": "UNBELIEVABLE PLACE!!!"
    },
    {
      "id": "ec_b2848e48eb4cd2bcb0243fbf",
      "source": "apartments",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167553",
      "rating": "4",
      "name": "false",
      "text": "I have lived here six months and it was definitely worth the wait. Brittany the property manager is professional, helpful and great with communication. Maintenance has been minor and all requests handled in a timely and friendly manner. Although all the amenities aren’t all open I have used the gym, conference room and of course Starbucks machine. Can’t wait for the rest ??. My unit is so bright and well laid out and well insulated. Other tenants I’ve met have been pretty friendly and the amazon package lockers are awesome. If you are looking for a safe, beautiful and great location this is it. My rating is really more 4.5…only downside is the lack of adherence to the trash policy. Hopefully that gets resolved pretty quickly so the buildings will remain well maintained. ",
      "date": "false",
      "title": "Great Property"
    }
  ],
  "virtual_tours": [],
  "faqs": [],
  "lead_collectors": [],
  "hyperlocal_queries": [
    {
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167553",
      "source": "generator",
      "page_item_url": "pet-friendly-apartments-rogers-ar-fitzroy-grove",
      "search_query": "pet friendly apartments rogers ar",
      "category": "Amenity",
      "h1_title": "Pet Friendly Apartments in Rogers, AR",
      "h2_subtitle": "Find your pet friendly apartment at Fitzroy Grove in Rogers, AR. Discover spacious living with amenities perfect for a pet-loving lifestyle.",
      "page_copy": "Welcome to Fitzroy Grove, where we offer pet friendly apartments in Rogers, AR designed for you and your furry friends. Our community provides spacious and comfortable living spaces with premium amenities such as ultra-high ceilings ranging from 9ft to an airy 14ft, perfect for providing your pets with room to roam. Relax in our recreational lounge or take a dip in our resort-style pool after a walk with your pet around our beautifully maintained grounds.\n\nAt Fitzroy Grove, we understand that pets are family. Located conveniently in Rogers, AR, our community is surrounded by pet-friendly parks and trails perfect for outdoor adventures with your four-legged companions. With designer tile backsplashes and stylish ceiling fans in every unit, you and your pet can enjoy a blend of luxury and comfort. Experience the best in pet-friendly living at Fitzroy Grove, where both you and your pets will feel right at home.",
      "featured_image": null,
      "featured_image_media": null,
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Pet Friendly Apartments in Rogers, AR",
      "seo_description": "Explore Fitzroy Grove's pet friendly apartments in Rogers, AR. Spacious homes and great amenities await both you and your furry friends.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167553",
      "source": "generator",
      "page_item_url": "apartments-with-pool-benton-county-fitzroy-grove",
      "search_query": "apartments with pool benton county",
      "category": "Amenity",
      "h1_title": "Apartments with Pool in Benton County",
      "h2_subtitle": "Discover Fitzroy Grove in Benton County, featuring a resort-style pool. Enjoy luxury living with great amenities at our apartments.",
      "page_copy": "Welcome to Fitzroy Grove, your premier destination for apartments with a pool in Benton County. Our community boasts a stunning resort-style pool, offering a serene escape right outside your home. Whether you prefer an early morning swim or lounging poolside on a sunny afternoon, our pool is the perfect place to refresh and unwind.\n\nLocated in the heart of Benton County, Fitzroy Grove offers more than just a fantastic pool. Our apartments feature high-end amenities such as ceiling fans and striking designer tile backsplashes. With ceilings soaring from 9ft to an impressive 14ft, our spacious apartments ensure comfort and style. Come and enjoy the vibrant living experience enhanced by both our luxurious pool and the friendly community at Fitzroy Grove.",
      "featured_image": null,
      "featured_image_media": null,
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Apartments with Pool in Benton County",
      "seo_description": "Explore Fitzroy Grove in Benton County for apartments with a resort-style pool. Luxury amenities and a refreshing lifestyle await you.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167553",
      "source": "generator",
      "page_item_url": "luxury-apartments-private-garages-rogers-fitzroy-grove",
      "search_query": "luxury apartments with private garages rogers",
      "category": "Amenity",
      "h1_title": "Luxury Apartments with Private Garages",
      "h2_subtitle": "Discover luxury living at Fitzroy Grove in Rogers, featuring private garages and high-end amenities. Experience unmatched comfort and convenience.",
      "page_copy": "Welcome to Fitzroy Grove, where luxury meets convenience in Rogers. Our luxury apartments offer private garages, providing you with a secure and exclusive parking solution right at your doorstep. This added convenience complements the elegant living experience we provide, ensuring you enjoy both extravagance and practicality every day.\n\nFitzroy Grove isn't just about privacy and security; it’s about living in style. With features such as designer tile backsplashes and generously high ceilings from 9ft to 14ft, our community ensures you live in comfort. Bask in the natural light filtering through your expansive windows or cool off with our stylish ceiling fans. Located in the thriving city of Rogers, Fitzroy Grove offers everything you need in luxury living, including our resort-style pool and recreational lounge. Indulge yourself in the superior lifestyle choice here at Fitzroy Grove.",
      "featured_image": null,
      "featured_image_media": null,
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Luxury Apartments with Private Garages",
      "seo_description": "Find luxury apartments with private garages at Fitzroy Grove in Rogers. Enjoy secure parking and top amenities today.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167553",
      "source": "generator",
      "page_item_url": "in-unit-laundry-apartments-72758-fitzroy-grove",
      "search_query": "in-unit laundry apartments 72758",
      "category": "Amenity",
      "h1_title": "In-Unit Laundry Apartments in 72758",
      "h2_subtitle": "Experience the convenience of in-unit laundry at Fitzroy Grove, located in the 72758 area. Simplify your lifestyle with modern amenities at our apartments.",
      "page_copy": "Find your ideal home at Fitzroy Grove, offering in-unit laundry apartments in the vibrant 72758 area. Our community ensures residents enjoy modern conveniences, like the hassle-free luxury of having a washer and dryer in each apartment, making laundry day a breeze.\n\nLocated conveniently in Rogers, AR, Fitzroy Grove combines practical living with premium amenities. Step into our spacious apartments with exceptional features such as designer tile backsplashes, towering ceilings from 9ft to 14ft, and stylish ceiling fans. Beyond personal conveniences, relish community amenities like our resort-style pool and a welcoming recreational lounge that enhances your living experience. Make Fitzroy Grove your new home and enjoy a seamless blend of comfort and efficiency.",
      "featured_image": null,
      "featured_image_media": null,
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "In-Unit Laundry Apartments in 72758",
      "seo_description": "Discover in-unit laundry at Fitzroy Grove in 72758. Enjoy modern living with convenient amenities in Rogers.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167553",
      "source": "generator",
      "page_item_url": "dog-friendly-apartments-park-rogers-ar-fitzroy-grove",
      "search_query": "dog friendly apartments with park rogers ar",
      "category": "Amenity",
      "h1_title": "Dog Friendly Apartments with Park in Rogers",
      "h2_subtitle": "Explore Fitzroy Grove in Rogers, AR, perfect for pet lovers with a nearby park. Enjoy a welcoming home for you and your furry friend.",
      "page_copy": "At Fitzroy Grove, embrace a lifestyle that celebrates both you and your canine companion. Located in Rogers, AR, our dog-friendly apartments are ideally situated near a lovely park, offering plenty of green space for play, exercise, and relaxation with your furry friend.\n\nOur community combines the comforts of luxury living with the warm welcome extended to all pets. Enjoy spacious interiors featuring high ceilings from 9ft to 14ft, designer tile backsplashes, and convenient in-home amenities such as ceiling fans. Outside your doorstep, take advantage of our resort-style pool and recreational lounge. Choose Fitzroy Grove and relish a balanced lifestyle of leisure and pet-friendly amenities in the beautiful city of Rogers, AR.",
      "featured_image": null,
      "featured_image_media": null,
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Dog Friendly Apartments with Park in Rogers",
      "seo_description": "Live at Fitzroy Grove, dog-friendly with a nearby park in Rogers, AR. Luxury living for you and your pet.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167553",
      "source": "generator",
      "page_item_url": "studio-apartments-rogers-ar-fitzroy-grove",
      "search_query": "studio apartments rogers ar",
      "category": "Floorplan",
      "h1_title": "Studio Apartments in Rogers, AR",
      "h2_subtitle": "Discover modern studio apartments at Fitzroy Grove, located in the heart of Rogers, AR. Perfect for a streamlined lifestyle.",
      "page_copy": "Welcome to Fitzroy Grove, where modern studio living in Rogers, AR offers both style and convenience. Our studio apartments are thoughtfully designed to maximize space, providing you with an open and airy environment perfect for any lifestyle. Enjoy the elegance of designer tile backsplashes and soaring ceilings ranging from 9ft to 14ft in our inviting studio units.\n\nSituated in the vibrant city of Rogers, Fitzroy Grove studio apartments offer more than just a place to live—they provide a community with upscale amenities like our resort-style pool and a vibrant recreational lounge. Whether you're lounging by the poolside or relishing the comfort of your spacious interiors, you'll find that our studio apartments cater to all your needs for modern, minimalist living.",
      "featured_image": null,
      "featured_image_media": null,
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Studio Apartments in Rogers, AR",
      "seo_description": "Explore studio apartments at Fitzroy Grove in Rogers, AR. Enjoy modern living with resort-style amenities.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167553",
      "source": "generator",
      "page_item_url": "one-bedroom-apartments-benton-county-fitzroy-grove",
      "search_query": "one bedroom apartments benton county",
      "category": "Floorplan",
      "h1_title": "One Bedroom Apartments in Benton County",
      "h2_subtitle": "Fitzroy Grove offers one bedroom apartments in Benton County, perfect for those seeking comfort and style in a prime location.",
      "page_copy": "Discover the perfect home at Fitzroy Grove, offering stylish one bedroom apartments in the heart of Benton County. Our apartments are meticulously designed to blend comfort with modern living, featuring expansive ceilings from 9ft to 14ft, chic designer tile backsplashes, and efficient ceiling fans to enhance your living experience.\n\nNestled in the charming city of Rogers, AR, Fitzroy Grove combines convenience with luxury. Residents can enjoy an array of community amenities such as a resort-style pool perfect for relaxation and a recreational lounge ideal for unwinding. Whether you're enjoying the privacy of your one bedroom haven or the vibrant community spaces, Fitzroy Grove offers a fulfilling lifestyle in Benton County.",
      "featured_image": null,
      "featured_image_media": null,
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "One Bedroom Apartments in Benton County",
      "seo_description": "Explore one bedroom apartments at Fitzroy Grove in Benton County. Modern designs with luxury amenities in Rogers.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167553",
      "source": "generator",
      "page_item_url": "two-bedroom-apartments-near-72758-fitzroy-grove",
      "search_query": "two bedroom apartments near 72758",
      "category": "Floorplan",
      "h1_title": "Two Bedroom Apartments Near 72758",
      "h2_subtitle": "Fitzroy Grove offers spacious two bedroom apartments near the 72758 zip code, perfect for comfortable and modern living.",
      "page_copy": "Situated near the bustling 72758 area, Fitzroy Grove presents the ideal solution for those seeking spacious two bedroom apartments. Designed with both functionality and style in mind, our residences feature high ceilings ranging from 9ft to 14ft, providing an expansive feel. Enjoy the touch of luxury with our designer tile backsplashes and enjoy the comfort of ceiling fans in every room.\n\nLocated in the vibrant city of Rogers, AR, our community not only offers exceptional living spaces but also a host of amenities that cater to an active lifestyle. Dive into relaxation at our resort-style pool or spend leisurely afternoons at the recreational lounge. With Fitzroy Grove, enjoy the conveniences and comforts of home while being close to all that the 72758 area has to offer.",
      "featured_image": null,
      "featured_image_media": null,
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Two Bedroom Apartments Near 72758",
      "seo_description": "Find spacious two bedroom apartments at Fitzroy Grove near the 72758 area, with premium amenities and modern design.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167553",
      "source": "generator",
      "page_item_url": "three-bedroom-apartments-rogers-fitzroy-grove",
      "search_query": "three bedroom apartments rogers",
      "category": "Floorplan",
      "h1_title": "Three Bedroom Apartments in Rogers",
      "h2_subtitle": "Explore spacious three bedroom apartments in Rogers at Fitzroy Grove, ideal for families or roommates seeking a modern space.",
      "page_copy": "Welcome to Fitzroy Grove, where our three bedroom apartments redefine spacious living in Rogers. Perfect for families or roommates, each unit is thoughtfully designed with high ceilings ranging from 9ft to 14ft and adorned with designer tile backsplashes. Our interiors seamlessly merge functionality with style, offering ample space to comfortably accommodate your lifestyle.\n\nLocated in the heart of Rogers, AR, our community provides not just a place to live but a place to thrive. Relax in our resort-style pool or enjoy leisure time in our inviting recreational lounge. With these shared amenities, Fitzroy Grove ensures that every moment at home is both enjoyable and convenient, making our three bedroom apartments an ideal choice for those looking to settle in Rogers.",
      "featured_image": null,
      "featured_image_media": null,
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Three Bedroom Apartments in Rogers",
      "seo_description": "Discover three bedroom apartments at Fitzroy Grove in Rogers, AR. Spacious family-friendly homes with luxury amenities.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167553",
      "source": "generator",
      "page_item_url": "apartments-near-nwacc-benton-county-fitzroy-grove",
      "search_query": "apartments near Northwest Arkansas Community College Benton County",
      "category": "School",
      "h1_title": "Apartments Near NWACC in Benton County",
      "h2_subtitle": "Discover convenience at Fitzroy Grove with our apartments located near Northwest Arkansas Community College in Benton County.",
      "page_copy": "Fitzroy Grove offers the perfect location for students and faculty seeking apartments near Northwest Arkansas Community College in Benton County. Our community provides an ideal blend of convenience and comfort, featuring spacious units with ceilings reaching up to 14ft and stylish designer tile backsplashes that elevate modern living.\n\nSituated in Rogers, AR, our vibrant community is just a short drive from NWACC, making it perfect for those affiliated with the college. Residents can enjoy luxurious amenities such as a resort-style pool for relaxation and a recreational lounge for casual meetups and study sessions. At Fitzroy Grove, you’ll find a supportive and dynamic environment tailored to your academic and professional needs.",
      "featured_image": null,
      "featured_image_media": null,
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Apartments Near NWACC in Benton County",
      "seo_description": "Find ideal living at Fitzroy Grove, featuring apartments near Northwest Arkansas Community College, with top amenities in Benton County.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167553",
      "source": "generator",
      "page_item_url": "apartments-near-mt-hebron-park-rogers-fitzroy-grove",
      "search_query": "apartments near mt hebron park rogers",
      "category": "Park",
      "h1_title": "Apartments Near Mt Hebron Park, Rogers",
      "h2_subtitle": "Find the perfect home at Fitzroy Grove, offering beautiful apartments just moments from Mt Hebron Park in Rogers.",
      "page_copy": "Located near the scenic Mt Hebron Park in Rogers, Fitzroy Grove offers a tranquil living experience with access to outdoor beauty and modern conveniences. Our apartments are designed with elegance and comfort in mind, featuring high ceilings up to 14ft and elegant designer tile backsplashes. Whether you are enjoying a quiet evening or entertaining guests, our spaces provide a perfect backdrop.\n\nIn addition to our prime location near Mt Hebron Park, residents of Fitzroy Grove can enjoy a wealth of community amenities. Lounge by our resort-style pool or spend quality time with friends at the recreational lounge. Our community not only places you close to nature but also offers you the lifestyle you have been searching for in Rogers, AR.",
      "featured_image": null,
      "featured_image_media": null,
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Apartments Near Mt Hebron Park, Rogers",
      "seo_description": "Live near the beauty of Mt Hebron Park in Rogers, AR, at Fitzroy Grove, where comfort meets style with premium amenities.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167553",
      "source": "generator",
      "page_item_url": "rogers-apartments-close-to-osage-park-fitzroy-grove",
      "search_query": "rogers apartments close to osage park",
      "category": "Park",
      "h1_title": "Rogers Apartments Close to Osage Park",
      "h2_subtitle": "Experience premium living at Fitzroy Grove, conveniently situated near Osage Park in Rogers, AR.",
      "page_copy": "Discover Fitzroy Grove, where contemporary design meets the convenience of being close to Osage Park, one of Rogers' most cherished green spaces. Our apartments offer spacious interiors with ceilings soaring up to 14ft, complemented by designer tile backsplashes, creating a refined atmosphere perfect for relaxation or entertaining.\n\nLiving at Fitzroy Grove means enjoying easy access to Osage Park, known for its beautiful trails and recreational activities. Our community also offers residents luxurious on-site amenities such as a resort-style pool and a recreational lounge, ensuring your leisure time is spent enjoying the best life has to offer. Experience the seamless blend of comfort and proximity at Fitzroy Grove in Rogers, AR, where every day can be an adventure.",
      "featured_image": null,
      "featured_image_media": null,
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Rogers Apartments Close to Osage Park",
      "seo_description": "Enjoy Fitzroy Grove's luxury living and proximity to Osage Park in Rogers, AR, with high-end amenities and spacious comfort.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167553",
      "source": "generator",
      "page_item_url": "lake-atalanta-park-rogers-area-apartments-fitzroy-grove",
      "search_query": "lake atalanta park rogers area apartments",
      "category": "Park",
      "h1_title": "Rogers Apartments Near Lake Atalanta Park",
      "h2_subtitle": "Immerse yourself in natural beauty at Fitzroy Grove, located conveniently near Lake Atalanta Park in Rogers.",
      "page_copy": "At Fitzroy Grove, embrace a serene lifestyle with easy access to Lake Atalanta Park's breathtaking trails and lush landscapes. Our Rogers area apartments offer both the tranquility of nature and the convenience of urban living. Each unit is thoughtfully designed, featuring expansive ceilings and designer tile backsplashes to inspire comfort and sophistication.\n\nResidents of Fitzroy Grove benefit from the close proximity to Lake Atalanta Park while enjoying premium amenities like a resort-style pool and a recreational lounge. These features make Fitzroy Grove an exceptional choice for those wanting the perfect blend of outdoor adventures and home luxury. Discover why our community is the ideal place to call home in the Rogers area today.",
      "featured_image": null,
      "featured_image_media": null,
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Rogers Apartments Near Lake Atalanta Park",
      "seo_description": "Live near Lake Atalanta Park at Fitzroy Grove in Rogers, AR, and enjoy modern amenities in a serene, nature-filled setting.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167553",
      "source": "generator",
      "page_item_url": "memorial-park-accessibility-from-fitzroy-grove-rogers",
      "search_query": "memorial park accessibility from fitzroy grove rogers",
      "category": "Park",
      "h1_title": "Access Memorial Park from Fitzroy Grove",
      "h2_subtitle": "Enjoy easy access to Memorial Park from Fitzroy Grove, right in the heart of Rogers, Arkansas.",
      "page_copy": "Fitzroy Grove offers the perfect balance of vibrant city life and peaceful natural surroundings, with the added benefit of being conveniently located near Memorial Park. Residents can easily enjoy the park's scenic beauty and facilities without straying far from home. Our community not only boasts a prime location but also features amenities like a resort-style pool and a recreational lounge for fitness enthusiasts and relaxation seekers alike.\n\nInside each Fitzroy Grove apartment, you'll find modern conveniences designed for comfort and style, such as high ceilings and elegant tile backsplashes. Whether you prefer a stroll through Memorial Park or lounging by our pool, Fitzroy Grove positions you ideally to take advantage of both outdoor adventures and indoor luxuries in Rogers.",
      "featured_image": null,
      "featured_image_media": null,
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Access Memorial Park from Fitzroy Grove",
      "seo_description": "Fitzroy Grove provides convenient access to Memorial Park in Rogers, AR. Enjoy modern amenities and a prime location.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167553",
      "source": "generator",
      "page_item_url": "fitzroy-grove-rogers-living-near-creekside-park",
      "search_query": "fitzroy grove rogers living near creekside park",
      "category": "Park",
      "h1_title": "Fitzroy Grove: Living Near Creekside Park",
      "h2_subtitle": "Experience the charm of Rogers living at Fitzroy Grove, located conveniently near Creekside Park.",
      "page_copy": "Fitzroy Grove is the perfect destination for those seeking a harmonious blend of nature and modern comfort. Nestled near Creekside Park in Rogers, our community offers residents a unique living experience, combining accessibility with tranquility. Each apartment is thoughtfully designed, featuring high ceilings and designer tile backsplashes that add an element of sophistication to your home.\n\nLiving near Creekside Park provides unparalleled opportunities for outdoor enjoyment, from leisurely walks to exciting recreational activities. Fitzroy Grove complements this active lifestyle with desirable on-site amenities such as a resort-style pool and a spacious recreational lounge. Whether you're exploring the park or relaxing at home, Fitzroy Grove delivers a premier living experience in the heart of Rogers.",
      "featured_image": null,
      "featured_image_media": null,
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Fitzroy Grove: Living Near Creekside Park",
      "seo_description": "Discover Fitzroy Grove in Rogers, AR, offering modern living near Creekside Park. Experience nature and luxury combined.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    }
  ],
  "custom_fields": [
    {
      "ID": "custom_pixel_id",
      "type": "STRING",
      "value": "1035508496598043"
    },
    {
      "ID": "custom_repli_id",
      "type": "STRING",
      "value": "12457359919"
    },
    {
      "ID": "custom_rollout_phase",
      "type": "STRING",
      "value": "ACQ"
    },
    {
      "ID": "custom_vibesites_theme",
      "type": "STRING",
      "value": "Blue Haven"
    },
    {
      "ID": "custom_hubspot_company_id",
      "type": "STRING",
      "value": "56463087370"
    }
  ],
  "custom_pixel_id": "1035508496598043",
  "custom_repli_id": "12457359919",
  "custom_rollout_phase": "ACQ",
  "custom_vibesites_theme": "Blue Haven",
  "custom_hubspot_company_id": "56463087370",
  "custom_audioeye_site_id": "2b59b511-47e0-41fc-9b3c-ee5489d9a245",
  "custom_audioeye_site_hash": "d8f7d93bf0360f030584faa1d2f1126a"
};

export const generatedAt = '2026-08-26T18:20:34.774Z';
